import React, { useState, useEffect, createContext, useContext, useRef, useMemo } from 'react';
import { BrowserRouter, Routes, Route, Link, useParams, Navigate, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { WalletProvider, useWallet } from './WalletContext';
import ContentRequestPage from './ContentRequestPage';
import { PremiumRoute } from './PremiumRoute';
import { QuickCategories, ReadNext } from './components/NavigationAddons';
import { LoginRoute } from './LoginRoute';
import SitemapPage from './SitemapPage';
import DharmaSastramPage from './DharmaSastramPage';
import PartnerRegistrationPage from './PartnerRegistrationPage';
import CustomerRequestPage from './CustomerRequestPage';
import ShradhdhaServicePage from './ShradhdhaServicePage';
import QAPage from './QAPage';
import { InstagramBioPage } from './pages/InstagramBioPage';
import FloatingChat from './components/FloatingChat';
import axios from 'axios';
import './App.css';
import './theme.css';
import { EditModeProvider, useEditMode } from './EditModeContext';

import VaideekaBasicsPage from './vaideekam/pages/VaideekaBasicsPage';
import SthothramsPage from './vaideekam/pages/SthothramsPage';
import ModelInvitationsPage from './vaideekam/pages/ModelInvitationsPage';
import ShradhdhamPage from './vaideekam/pages/ShradhdhamPage';
import SelfPreparePage from './vaideekam/pages/SelfPreparePage';
import PraathasandhiPage from './vaideekam/pages/PraathasandhiPage';
import BrahmayajgnamPage from './vaideekam/pages/BrahmayajgnamPage';
import SamidhadhanamPage from './vaideekam/pages/SamidhadhanamPage';
import AgnisanthanamPage from './vaideekam/pages/AgnisanthanamPage';
import AupaasanamPage from './vaideekam/pages/AupaasanamPage';
import UpakarmaPage from './vaideekam/pages/UpakarmaPage';
import GayathrijapamPage from './vaideekam/pages/GayathrijapamPage';
import AanmikamPage from './vaideekam/pages/AanmikamPage';
import DivyadesamPage from './vaideekam/pages/DivyadesamPage';
import DharmakandamPage from './vaideekam/pages/DharmakandamPage';
import AhnigamPage from './vaideekam/pages/AhnigamPage';
import AsouchamPage from './vaideekam/pages/AsouchamPage';
import ShradhakandamPage from './vaideekam/pages/ShradhakandamPage';
import PoorvamPage from './vaideekam/pages/PoorvamPage';
import AksharaabhyaasamPage from './vaideekam/pages/AksharaabhyaasamPage';
import AaseervadhamPage from './vaideekam/pages/AaseervadhamPage';
import AnkuramPage from './vaideekam/pages/AnkuramPage';
import AnnapraasanamPage from './vaideekam/pages/AnnapraasanamPage';
import AshtavradhamPage from './vaideekam/pages/AshtavradhamPage';
import BeejaDhanamPage from './vaideekam/pages/BeejaDhanamPage';
import GrihapravesamPage from './vaideekam/pages/GrihapravesamPage';
import JaadhakarmaPage from './vaideekam/pages/JaadhakarmaPage';
import KaaladhikramamPage from './vaideekam/pages/KaaladhikramamPage';
import ManaiMuhurthamPage from './vaideekam/pages/ManaiMuhurthamPage';
import NaamakaranamPage from './vaideekam/pages/NaamakaranamPage';
import NaandhiPage from './vaideekam/pages/NaandhiPage';
import NischayadhaarthamPage from './vaideekam/pages/NischayadhaarthamPage';
import PandalkaalPage from './vaideekam/pages/PandalkaalPage';
import PrashavaPunyaahamPage from './vaideekam/pages/PrashavaPunyaahamPage';
import PrathisaramPage from './vaideekam/pages/PrathisaramPage';
import PumsavanamPage from './vaideekam/pages/PumsavanamPage';
import SeemanthamPage from './vaideekam/pages/SeemanthamPage';
import UdakasaandhiPage from './vaideekam/pages/UdakasaandhiPage';
import UpanayanamPage from './vaideekam/pages/UpanayanamPage';
import VadhuGrihapravesamPage from './vaideekam/pages/VadhuGrihapravesamPage';
import VivaahamPage from './vaideekam/pages/VivaahamPage';
import YaathraaDhaanamPage from './vaideekam/pages/YaathraaDhaanamPage';
import AparamPage from './vaideekam/pages/AparamPage';
import YajurShradhdhamPage from './vaideekam/pages/YajurShradhdhamPage';
import YajurTarpanamPage from './vaideekam/pages/YajurTarpanamPage';

import { AdminDashboard, ManagePosts, PostEditor, ModerateComments, BackupSystem, ManageUsers, ManagePages, PageEditor } from './AdminDashboard';
import AdminPanel from './AdminPanel';
import ShopPage from './ShopPage';
import { ForumPage } from './pages/ForumPage';
import CartPage from './CartPage';
import CheckoutPage from './CheckoutPage';
import DonatePage from './DonatePage';
import MarriageGarlandPage from './MarriageGarlandPage';
import PracheenaQAPage from './PracheenaQAPage';

import RigUpakarmaPage from './pages/RigUpakarmaPage';
import YajurUpakarmaPage from './pages/YajurUpakarmaPage';
import SamaUpakarmaPage from './pages/SamaUpakarmaPage';
import BodhayanaUpakarmaPage from './pages/BodhayanaUpakarmaPage';
import GayathriJapamPage from './pages/GayathriJapamPage';
import SathyaNarayanaPooja from './pages/SathyaNarayanaPooja';
import PrayogamsPage from './pages/PrayogamsPage';
import KarmangalinThathuvangalPage from './pages/KarmangalinThathuvangalPage';
import ShastraLibraryPage from './pages/ShastraLibraryPage';
import ShastraTopicDetailPage from './pages/ShastraTopicDetailPage';


import ArchanaiPage from './ArchanaiPage';
import UserProfilePage from './UserProfilePage';
import ContactPage from './ContactPage';
import TermsPage from './TermsPage';
import CustomPage from './CustomPage';
import VaideekaDictionaryPopup from './components/VaideekaDictionaryPopup';
import SearchModal from './components/SearchModal';
// PanchangamWrapper removed â€” was iframe-based, no longer needed
// PanchangamEmbed removed â€” was iframe-based, no longer needed
import WebPremiumStorePage from './WebPremiumStorePage';
import PremiumSuccessPage from './PremiumSuccessPage';
import { MonetizationProvider } from './panchangam/services/monetization';
import CalendarPage from './panchangam/pages/CalendarPage';
import GenSankalpamPage from './panchangam/pages/GenSankalpamPage';
import NazhiConvertPage from './panchangam/pages/NazhiConvertPage';
import AllAboutStarsPage from './panchangam/pages/AllAboutStarsPage';
import PartsOfPanchangamPage from './panchangam/pages/PartsOfPanchangamPage';
import NavagrahasPage from './panchangam/pages/NavagrahasPage';
import TheetuPage from './panchangam/pages/TheetuPage';
import GenTheetuPage from './panchangam/pages/GenTheetuPage';
import MaranaTheetuPage from './panchangam/pages/MaranaTheetuPage';
import DayDhoshaPage from './panchangam/pages/DayDhoshaPage';
import VivasayamPage from './panchangam/pages/VivasayamPage';
import MatchingPage from './panchangam/pages/MatchingPage';
import AboutPage from './panchangam/pages/AboutPage';
import AllMuhurthamsPage from './panchangam/pages/AllMuhurthamsPage';
import BestForEventsPage from './panchangam/pages/BestForEventsPage';
import CastingPage from './panchangam/pages/CastingPage';
import CurrentYearPage from './panchangam/pages/CurrentYearPage';
import DasaBukthiPage from './panchangam/pages/DasaBukthiPage';
import DayValuePage from './panchangam/pages/DayValuePage';
import DayValuePremiumPage from './panchangam/pages/DayValuePremiumPage';
import DhinaPoruthamPage from './panchangam/pages/DhinaPoruthamPage';
import DiaryPage from './panchangam/pages/DiaryPage';
import FaqKnowledgeBasePage from './panchangam/pages/FaqKnowledgeBasePage';
import FeedbackPage from './panchangam/pages/FeedbackPage';
import FullOonamListPage from './panchangam/pages/FullOonamListPage';
import GoodDaysPage from './panchangam/pages/GoodDaysPage';
import GowriPanchangamPage from './panchangam/pages/GowriPanchangamPage';
import HomePage from './panchangam/pages/HomePage';
import HoraiPage from './panchangam/pages/HoraiPage';
import LagnasPage from './panchangam/pages/LagnasPage';
import LocalCalendarPage from './panchangam/pages/LocalCalendarPage';
import MonthlyPage from './panchangam/pages/MonthlyPage';
import MonthViewPage from './panchangam/pages/MonthViewPage';
import MuhurthamsPage from './panchangam/pages/MuhurthamsPage';
import MyMuhurthamsPage from './panchangam/pages/MyMuhurthamsPage';
import NumerologyPage from './panchangam/pages/NumerologyPage';
import OonamsPage from './panchangam/pages/OonamsPage';
import PanchangamNextPage from './panchangam/pages/PanchangamNextPage';
import PanchangamPage from './panchangam/pages/PanchangamPage';
import PlaceholderPage from './panchangam/pages/PlaceholderPage';
import PremiumCalendarPage from './panchangam/pages/PremiumCalendarPage';
import PremiumStorePage from './panchangam/pages/PremiumStorePage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import UserDeletionPage from './UserDeletionPage';
import SankalpamPage from './panchangam/pages/SankalpamPage';
import SearchPage from './panchangam/pages/SearchPage';
import ShraaddhaThithiPage from './panchangam/pages/ShraaddhaThithiPage';
import ShraaddhaThithiMakerPage from './panchangam/pages/ShraaddhaThithiMakerPage';
import StaticDataPage from './panchangam/pages/StaticDataPage';
import ThithiNirnayaRulesPage from './panchangam/pages/ThithiNirnayaRulesPage';
import SEO from './SEO';
import SocialShare from './SocialShare';
import FloatingShare from './FloatingShare';
import DynamicHomePage from './components/DynamicHomePage';
import VaidhikaServicesPage from './VaidhikaServicesPage';
import DivyaprabandhamPage from './panchangam/pages/DivyaprabandhamPage';
import DivyadesamsDetailPage from './panchangam/pages/DivyadesamsDetailPage';


const getBackendUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
};

const BACKEND_URL = getBackendUrl();
// Ensure /api suffix is present
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

// Utility: Clean WordPress Gutenberg block comments and shortcodes from HTML content
const cleanWordPressContent = (html) => {
  if (!html) return '';
  return html
    // Remove WordPress Gutenberg block comments: <!-- wp:xxx --> and <!-- /wp:xxx -->
    .replace(/<!--\s*\/?wp:[^>]*-->/gi, '')
    // Remove WordPress shortcodes: [su_xxx], [/su_xxx], [caption], [gallery], etc.
    .replace(/\[\/?(?:su_[a-zA-Z0-9_]+|caption|gallery|audio|video|embed|vc_[a-zA-Z0-9_]+)[^\]]*\]/gi, '')
    // Clean up excessive blank lines left after removing comments
    .replace(/(\n\s*){3,}/g, '\n\n')
    .trim();
};

// Utility: Deduplicate blog posts by wp_id (keeps first occurrence)
const deduplicatePosts = (posts) => {
  const seen = new Set();
  return posts.filter(post => {
    const key = post.wp_id || post.slug || post.id;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// Wrapper to pass user to AdminPanel
const AdminPanelWrapper = () => {
  const { user, language } = useAuth();
  return <AdminPanel user={user} language={language} />;
};

// Rich Text Editor Component
const RichTextEditor = ({ value, onChange, placeholder, height = '200px' }) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && !quillRef.current && window.Quill) {
      const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'header': [1, 2, 3, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link', 'image'],
        ['clean']
      ];

      quillRef.current = new window.Quill(editorRef.current, {
        theme: 'snow',
        modules: { toolbar: toolbarOptions },
        placeholder: placeholder || 'Write something...'
      });

      // Set initial value
      if (value) {
        quillRef.current.root.innerHTML = value;
      }

      // Listen for changes
      quillRef.current.on('text-change', () => {
        if (onChange) {
          onChange(quillRef.current.root.innerHTML);
        }
      });
    }
  }, []);

  // Update content when value prop changes externally
  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value || '';
    }
  }, [value]);

  return <div ref={editorRef} style={{ height, background: 'white' }} />;
};

// Auth Context
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const [sessionMessage, setSessionMessage] = useState(null);

  // Helper: decode JWT and check expiry (without external library)
  const isTokenExpired = (tok) => {
    try {
      const payload = JSON.parse(atob(tok.split('.')[1]));
      return payload.exp * 1000 < Date.now();
    } catch { return true; }
  };

  // Auto-logout helper with message
  const sessionExpiredLogout = (msg) => {
    console.warn('â° Session expired:', msg);
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    setSessionMessage(msg || 'Your session has expired. Please log in again.');
  };

  // Axios 401 interceptor â€” auto logout on any unauthorized API response
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401 && token) {
          sessionExpiredLogout('Your login session has expired. Please log in again to continue.');
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, [token]);

  useEffect(() => {
    // Check token expiry on app load
    if (token && isTokenExpired(token)) {
      sessionExpiredLogout('Your session has expired. Please log in again.');
      return;
    }

    // Try to load user from localStorage first
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        console.log('âœ… User loaded from localStorage:', parsedUser.email, 'Role:', parsedUser.role);
      } catch (e) {
        console.error('Error parsing stored user:', e);
      }
    }

    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      // Only fetch user from API if not already loaded from localStorage
      if (!storedUser) {
        fetchUser();
      }
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
      console.log('âœ… User fetched:', response.data);
    } catch (error) {
      console.error('âŒ Error fetching user:', error);
      logout();
    }
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      setToken(response.data.access_token);
      setUser(response.data.user);
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
      return response.data.user;
    } catch (error) {
      const detail = error.response?.data?.detail;
      if (error.response && error.response.status === 401) {
        throw new Error(detail || 'Invalid email or password');
      } else {
        console.error('Login error:', error);
        throw new Error(detail || 'An error occurred during login');
      }
    }
  };

  const register = async (email, password, name) => {
    try {
      const response = await axios.post(`${API}/auth/register`, { email, password, name });
      setToken(response.data.access_token);
      setUser(response.data.user);
      localStorage.setItem('token', response.data.access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
    } catch (error) {
      console.error('Registration error:', error);
      const detail = error.response?.data?.detail;
      if (typeof detail === 'string') {
        throw new Error(detail);
      } else if (Array.isArray(detail) && detail.length > 0) {
        throw new Error(detail[0].msg || 'Registration failed');
      } else {
        throw new Error('Registration failed. Please check your network connection.');
      }
    }
  };

  const googleLogin = async (credential) => {
    const response = await axios.post(`${API}/auth/google`, { credential });
    setToken(response.data.access_token);
    setUser(response.data.user);
    localStorage.setItem('token', response.data.access_token);
    localStorage.setItem('user', JSON.stringify(response.data.user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
  };

  const facebookLogin = async (accessToken) => {
    const response = await axios.post(`${API}/auth/facebook`, { accessToken });
    setToken(response.data.access_token);
    setUser(response.data.user);
    localStorage.setItem('token', response.data.access_token);
    localStorage.setItem('user', JSON.stringify(response.data.user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
  };

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ta' : 'en';
    setLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  // Clear session message after 5 seconds
  useEffect(() => {
    if (sessionMessage) {
      const timer = setTimeout(() => setSessionMessage(null), 8000);
      return () => clearTimeout(timer);
    }
  }, [sessionMessage]);

  return (
    <AuthContext.Provider value={{ user, login, register, googleLogin, facebookLogin, logout, language, toggleLanguage, fetchUser, sessionMessage, setSessionMessage, token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

// Theme Switcher Component
const ThemeSwitcher = () => {
  const { theme, switchTheme } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  const themeOptions = [
    { value: 'default', label: 'ðŸŸ¢ Green/Orange', emoji: 'ðŸŸ¢' },
    { value: 'blue', label: 'ðŸ”µ Blue/Indigo', emoji: 'ðŸ”µ' },
    { value: 'purple', label: 'ðŸŸ£ Purple/Pink', emoji: 'ðŸŸ£' }
  ];

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="px-3 py-1 bg-green-800 hover:bg-green-900 rounded-md text-sm font-medium transition-colors flex items-center space-x-1"
      >
        <span>ðŸŽ¨</span>
        <span>Theme</span>
      </button>
      {showMenu && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl z-50 py-2">
          {themeOptions.map(option => (
            <button
              key={option.value}
              onClick={() => {
                switchTheme(option.value);
                setShowMenu(false);
              }}
              className={`w-full text-left px-4 py-2 hover:bg-gray-100 transition ${theme === option.value ? 'bg-green-50 font-semibold' : ''
                }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const MENU_ITEMS = [
  {
    "id": "home",
    "label_en": "Home",
    "label_ta": "à®®à¯à®•à®ªà¯à®ªà¯",
    "slug": "/",
    "subMenus": [
      {
        "id": "home-quick",
        "label_en": "Quick Access",
        "label_ta": "à®µà®¿à®°à¯ˆà®µà¯ à®µà®´à®¿",
        "slug": "/",
        "pages": [
          {
            "slug": "/",
            "label_en": "Home Page",
            "label_ta": "à®®à¯à®•à®ªà¯à®ªà¯ à®ªà®•à¯à®•à®®à¯"
          },
          {
            "slug": "/Sri_Paranthaman_Panchangam_Interactive_Browser.html",
            "label_en": "ðŸŒŸ Sri Paranthaman Panchangam",
            "label_ta": "ðŸŒŸ à®¸à¯à®°à¯€ à®ªà®°à®¨à¯à®¤à®¾à®®à®©à¯ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯ (à®¨à¯‡à®°à®Ÿà®¿ à®ªà®¾à®°à¯à®µà¯ˆ)"
          },
          {
            "slug": "/Events-And-Shastra-Rules/",
            "label_en": "ðŸ“œ 6,500+ Shastra Decision Rules",
            "label_ta": "ðŸ“œ à®ªà®žà¯à®šà®¾à®™à¯à®• à®šà®¾à®¸à¯à®¤à®¿à®° à®®à¯à®Ÿà®¿à®µà¯†à®Ÿà¯à®•à¯à®•à¯à®®à¯ à®µà®¿à®¤à®¿à®•à®³à¯"
          },
          {
            "slug": "/panchangam/about",
            "label_en": "About Ahobilam",
            "label_ta": "à®…à®±à®¿à®®à¯à®•à®®à¯"
          },
          {
            "slug": "/contact",
            "label_en": "Contact Us",
            "label_ta": "à®¤à¯Šà®Ÿà®°à¯à®ªà¯ à®•à¯Šà®³à¯à®³"
          },
          {
            "slug": "/sitemap",
            "label_en": "Site Map",
            "label_ta": "à®¤à®³ à®µà®°à¯ˆà®ªà®Ÿà®®à¯"
          },
          {
            "slug": "/privacy-policy",
            "label_en": "Privacy Policy",
            "label_ta": "à®¤à®©à®¿à®¯à¯à®°à®¿à®®à¯ˆà®•à¯ à®•à¯Šà®³à¯à®•à¯ˆ"
          }
        ]
      }
    ]
  },
  {
    "id": "anmikam",
    "label_en": "Anmikam",
    "label_ta": "à®†à®©à¯à®®à®¿à®•à®®à¯",
    "slug": "/divyadesams",
    "subMenus": [
      {
        "id": "divyadesams",
        "label_en": "Divya Desams",
        "label_ta": "à®¤à®¿à®µà¯à®¯à®¤à¯‡à®šà®™à¯à®•à®³à¯",
        "slug": "/divyadesams",
        "pages": [
          {
            "slug": "/divyadesams",
            "label_en": "108 Divya Desams",
            "label_ta": "108 à®¤à®¿à®µà¯à®¯à®¤à¯‡à®šà®™à¯à®•à®³à¯"
          },
          {
            "slug": "/divyadesa-namavali",
            "label_en": "Divyadesa Namavali",
            "label_ta": "à®¤à®¿à®µà¯à®¯ à®¤à¯‡à®š à®¨à®¾à®®à®¾à®µà®³à®¿"
          },
          {
            "slug": "/vaideekam/divyadesam",
            "label_en": "Divyadesam Guide",
            "label_ta": "à®¤à®¿à®µà¯à®¯à®¤à¯‡à®š à®µà®´à®¿à®•à®¾à®Ÿà¯à®Ÿà®¿"
          }
        ]
      },
      {
        "id": "stothras",
        "label_en": "Stotras & Prabandham",
        "label_ta": "à®¸à¯à®¤à¯‹à®¤à¯à®¤à®¿à®°à®™à¯à®•à®³à¯ & à®ªà®¿à®°à®ªà®¨à¯à®¤à®®à¯",
        "slug": "/anmikam/divyaprabandham",
        "pages": [
          {
            "slug": "/anmikam/divyaprabandham",
            "label_en": "Divya Prabandham",
            "label_ta": "à®¤à®¿à®µà¯à®¯ à®ªà®¿à®°à®ªà®¨à¯à®¤à®®à¯"
          },
          {
            "slug": "/sathya-narayana-pooja",
            "label_en": "Sathya Narayana Pooja",
            "label_ta": "à®šà®¤à¯à®¯ à®¨à®¾à®°à®¾à®¯à®£ à®ªà¯‚à®œà¯ˆ"
          },
          {
            "slug": "/vaideekam/sthothrams",
            "label_en": "Stothram Collection",
            "label_ta": "à®¸à¯à®¤à¯‹à®¤à¯à®¤à®¿à®°à®™à¯à®•à®³à¯ à®šà¯‡à®•à®°à®¿à®ªà¯à®ªà¯"
          }
        ]
      },
      {
        "id": "knowledge",
        "label_en": "Knowledge & Articles",
        "label_ta": "à®†à®©à¯à®®à®¿à®•à®•à¯ à®•à®Ÿà¯à®Ÿà¯à®°à¯ˆà®•à®³à¯",
        "slug": "/blog",
        "pages": [
          {
            "slug": "/blog",
            "label_en": "Anmikam Blog Articles",
            "label_ta": "à®†à®©à¯à®®à®¿à®•à®•à¯ à®•à®Ÿà¯à®Ÿà¯à®°à¯ˆà®•à®³à¯"
          },
          {
            "slug": "/qa",
            "label_en": "Q&A Forum",
            "label_ta": "à®•à¯‡à®³à¯à®µà®¿ - à®ªà®¤à®¿à®²à¯"
          },
          {
            "slug": "/pracheena-qa",
            "label_en": "Pracheena QA",
            "label_ta": "à®ªà¯à®°à®¾à®šà¯€à®© à®†à®šà®¾à®°à®®à¯"
          }
        ]
      }
    ]
  },
  {
    "id": "astro",
    "label_en": "Astro & Panchangam",
    "label_ta": "à®œà¯‹à®¤à®¿à®Ÿà®®à¯ & à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯",
    "slug": "/panchangam/panchangam",
    "subMenus": [
      {
        "id": "horoscope",
        "label_en": "Horoscope & Predictions",
        "label_ta": "à®œà®¾à®¤à®•à®®à¯ & à®•à®£à®¿à®¤à®®à¯",
        "slug": "/panchangam/casting",
        "pages": [
          {
            "slug": "/panchangam/casting",
            "label_en": "â­ Horoscope Casting",
            "label_ta": "â­ à®œà®¾à®¤à®•à®®à¯ à®•à®£à®¿à®¤à¯à®¤à®²à¯"
          },
          {
            "slug": "/panchangam/matching",
            "label_en": "â­ Horoscope Matching",
            "label_ta": "â­ à®œà®¾à®¤à®• à®ªà¯Šà®°à¯à®¤à¯à®¤à®®à¯"
          },
          {
            "slug": "/panchangam/dasabukthi",
            "label_en": "Predictions & Dasa Bukthi",
            "label_ta": "à®œà®¾à®¤à®• à®ªà®²à®©à¯à®•à®³à¯ & à®¤à®šà®¾ à®ªà¯à®•à¯à®¤à®¿"
          },
          {
            "slug": "/services",
            "label_en": "Astrology Services",
            "label_ta": "à®œà¯‹à®¤à®¿à®Ÿ à®šà¯‡à®µà¯ˆà®•à®³à¯"
          }
        ]
      },
      {
        "id": "panchangam-live",
        "label_en": "Live Panchangam & Rules",
        "label_ta": "à®‡à®©à¯à®±à¯ˆà®¯ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯ & à®µà®¿à®¤à®¿à®•à®³à¯",
        "slug": "/panchangam/panchangam",
        "pages": [
          {
            "slug": "/Sri_Paranthaman_Panchangam_Interactive_Browser.html",
            "label_en": "ðŸŒŸ Sri Paranthaman Panchangam Browser",
            "label_ta": "ðŸŒŸ à®¸à¯à®°à¯€ à®ªà®°à®¨à¯à®¤à®¾à®®à®©à¯ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯ (2 à®µà®°à¯à®Ÿ à®¨à¯‡à®°à®Ÿà®¿ à®ªà®¾à®°à¯à®µà¯ˆ)"
          },
          {
            "slug": "/Events-And-Shastra-Rules/",
            "label_en": "ðŸ“œ 6,500+ Shastra Decision Rules",
            "label_ta": "ðŸ“œ à®šà®¾à®¸à¯à®¤à®¿à®° à®µà®¿à®šà¯‡à®· à®®à¯à®Ÿà®¿à®µà¯†à®Ÿà¯à®•à¯à®•à¯à®®à¯ à®µà®¿à®¤à®¿à®•à®³à¯"
          },
          {
            "slug": "/panchangam/panchangam",
            "label_en": "Live Panchangam",
            "label_ta": "à®‡à®©à¯à®±à¯ˆà®¯ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯"
          },
          {
            "slug": "/panchangam/calendar",
            "label_en": "Calendar (24 yrs)",
            "label_ta": "à®•à®¾à®²à®£à¯à®Ÿà®°à¯ (24 à®†à®£à¯à®Ÿà¯à®•à®³à¯)"
          },
          {
            "slug": "/panchangam/month-view",
            "label_en": "Monthly View",
            "label_ta": "à®®à®¾à®¤ à®•à®¾à®Ÿà¯à®Ÿà®¿"
          },
          {
            "slug": "/panchangam/gowri-panchangam",
            "label_en": "Gowri Panchangam",
            "label_ta": "à®•à¯Œà®°à®¿ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯"
          },
          {
            "slug": "/panchangam/horai",
            "label_en": "Horai Timing",
            "label_ta": "à®¹à¯‹à®°à¯ˆ à®¨à¯‡à®°à®®à¯"
          },
          {
            "slug": "/panchangam/day-dhosha",
            "label_en": "Day Dhosha",
            "label_ta": "à®¨à®¾à®³à¯à®¤à¯‹à®·à®®à¯"
          }
        ]
      },
      {
        "id": "knowledge-base",
        "label_en": "Panchangam Knowledge Base",
        "label_ta": "à®ªà®žà¯à®šà®¾à®™à¯à®• à®ªà®¾à®•à®™à¯à®•à®³à¯",
        "slug": "/panchangam/parts-of-panchangam",
        "pages": [
          {
            "slug": "/panchangam/parts-of-panchangam",
            "label_en": "Parts of Panchangam",
            "label_ta": "à®ªà®žà¯à®šà®¾à®™à¯à®•à®¤à¯à®¤à®¿à®©à¯ à®ªà®¾à®•à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/panchangam/allaboutstars",
            "label_en": "All About Stars",
            "label_ta": "à®¨à®Ÿà¯à®šà®¤à¯à®¤à®¿à®°à®™à¯à®•à®³à¯ˆà®ªà¯ à®ªà®±à¯à®±à®¿"
          },
          {
            "slug": "/panchangam/navagrahas",
            "label_en": "Navagrahas",
            "label_ta": "à®¨à®µà®•à¯à®•à®¿à®°à®•à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/panchangam/lagnas",
            "label_en": "Lagnas",
            "label_ta": "à®²à®•à¯à®©à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/panchangam/numerology",
            "label_en": "Numerology",
            "label_ta": "à®Žà®£à¯ à®•à®£à®¿à®¤à®®à¯"
          }
        ]
      },
      {
        "id": "muhurthams",
        "label_en": "Muhurthams & Good Days",
        "label_ta": "à®®à¯à®•à¯‚à®°à¯à®¤à¯à®¤à®™à¯à®•à®³à¯",
        "slug": "/panchangam/good-days",
        "pages": [
          {
            "slug": "/panchangam/good-days",
            "label_en": "Good Muhurtha Days",
            "label_ta": "30 à®šà¯à®ª à®®à¯à®•à¯‚à®°à¯à®¤à¯à®¤à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/panchangam/my-muhurthams",
            "label_en": "My Muhurthams",
            "label_ta": "à®Žà®©à¯ à®®à¯à®•à¯‚à®°à¯à®¤à¯à®¤à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/panchangam/all-muhurthams",
            "label_en": "All Muhurthams",
            "label_ta": "à®…à®©à¯ˆà®¤à¯à®¤à¯ à®®à¯à®•à¯‚à®°à¯à®¤à¯à®¤à®™à¯à®•à®³à¯"
          }
        ]
      }
    ]
  },
  {
    "id": "vaidhikam",
    "label_en": "Vaidhikam & Sastram",
    "label_ta": "à®µà¯ˆà®¤à¯€à®•à®®à¯ & à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯",
    "slug": "/vaideekam",
    "subMenus": [
      {
        "id": "prayogams",
        "label_en": "Prayogams & Basics",
        "label_ta": "à®ªà®¿à®°à®¯à¯‹à®•à®™à¯à®•à®³à¯ & à®…à®Ÿà®¿à®ªà¯à®ªà®Ÿà¯ˆ",
        "slug": "/vaidhikam/prayogams",
        "pages": [
          {
            "slug": "/vaidhikam/prayogams",
            "label_en": "ðŸ“œ Prayogams",
            "label_ta": "ðŸ“œ à®ªà®¿à®°à®¯à¯‹à®•à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/vaideekam/vaideeka-basics",
            "label_en": "Vaideeka Basics",
            "label_ta": "à®µà¯ˆà®¤à¯€à®• à®…à®Ÿà®¿à®ªà¯à®ªà®Ÿà¯ˆà®•à®³à¯"
          },
          {
            "slug": "/vaideekam/praathasandhi",
            "label_en": "Sandhyavandhanam",
            "label_ta": "à®¸à®¨à¯à®¤à®¿ 3 à®µà¯‡à®³à¯ˆ"
          },
          {
            "slug": "/vaideekam/brahmayajgnam",
            "label_en": "Brahmayajgnam",
            "label_ta": "à®ªà¯à®°à®¹à¯à®® à®¯à®œà¯à®žà®®à¯"
          },
          {
            "slug": "/vaideekam/samidhadhanam",
            "label_en": "Samidhadhanam",
            "label_ta": "à®¸à®®à®¿à®¤à®¾à®¤à®¾à®©à®®à¯"
          },
          {
            "slug": "/vaideekam/aupaasanam",
            "label_en": "Aupaasanam",
            "label_ta": "à®”à®ªà®¾à®¸à®©à®®à¯"
          }
        ]
      },
      {
        "id": "upakarma",
        "label_en": "Upakarma Rituals",
        "label_ta": "à®‰à®ªà®¾à®•à®°à¯à®®à®¾ à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯",
        "slug": "/vaideekam/upakarma",
        "pages": [
          {
            "slug": "/vaideekam/yajur-upakarma",
            "label_en": "Yajur Upakarma",
            "label_ta": "à®¯à®œà¯‚à®°à¯ à®‰à®ªà®¾à®•à®°à¯à®®à®¾"
          },
          {
            "slug": "/vaideekam/rig-upakarma",
            "label_en": "Rig Upakarma",
            "label_ta": "à®°à¯à®•à¯ à®‰à®ªà®¾à®•à®°à¯à®®à®¾"
          },
          {
            "slug": "/vaideekam/sama-upakarma",
            "label_en": "Sama Upakarma",
            "label_ta": "à®¸à®¾à®® à®‰à®ªà®¾à®•à®°à¯à®®à®¾"
          },
          {
            "slug": "/vaideekam/gayathrijapam",
            "label_en": "Gayathri Japam",
            "label_ta": "à®•à®¾à®¯à®¤à¯à®°à®¿ à®œà®ªà®®à¯"
          }
        ]
      },
      {
        "id": "poorvam",
        "label_en": "Poorvam Karmas (Subham)",
        "label_ta": "à®ªà¯‚à®°à¯à®µà®®à¯ à®•à®°à¯à®®à®¾à®•à¯à®•à®³à¯",
        "slug": "/vaideekam/poorvam",
        "pages": [
          {
            "slug": "/vaideekam/poorvam",
            "label_en": "Poorvam Overview",
            "label_ta": "à®ªà¯‚à®°à¯à®µà®®à¯ à®®à¯à®•à®ªà¯à®ªà¯"
          },
          {
            "slug": "/vaideekam/aksharaabhyaasam",
            "label_en": "Aksharabyasam",
            "label_ta": "à®…à®•à¯à®·à®°à®¾à®ªà¯à®¯à®¾à®šà®®à¯"
          },
          {
            "slug": "/vaideekam/upanayanam",
            "label_en": "Upanayanam",
            "label_ta": "à®‰à®ªà®¨à®¯à®©à®®à¯"
          },
          {
            "slug": "/vaideekam/vivaaham",
            "label_en": "Vivaaham (Marriage)",
            "label_ta": "à®µà®¿à®µà®¾à®¹à®®à¯"
          },
          {
            "slug": "/vaideekam/grihapravesam",
            "label_en": "Grihapravesam",
            "label_ta": "à®•à¯à®°à¯à®¹à®ªà¯à®°à®µà¯‡à®šà®®à¯"
          },
          {
            "slug": "/vaideekam/seemantham",
            "label_en": "Seemantham",
            "label_ta": "à®¸à¯€à®®à®¨à¯à®¤à®®à¯"
          }
        ]
      },
      {
        "id": "aparam",
        "label_en": "Aparam & Shradhdham",
        "label_ta": "à®…à®ªà®°à®®à¯ & à®šà¯à®°à®¾à®¤à¯à®¤à®®à¯",
        "slug": "/vaideekam/aparam",
        "pages": [
          {
            "slug": "/religious-services/shradhdha-service",
            "label_en": "Shradhdha Service",
            "label_ta": "à®¸à¯à®°à®¾à®¤à¯à®¤ à®¸à¯‡à®µà¯ˆ"
          },
          {
            "slug": "/vaideekam/aparam",
            "label_en": "Aparam Guide",
            "label_ta": "à®…à®ªà®°à®®à¯ à®µà®´à®¿à®•à®¾à®Ÿà¯à®Ÿà®¿"
          },
          {
            "slug": "/vaideekam/shradhdham",
            "label_en": "Shradhdham Procedures",
            "label_ta": "à®šà¯à®°à®¾à®¤à¯à®¤ à®µà®¿à®³à®•à¯à®•à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/panchangam/shradhdha-thithi",
            "label_en": "Shradhdha Thithi",
            "label_ta": "à®¸à¯à®°à®¾à®¤à¯à®¤ à®¤à®¿à®¤à®¿"
          },
          {
            "slug": "/panchangam/thithi-nirnaya-rules",
            "label_en": "Thithi Nirnaya Rules",
            "label_ta": "à®¤à®¿à®¤à®¿ à®¨à®¿à®°à¯à®£à®¯ à®µà®¿à®¤à®¿à®•à®³à¯"
          },
          {
            "slug": "/vaideekam/asoucham",
            "label_en": "Asoucham (Theetu Calculator)",
            "label_ta": "à®œà®©à®© à®®à®°à®£ à®¤à¯€à®Ÿà¯à®Ÿà¯ à®µà®¿à®ªà®°à®®à¯ & à®•à®£à®¿à®ªà¯à®ªà®¾à®©à¯"
          }
        ]
      },
      {
        "id": "sastram",
        "label_en": "Dharma Sastram Guide",
        "label_ta": "à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯ & à®µà®¿à®¤à®¿à®•à®³à¯",
        "slug": "/dharma-sastram",
        "pages": [
          {
            "slug": "/Events-And-Shastra-Rules/",
            "label_en": "ðŸ“œ 6,500+ Shastra Decision Rules",
            "label_ta": "ðŸ“œ à®ªà®žà¯à®šà®¾à®™à¯à®• à®šà®¾à®¸à¯à®¤à®¿à®° à®µà®¿à®šà¯‡à®· à®µà®¿à®¤à®¿à®•à®³à¯ (6,500+)"
          },
          {
            "slug": "/Sri_Paranthaman_Panchangam_Interactive_Browser.html",
            "label_en": "ðŸ“… Sri Paranthaman Panchangam",
            "label_ta": "ðŸ“… à®¸à¯à®°à¯€ à®ªà®°à®¨à¯à®¤à®¾à®®à®©à¯ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯"
          },
          {
            "slug": "/dharma-sastram",
            "label_en": "ðŸ“– Dharma Sastram (701 Pages)",
            "label_ta": "ðŸ“– à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯ (701 à®ªà®•à¯à®•à®™à¯à®•à®³à¯)"
          },
          {
            "slug": "/vaideekam/asoucham",
            "label_en": "à®†à®šà¯Œà®šà®®à¯ (à®œà®©à®© à®®à®°à®£ à®¤à¯€à®Ÿà¯à®Ÿà¯)",
            "label_ta": "à®†à®šà¯Œà®šà®®à¯ (à®œà®©à®© à®®à®°à®£ à®¤à¯€à®Ÿà¯à®Ÿà¯ à®µà®¿à®ªà®°à®®à¯)"
          },
          {
            "slug": "/pracheena-qa",
            "label_en": "ðŸ†• Pracheena QA",
            "label_ta": "ðŸ†• à®ªà¯à®°à®¾à®šà¯€à®© à®†à®šà®¾à®°à®®à¯"
          }
        ]
      }
    ]
  },
  {
    "id": "services",
    "label_en": "Services & Forum",
    "label_ta": "சேவைகள் & விவாத மன்றம்",
    "slug": "/services",
    "subMenus": [
      {
        "id": "religious-svcs",
        "label_en": "Religious Services",
        "label_ta": "à®†à®©à¯à®®à®¿à®• à®šà¯‡à®µà¯ˆà®•à®³à¯",
        "slug": "/services",
        "pages": [
          {
            "slug": "/services/marriage-garland",
            "label_en": "Marriage Garland Service",
            "label_ta": "à®¤à®¿à®°à¯à®®à®£ à®®à®¾à®²à¯ˆ à®šà¯‡à®µà¯ˆ"
          },
          {
            "slug": "/services/archanai",
            "label_en": "Remote Archanai Service",
            "label_ta": "à®¤à¯Šà®²à¯ˆ à®…à®°à¯à®šà¯à®šà®©à¯ˆ à®šà¯‡à®µà¯ˆ"
          },
          {
            "slug": "/religious-services/shradhdha-service",
            "label_en": "Shradhdha Service",
            "label_ta": "à®šà¯à®°à®¾à®¤à¯à®¤ à®šà¯‡à®µà¯ˆ"
          },
          {
            "slug": "/vaidhika-services",
            "label_en": "Vaidhika Services (23 Karmas)",
            "label_ta": "à®µà¯ˆà®¤à¯€à®• à®šà¯‡à®µà¯ˆà®•à®³à¯ (23 à®•à®°à¯à®®à®¾à®•à¯à®•à®³à¯)"
          },
          {
            "slug": "/partner-registration",
            "label_en": "Personnel Registration",
            "label_ta": "à®ªà®£à®¿à®¯à®¾à®³à®°à¯ à®ªà®¤à®¿à®µà¯"
          },
          {
            "slug": "/services/marriage-garland",
            "label_en": "Marriage Garland Service",
            "label_ta": "à®¤à®¿à®°à¯ à®®à®£ à®®à®¾à®²à¯ˆ à®šà¯‡à®µà¯ˆ"
          },
          {
            "slug": "/services/archanai",
            "label_en": "Remote Archanai Service",
            "label_ta": "à®¤à¯Šà®²à¯ˆ à®…à®°à¯ à®šà¯ à®šà®©à¯ˆ à®šà¯‡à®µà¯ˆ"
          },
          {
            "slug": "/religious-services/shradhdha-service",
            "label_en": "Shradhdha Service",
            "label_ta": "à®šà¯ à®°à®¾à®¤à¯ à®¤ à®¸à¯‡à®µà¯ˆ"
          },
          {
            "slug": "/vaidhika-services",
            "label_en": "Vaidhika Services (23 Karmas)",
            "label_ta": "à®µà¯ˆà®¤à¯€à®• à®šà¯‡à®µà¯ˆà®•à®³à¯  (23 à®•à®°à¯ à®®à®¾à®•à¯ à®•à®³à¯ )"
          },
          {
            "slug": "/partner-registration",
            "label_en": "Personnel Registration",
            "label_ta": "à®ªà®£à®¿à®¯à®¾à®³à®°à¯  à®ªà®¤à®¿à®µà¯ "
          },
          {
            "slug": "/request-personnel",
            "label_en": "Request Personnel",
            "label_ta": "à®ªà®£à®¿à®¯à®¾à®³à®°à¯ à®•à®³à¯  à®¤à¯‡à®µà¯ˆ"
          }
        ]
      },
      {
        "id": "shop-dl",
        "label_en": "Shop & Downloads",
        "label_ta": "à®…à®™à¯ à®•à®¾à®Ÿà®¿ & à®ªà®¤à®¿à®µà®¿à®±à®•à¯ à®•à®®à¯ ",
        "slug": "/shop",
        "pages": [
          {
            "slug": "/shop",
            "label_en": "Ahobilam Shop",
            "label_ta": "à®…à®•à¯‹à®ªà®¿à®²à®®à¯  à®…à®™à¯ à®•à®¾à®Ÿà®¿"
          },
          {
            "slug": "/panchangam/panchangam",
            "label_en": "Panchangam App Download",
            "label_ta": "à®ªà®žà¯ à®šà®¾à®™à¯ à®•à®®à¯  à®†à®ªà¯  à®ªà®¤à®¿à®µà®¿à®±à®•à¯ à®•à®®à¯ "
          },
          {
            "slug": "/panchangam/calendar",
            "label_en": "Annual Calendar",
            "label_ta": "à®µà®°à¯ à®Ÿà®¾à®¨à¯ à®¤à®¿à®° à®•à®¾à®²à®£à¯ à®Ÿà®°à¯ "
          }
        ]
      },
      {
        "id": "about-meta",
        "label_en": "About & Information",
        "label_ta": "à®…à®±à®¿à®®à¯ à®•à®®à¯  & à®¤à®•à®µà®²à¯ à®•à®³à¯ ",
        "slug": "/panchangam/about",
        "pages": [
          {
            "slug": "/privacy-policy",
            "label_en": "Privacy Policy",
            "label_ta": "à®¤à®©à®¿à®¯à¯à®°à®¿à®®à¯ˆà®•à¯ à®•à¯Šà®³à¯à®•à¯ˆ"
          }
        ]
      },
      {
        "id": "forum-main",
        "label_en": "Community & Q&A Board",
        "label_ta": "à®†à®©à¯à®®à¯€à®• à®®à®©à¯à®±à®®à¯ & à®µà®¿à®©à®¾-à®µà®¿à®Ÿà¯ˆ",
        "slug": "/forum",
        "pages": [
          {
            "slug": "/forum",
            "label_en": "ðŸŒ Community Forum (37,300+ Topics)",
            "label_ta": "ðŸŒ à®šà®®à¯à®¤à®¾à®¯ à®µà®¿à®µà®¾à®¤ à®®à®©à¯à®±à®®à¯"
          },
          {
            "slug": "/qa",
            "label_en": "â“ Ask Question / Q&A Board",
            "label_ta": "â“ à®µà®¿à®©à®¾-à®µà®¿à®Ÿà¯ˆ à®ªà®²à®•à¯ˆ"
          },
          {
            "slug": "/forum",
            "label_en": "ðŸ”¥ Iyer-Iyengar Rituals",
            "label_ta": "ðŸ”¥ à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯ & à®†à®šà®¾à®°à®®à¯"
          },
          {
            "slug": "/forum",
            "label_en": "ðŸ“š Dharma Sastram Discussions",
            "label_ta": "ðŸ“š à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®° à®µà®¿à®µà®¾à®¤à®™à¯à®•à®³à¯"
          },
          {
            "slug": "/forum",
            "label_en": "ðŸ’ FREE Matrimonials & Ads",
            "label_ta": "ðŸ’ à®‡à®²à®µà®š à®µà®°à®©à¯ & à®µà®¿à®³à®®à¯à®ªà®°à®™à¯à®•à®³à¯"
          }
        ]
      }
    ]
  }
];

const Navigation = () => {
  const { user, logout, language, toggleLanguage } = useAuth();
  const { isPremium } = useWallet();
  const { editMode, toggleEditMode } = useEditMode();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [hoveredMainIdx, setHoveredMainIdx] = useState(null);
  const [activeSubMenuIdx, setActiveSubMenuIdx] = useState(null);
  const [expandedMobileMenu, setExpandedMobileMenu] = useState(null);
  const [dynamicMenuItems, setDynamicMenuItems] = useState(MENU_ITEMS);
  const [showSearchModal, setShowSearchModal] = useState(false);

  // Auto-detect active Tier 1 index from current route
  const currentMainIndex = useMemo(() => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path.startsWith('/divyadesam') || path.startsWith('/anmikam') || path.startsWith('/sathya-narayana')) return 1;
    if (path.startsWith('/panchangam') || path === '/live-panchangam' || path === '/matching' || path === '/casting') return 2;
    if (path.startsWith('/vaideekam') || path.startsWith('/vaidhika') || path === '/dharma-sastram' || path === '/pracheena-qa') return 3;
    if (path.startsWith('/services') || path === '/shop' || path === '/cart' || path === '/checkout' || path === '/contact' || path === '/blog' || path === '/qa') return 4;
    return 1;
  }, [location.pathname]);

  const activeMainIdx = hoveredMainIdx !== null ? hoveredMainIdx : currentMainIndex;

  useEffect(() => {
    const fetchDynamicMenu = async () => {
      try {
        const pagesRes = await axios.get(`${API}/blog/pages`);
        const wpPages = pagesRes.data || [];

        if (wpPages.length > 0) {
          const updated = MENU_ITEMS.map(item => {
            if (item.id === 'anmikam') {
              return {
                ...item,
                subMenus: [
                  ...item.subMenus,
                  {
                    id: 'wp-pages',
                    label_en: 'Dynamic Library Pages',
                    label_ta: 'à®¨à¯‚à®²à®•à®ªà¯ à®ªà®•à¯à®•à®™à¯à®•à®³à¯',
                    slug: `/page/${wpPages[0].slug}`,
                    pages: wpPages.map(p => ({
                      slug: `/page/${p.slug}`,
                      label_en: p.title_en || p.title,
                      label_ta: p.title_ta || p.title
                    }))
                  }
                ]
              };
            }
            return item;
          });
          setDynamicMenuItems(updated);
        }
      } catch (err) {
        console.error("Failed to load dynamic menu items", err);
      }
    };
    fetchDynamicMenu();
  }, []);

  useEffect(() => {
    const handleOpenAuth = () => setShowAuthModal(true);
    const handleOpenForgotPassword = () => setShowForgotPassword(true);
    window.addEventListener('open-auth-modal', handleOpenAuth);
    window.addEventListener('openForgotPassword', handleOpenForgotPassword);
    return () => {
      window.removeEventListener('open-auth-modal', handleOpenAuth);
      window.removeEventListener('openForgotPassword', handleOpenForgotPassword);
    };
  }, []);

  const isHomePage = location.pathname === '/';
  const isAdminRoute = location.pathname ? location.pathname.startsWith('/admin') : false;

  return (
    <>
      {/* Top Header Banner â€” Auto-hides on mobile screens when on non-home pages */}
      {!isAdminRoute && (
        <Link
          to="/"
          className={`block ${!isHomePage ? 'hidden md:block' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <div
            style={{
              background: 'linear-gradient(to right, #51965a 0%, #fea328 15%, #ffc758 30%, #ffea81 42%, #d6e580 55%, #9ac959 65%, #4b9b1e 80%, #238709 90%, #047200 100%)',
              position: 'relative',
              overflow: 'hidden',
              minHeight: '90px'
            }}
            className="header-banner-container"
          >
            <img
              src="/images/header_left_emblem.png"
              alt="Ahobilam Sacred Emblem"
              style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                height: '92%',
                maxHeight: '115px',
                width: 'auto',
                objectFit: 'contain',
                zIndex: 2,
                filter: 'brightness(1.15) contrast(1.1) drop-shadow(0 4px 10px rgba(0,0,0,0.35))'
              }}
              className="header-left-deity"
            />
            <img
              src="/images/header_right_deity.png"
              alt="Lord Vishnu"
              style={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '100%',
                width: 'auto',
                objectFit: 'contain',
                objectPosition: 'right bottom',
                zIndex: 2,
                WebkitMaskImage: 'linear-gradient(to left, black 40%, transparent 100%)',
                maskImage: 'linear-gradient(to left, black 40%, transparent 100%)'
              }}
              className="header-right-deity"
            />
            <div
              style={{
                position: 'relative',
                zIndex: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '4px 0 6px',
                minHeight: 'inherit'
              }}
            >
              <div
                style={{
                  fontSize: 'clamp(18px, 3vw, 36px)',
                  lineHeight: 1,
                  color: '#8B0000',
                  textShadow: '0 1px 3px rgba(255,200,0,0.4)',
                  marginBottom: '2px'
                }}
              >
                ðŸ•‰
              </div>
              <div
                style={{
                  fontFamily: "'Noto Sans Devanagari', 'Noto Sans', serif",
                  fontStyle: 'italic',
                  fontWeight: 700,
                  color: '#5a3300',
                  textShadow: '1px 1px 2px rgba(255,255,255,0.5)',
                  lineHeight: 1.15,
                  textAlign: 'center'
                }}
                className="header-title-text"
              >
                <div
                  style={{
                    fontWeight: 900,
                    color: '#1A237E',
                    lineHeight: 1.1,
                    fontFamily: "'Cinzel Decorative', 'Georgia', serif",
                    fontSize: 'clamp(16px, 3.2vw, 40px)',
                    textAlign: 'center',
                    textShadow: '1px 1px 3px rgba(255,255,255,0.6)',
                    letterSpacing: '1px'
                  }}
                >
                  Sri Vaishnava Kendram
                </div>
                <div
                  style={{
                    fontSize: 'clamp(8px, 1.4vw, 16px)',
                    color: '#ed200dff',
                    fontWeight: 600,
                    fontStyle: 'italic',
                    maxWidth: '75%',
                    margin: '4px auto 0'
                  }}
                >
                  Bagavath Preethyartham Bhagavata Seva
                </div>
                <div
                  style={{
                    fontSize: 'clamp(8px, 1.1vw, 13px)',
                    color: '#b513f0ff',
                    fontWeight: 800,
                    fontFamily: "'Georgia', serif",
                    letterSpacing: '1px',
                    margin: '4px auto 0',
                    textShadow: '0 1px 2px rgba(255,255,255,0.8)'
                  }}
                >
                  Authentic Religious Knowhows on Rituals, Sastra, Sampradaya, Astrology and Panchangam since 24 years.
                </div>
              </div>
            </div>
          </div>

          {/* Sub-header Dark Strip */}
          <div
            style={{
              background: 'linear-gradient(to right, #8B4513, #2d5a1e)',
              padding: '6px 16px',
              color: '#fef3c7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
              minHeight: '40px'
            }}
          >
            <div className="hidden md:block w-48 flex-shrink-0"></div>
            <div
              style={{
                fontSize: 'clamp(14px, 1.8vw, 20px)',
                fontWeight: 800,
                letterSpacing: '3px',
                textShadow: '0 1px 2px rgba(0,0,0,0.5)',
                textAlign: 'center'
              }}
              className="flex-1 whitespace-nowrap"
            >
              www.ahobilam.com
            </div>
            <div className="flex items-center space-x-2 flex-shrink-0">
              <button
                onClick={toggleLanguage}
                className="px-3 py-1 bg-green-700 hover:bg-green-800 rounded text-xs font-bold transition-colors whitespace-nowrap text-white"
              >
                {language === 'en' ? 'à®¤à®®à®¿à®´à¯' : 'English'}
              </button>
              {user ? (
                <div className="flex items-center space-x-1.5">
                  {isPremium && (
                    <span
                      className="px-2 py-1 bg-yellow-400 text-yellow-900 rounded text-xs font-bold whitespace-nowrap shadow-sm border border-yellow-500 flex items-center gap-1"
                      title="Premium User"
                    >
                      <span>â­</span> Premium
                    </span>
                  )}
                  {user.role === 'admin' && (
                    <Link
                      to="/admin"
                      className="px-3 py-1 bg-purple-600 hover:bg-purple-700 rounded text-xs font-bold text-white transition-colors whitespace-nowrap"
                    >
                      Admin Panel
                    </Link>
                  )}
                  <Link
                    to="/profile"
                    className="px-3 py-1 bg-indigo-600 hover:bg-indigo-700 rounded text-xs font-bold text-white transition-all whitespace-nowrap"
                  >
                    {user.role === 'admin' ? 'âš™ï¸ Profile' : (user.name ? user.name.split(' ')[0] : 'Profile')}
                  </Link>
                  <button
                    onClick={logout}
                    className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-xs font-bold text-white transition-colors whitespace-nowrap"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => setShowAuthModal(true)}
                  className="px-3 py-1 bg-yellow-500 hover:bg-yellow-600 text-green-950 rounded text-xs font-bold transition-colors whitespace-nowrap"
                >
                  Login / Register
                </button>
              )}
            </div>
          </div>
        </Link>
      )}

      {/* 3-Tier Dynamic Navigation Bar */}
      <nav
        className="bg-gradient-to-r from-orange-700 via-amber-800 to-green-900 shadow-md sticky top-0 z-50 border-y border-amber-400/40 text-amber-100"
        onMouseLeave={() => {
          setHoveredMainIdx(null);
          setActiveSubMenuIdx(null);
        }}
      >
        <div className="w-full px-4 max-w-7xl mx-auto">
          <div className="flex items-center justify-between h-10 w-full relative">

            {/* Tier 1: Horizontal Root Bar (5 Main Menus Always - Horizontal Scroll on Mobile) */}
            <div className="flex items-center space-x-1.5 sm:space-x-4 md:space-x-6 overflow-x-auto scrollbar-none py-1 scroll-smooth flex-1 whitespace-nowrap min-w-0 mr-2">
              {dynamicMenuItems.map((mainItem, mIdx) => {
                const isActive = activeMainIdx === mIdx;
                return (
                  <div
                    key={mIdx}
                    className="relative group shrink-0"
                    onMouseEnter={() => setHoveredMainIdx(mIdx)}
                  >
                    <Link
                      to={mainItem.slug}
                      onClick={() => setHoveredMainIdx(mIdx)}
                      className={`px-2.5 sm:px-3 py-1.5 rounded-t-md text-xs sm:text-sm font-bold transition-all whitespace-nowrap flex items-center gap-1 ${
                        isActive
                          ? 'bg-[#FAF6EE] text-[#1A237E] shadow-sm border-t-2 border-[#D4AF37]'
                          : 'text-[#FAF6EE] hover:text-white hover:bg-amber-800/50'
                      }`}
                    >
                      <span>{language === 'en' ? mainItem.label_en : mainItem.label_ta}</span>
                      {mainItem.subMenus && <span className="text-[10px] opacity-80">â–¾</span>}
                    </Link>
                  </div>
                );
              })}

              {/* Universal Search Lens Icon Button (Desktop) */}
              <button
                onClick={() => setShowSearchModal(true)}
                className="hidden md:flex items-center gap-1.5 px-3 py-1 bg-amber-400/20 hover:bg-amber-400/40 text-[#FAF6EE] hover:text-white rounded-full border border-amber-400/50 transition-all font-bold text-xs whitespace-nowrap shadow-sm ml-2 shrink-0 cursor-pointer"
                title={language === 'en' ? 'Universal Site Search' : 'à®ªà®¿à®°à®ªà®žà¯à®šà®¤à¯ à®¤à¯‡à®Ÿà®²à¯'}
              >
                <span>ðŸ”</span>
                <span>{language === 'en' ? 'Search' : 'à®¤à¯‡à®Ÿà¯à®•'}</span>
              </button>
            </div>

            {/* Mobile Actions: Search, Register & Hamburger Menu */}
            <div className="md:hidden flex items-center space-x-1.5 shrink-0">
              <button
                onClick={() => setShowSearchModal(true)}
                className="px-2.5 py-1 bg-amber-400/30 hover:bg-amber-400/50 text-[#FAF6EE] hover:text-white rounded-full border border-amber-400/60 font-extrabold text-xs whitespace-nowrap shadow-sm flex items-center gap-1"
                title={language === 'en' ? 'Search Site' : 'à®¤à¯‡à®Ÿà¯à®•'}
              >
                <span>ðŸ”</span>
                <span className="text-[11px]">{language === 'en' ? 'Search' : 'à®¤à¯‡à®Ÿà¯à®•'}</span>
              </button>
              {!user && (
                <button
                  onClick={() => { setIsLogin(false); setShowAuthModal(true); }}
                  className="px-2.5 py-1 bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-extrabold text-xs rounded-full shadow-md flex items-center gap-1 border border-amber-300 animate-pulse"
                >
                  <span>ðŸ”‘</span>
                  <span>{language === 'en' ? 'Register' : 'à®ªà®¤à®¿à®µà¯'}</span>
                </button>
              )}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-[#FAF6EE] hover:text-white focus:outline-none text-xl px-2 py-0.5 bg-amber-800/60 rounded border border-amber-400/40"
                aria-label="Menu"
              >
                â˜°
              </button>
            </div>
          </div>
        </div>

        {/* Tier 2: Selected Main Menu Pop-down Horizontal Sub-Menu Row */}
        {dynamicMenuItems[activeMainIdx]?.subMenus && (
          <div className="w-full bg-[#FAF6EE] border-b border-[#F5EDDA] shadow-inner py-1.5 px-4 hidden md:block">
            <div className="max-w-7xl mx-auto flex items-center justify-center space-x-3 sm:space-x-6 flex-wrap gap-y-1">
              <span className="text-[11px] font-extrabold uppercase tracking-wider text-[#CC6600] flex items-center gap-1 mr-2">
                <span>â–</span>
                <span>{language === 'en' ? dynamicMenuItems[activeMainIdx].label_en : dynamicMenuItems[activeMainIdx].label_ta}:</span>
              </span>
              {dynamicMenuItems[activeMainIdx].subMenus.map((subItem, sIdx) => (
                <div
                  key={sIdx}
                  className="relative"
                  onMouseEnter={() => setActiveSubMenuIdx(sIdx)}
                >
                  <Link
                    to={subItem.slug}
                    className={`px-2.5 py-1 rounded text-xs font-bold transition-all flex items-center gap-1 ${
                      activeSubMenuIdx === sIdx
                        ? 'bg-[#1A237E] text-white shadow-sm'
                        : 'text-[#1A237E] hover:bg-[#F5EDDA] hover:text-[#CC6600]'
                    }`}
                  >
                    <span>{language === 'en' ? subItem.label_en : subItem.label_ta}</span>
                    {subItem.pages && <span className="text-[9px] text-[#D4AF37]">â–¾</span>}
                  </Link>

                  {/* Tier 3: Mouseover Vertical Dropdown Menu at Left End */}
                  {subItem.pages && activeSubMenuIdx === sIdx && (
                    <div className="absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 rounded-lg shadow-2xl py-2 z-50 border border-amber-200 animate-fade-in-down">
                      <div className="px-3 py-1 text-[11px] font-extrabold text-[#2D5A1E] bg-[#F5EDDA] border-b border-[#FAF6EE] uppercase tracking-wider mb-1 flex items-center justify-between">
                        <span>{language === 'en' ? subItem.label_en : subItem.label_ta}</span>
                        <span className="text-[10px] text-[#CC6600]">Pages</span>
                      </div>
                      {subItem.pages.map((pItem, pIdx) => (
                        <Link
                          key={pIdx}
                          to={pItem.slug}
                          onClick={() => {
                            setActiveSubMenuIdx(null);
                            setHoveredMainIdx(null);
                          }}
                          className="block px-4 py-1.5 text-xs font-semibold text-gray-700 hover:bg-[#FDF8ED] hover:text-[#1A237E] transition-colors border-b border-gray-50 last:border-0 flex items-center justify-between"
                        >
                          <span>{language === 'en' ? pItem.label_en : pItem.label_ta}</span>
                          <span className="text-gray-400 text-[10px]">â†’</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Mobile Touch 3-Tier Accordion Drawer */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#FAF6EE] text-[#1A237E] border-t-2 border-[#D4AF37] p-4 max-h-[80vh] overflow-y-auto shadow-2xl">
            {/* Mobile Registration Banner */}
            {!user ? (
              <div className="mb-4 p-3 bg-gradient-to-r from-amber-100 to-orange-100 rounded-lg border border-amber-300 text-center shadow-sm">
                <p className="text-xs font-bold text-amber-900 mb-2">
                  {language === 'en' ? 'ðŸŒ¸ Join 60+ Devotees for Daily Panchangam & Shastra Alerts!' : 'ðŸŒ¸ à®¤à®¿à®©à®šà®°à®¿ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯ à®ªà¯†à®± à®‡à®²à®µà®šà®®à®¾à®• à®‡à®£à¯ˆà®¯à¯à®™à¯à®•à®³à¯!'}
                </p>
                <div className="flex gap-2">
                  <button
                    onClick={() => { setIsLogin(false); setShowAuthModal(true); setMobileMenuOpen(false); }}
                    className="flex-1 py-1.5 bg-[#CC6600] hover:bg-orange-700 text-white font-bold text-xs rounded-md shadow flex items-center justify-center gap-1"
                  >
                    <span>ðŸ”‘</span>
                    <span>{language === 'en' ? 'Free Register' : 'à®‡à®²à®µà®š à®ªà®¤à®¿à®µà¯'}</span>
                  </button>
                  <button
                    onClick={() => { setIsLogin(true); setShowAuthModal(true); setMobileMenuOpen(false); }}
                    className="flex-1 py-1.5 bg-[#1A237E] hover:bg-blue-900 text-white font-bold text-xs rounded-md shadow flex items-center justify-center gap-1"
                  >
                    <span>ðŸ”“</span>
                    <span>{language === 'en' ? 'Log In' : 'à®‰à®³à¯à®¨à¯à®´à¯ˆà®•'}</span>
                  </button>
                </div>
              </div>
            ) : (
              <div className="mb-4 p-3 bg-green-50 rounded-lg border border-green-200 flex items-center justify-between text-xs font-bold text-green-900">
                <span>ðŸ™ {language === 'en' ? 'Welcome' : 'à®µà®°à®µà¯‡à®±à¯à®•à®¿à®±à¯‹à®®à¯'}, {user.name}</span>
                <button onClick={() => { logout(); setMobileMenuOpen(false); }} className="text-red-700 underline">Logout</button>
              </div>
            )}
            {dynamicMenuItems.map((mainItem, mIdx) => (
              <div key={mIdx} className="mb-2 border-b border-amber-200/60 pb-2 last:border-0">
                <div className="flex items-center justify-between font-bold text-sm text-[#1A237E] py-1">
                  <Link
                    to={mainItem.slug}
                    onClick={() => setMobileMenuOpen(false)}
                    className="hover:text-[#CC6600] transition-colors"
                  >
                    {language === 'en' ? mainItem.label_en : mainItem.label_ta}
                  </Link>
                  {mainItem.subMenus && (
                    <button
                      onClick={() => setExpandedMobileMenu(expandedMobileMenu === mIdx ? null : mIdx)}
                      className="px-2 py-0.5 text-xs bg-amber-200 rounded text-[#1A237E] font-extrabold focus:outline-none"
                    >
                      {expandedMobileMenu === mIdx ? 'âˆ’' : '+'}
                    </button>
                  )}
                </div>

                {/* Tier 2 Sub-Menus in Mobile Drawer */}
                {mainItem.subMenus && expandedMobileMenu === mIdx && (
                  <div className="pl-3 mt-1 space-y-2 border-l-2 border-amber-400">
                    {mainItem.subMenus.map((subItem, sIdx) => (
                      <div key={sIdx} className="bg-white p-2 rounded shadow-sm border border-amber-100">
                        <div className="font-bold text-xs text-[#CC6600] mb-1">
                          <Link
                            to={subItem.slug}
                            onClick={() => setMobileMenuOpen(false)}
                            className="hover:underline"
                          >
                            {language === 'en' ? subItem.label_en : subItem.label_ta}
                          </Link>
                        </div>

                        {/* Tier 3 Pages in Mobile Drawer */}
                        {subItem.pages && (
                          <div className="pl-2 space-y-1 mt-1 border-t border-gray-100 pt-1">
                            {subItem.pages.map((pItem, pIdx) => (
                              <Link
                                key={pIdx}
                                to={pItem.slug}
                                onClick={() => setMobileMenuOpen(false)}
                                className="block text-[11px] font-medium text-gray-700 hover:text-[#1A237E] py-0.5 flex items-center justify-between"
                              >
                                <span>{language === 'en' ? pItem.label_en : pItem.label_ta}</span>
                                <span className="text-[9px] text-amber-600">âž”</span>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            <div className="pt-3 border-t border-amber-300 flex items-center justify-between text-xs font-bold mt-2">
              <button
                onClick={toggleLanguage}
                className="px-3 py-1.5 bg-[#2D5A1E] text-white rounded shadow-sm"
              >
                {language === 'en' ? 'à®¤à®®à®¿à®´à¯ à®®à¯Šà®´à®¿' : 'English'}
              </button>
              {user && (
                <button
                  onClick={() => { logout(); setMobileMenuOpen(false); }}
                  className="px-3 py-1.5 bg-[#C62828] text-white rounded shadow-sm"
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        )}
      </nav>
      {showAuthModal && <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} isLogin={isLogin} setIsLogin={setIsLogin} />}
      {showForgotPassword && <ForgotPasswordModal onClose={() => setShowForgotPassword(false)} />}
      <SearchModal isOpen={showSearchModal} onClose={() => setShowSearchModal(false)} language={language} />
    </>
  );
};

const AuthModal = ({ isLogin, setIsLogin, onClose }) => {
  const { login, register, googleLogin, language } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isAlreadyRegistered, setIsAlreadyRegistered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [touched, setTouched] = useState({ email: false, password: false, name: false });

  // Priority control: Pause background audio/activity when registration modal opens
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('authModalActive', { detail: { active: true } }));
    return () => {
      window.dispatchEvent(new CustomEvent('authModalActive', { detail: { active: false } }));
    };
  }, []);

  // On-the-spot realtime field validations
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = emailRegex.test(email.trim());
  const isPasswordValid = password.length >= 4;
  const isNameValid = name.trim().length >= 2;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsAlreadyRegistered(false);

    // On the spot pre-submit validation checks
    if (!isEmailValid) {
      setError(language === 'ta' ? 'à®¤à®¯à®µà¯à®šà¯†à®¯à¯à®¤à¯ à®šà®°à®¿à®¯à®¾à®© à®®à®¿à®©à¯à®©à®žà¯à®šà®²à¯ à®®à¯à®•à®µà®°à®¿à®¯à¯ˆ à®‰à®³à¯à®³à®¿à®Ÿà®µà¯à®®à¯.' : 'Please enter a valid email address.');
      return;
    }
    if (!isPasswordValid) {
      setError(language === 'ta' ? 'à®•à®Ÿà®µà¯à®šà¯à®šà¯Šà®²à¯ à®•à¯à®±à¯ˆà®¨à¯à®¤à®¤à¯ 4 à®Žà®´à¯à®¤à¯à®¤à¯à®•à®³à¯ à®‡à®°à¯à®•à¯à®• à®µà¯‡à®£à¯à®Ÿà¯à®®à¯.' : 'Password must be at least 4 characters long.');
      return;
    }
    if (!isLogin && !isNameValid) {
      setError(language === 'ta' ? 'à®¤à®¯à®µà¯à®šà¯†à®¯à¯à®¤à¯ à®‰à®™à¯à®•à®³à¯ à®ªà¯†à®¯à®°à¯ˆ à®‰à®³à¯à®³à®¿à®Ÿà®µà¯à®®à¯.' : 'Please enter your full name.');
      return;
    }

    setLoading(true);

    try {
      if (isLogin) {
        const loggedUser = await login(email, password);
        onClose();
        if (loggedUser?.role === 'admin' || loggedUser?.role === 'moderator') {
          navigate('/admin');
        }
      } else {
        await register(email, password, name);
        onClose();
      }
    } catch (err) {
      console.error('Auth error:', err);
      const errMsg = err.message || err.response?.data?.detail || '';
      
      // Smart detection for 400 error / duplicate email registration
      if (errMsg.toLowerCase().includes('already registered') || errMsg.toLowerCase().includes('already exists') || err.response?.status === 400) {
        setIsAlreadyRegistered(true);
        setError(
          language === 'ta'
            ? `"${email}" à®Žà®©à¯à®± à®®à®¿à®©à¯à®©à®žà¯à®šà®²à¯ à®®à¯à®•à®µà®°à®¿ à®à®±à¯à®•à®©à®µà¯‡ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à®ªà¯à®ªà®Ÿà¯à®Ÿà¯à®³à¯à®³à®¤à¯!`
            : `The email "${email}" is already registered on Ahobilam.com!`
        );
      } else {
        setError(
          errMsg || (language === 'ta' ? 'à®‰à®³à¯à®¨à¯à®´à¯ˆà®µà¯/à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯ à®®à¯à®Ÿà®¿à®¯à®µà®¿à®²à¯à®²à¯ˆ. à®®à¯€à®£à¯à®Ÿà¯à®®à¯ à®®à¯à®¯à®±à¯à®šà®¿à®•à¯à®•à®µà¯à®®à¯.' : 'Authentication failed. Please check your credentials and try again.')
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: 'rgba(26, 35, 126, 0.75)' }} className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-[100000] p-3">
      <div style={{ backgroundColor: '#FAF6EE', borderColor: '#E65100' }} className="rounded-xl shadow-2xl max-w-sm w-full p-4 border-2 relative animate-fadeIn" data-testid="auth-modal">
        <div className="flex justify-between items-center mb-3 border-b border-amber-200 pb-2">
          <div>
            <h2 style={{ color: '#1A237E' }} className="text-base font-bold flex items-center gap-1.5">
              {isLogin ? 'ðŸ”‘ Log In' : 'ðŸ“ Register New Account'}
            </h2>
            <p className="text-[11px] text-amber-900 font-medium mt-0.5">
              {isLogin
                ? (language === 'ta' ? 'à®‰à®™à¯à®•à®³à¯ à®•à®£à®•à¯à®•à®¿à®²à¯ à®‰à®³à¯à®¨à¯à®´à¯ˆà®¯à®µà¯à®®à¯' : 'Welcome back to Ahobilam.com')
                : (language === 'ta' ? 'à®ªà¯à®¤à®¿à®¯ à®‡à®²à®µà®š à®•à®£à®•à¯à®•à¯ˆ à®‰à®°à¯à®µà®¾à®•à¯à®•à®µà¯à®®à¯' : 'Create your free account on Ahobilam.com')}
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-lg font-bold p-1 rounded-full hover:bg-amber-100 transition-colors" data-testid="close-modal">
            âœ•
          </button>
        </div>

        {/* Intuitive 400 Error / Duplicate Email Notice Box */}
        {isAlreadyRegistered ? (
          <div className="bg-amber-50 border-2 border-amber-400 p-4 rounded-xl shadow-inner mb-4 space-y-3">
            <div className="flex items-start gap-2.5">
              <span className="text-xl">âš ï¸</span>
              <div>
                <p className="font-bold text-amber-900 text-sm">
                  {language === 'ta' ? 'à®®à®¿à®©à¯à®©à®žà¯à®šà®²à¯ à®à®±à¯à®•à®©à®µà¯‡ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à®ªà¯à®ªà®Ÿà¯à®Ÿà¯à®³à¯à®³à®¤à¯!' : 'Email Already Registered'}
                </p>
                <p className="text-xs text-amber-800 font-medium mt-1">
                  {language === 'ta'
                    ? `"${email}" à®Žà®©à¯à®± à®®à®¿à®©à¯à®©à®žà¯à®šà®²à®¿à®²à¯ à®à®±à¯à®•à®©à®µà¯‡ à®’à®°à¯ à®•à®£à®•à¯à®•à¯ à®‰à®³à¯à®³à®¤à¯. à®¨à¯€à®™à¯à®•à®³à¯ à®¨à¯‡à®°à®Ÿà®¿à®¯à®¾à®• à®‰à®³à¯à®¨à¯à®´à¯ˆà®¯à®²à®¾à®®à¯.`
                    : `An account already exists for "${email}". You can log in directly below.`}
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                setError('');
                setIsAlreadyRegistered(false);
                setIsLogin(true);
              }}
              className="w-full bg-amber-700 hover:bg-amber-800 text-white font-extrabold py-2.5 px-4 rounded-lg shadow transition-all cursor-pointer text-sm flex items-center justify-center gap-2"
            >
              ðŸ”‘ {language === 'ta' ? 'à®‡à®™à¯à®•à¯ à®‰à®³à¯à®¨à¯à®´à¯ˆà®¯à®µà¯à®®à¯ (Log In Here)' : 'Log In With This Email'}
            </button>
          </div>
        ) : error ? (
          <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-3 text-sm rounded-lg mb-4 font-medium" data-testid="auth-error">
            {error}
          </div>
        ) : null}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* EMAIL FIELD WITH REALTIME HINT */}
          <div>
            <div className="flex justify-between items-center mb-1">
              <label htmlFor="email" className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                Username or Email Address <span className="text-red-500">*</span>
              </label>
              {email.length > 0 && (
                <span className={`text-[11px] font-bold ${isEmailValid ? 'text-green-600' : 'text-amber-600'}`}>
                  {isEmailValid ? 'âœ“ Valid format' : 'âš ï¸ Incomplete email'}
                </span>
              )}
            </div>
            <input
              id="email"
              type="text"
              value={email}
              onBlur={() => setTouched(prev => ({ ...prev, email: true }))}
              onChange={(e) => {
                setEmail(e.target.value);
                if (isAlreadyRegistered) setIsAlreadyRegistered(false);
                if (error) setError('');
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-900 bg-white text-sm font-medium focus:ring-2 focus:ring-green-600"
              placeholder="Username or email address"
              required
            />
          </div>

          {/* PASSWORD FIELD WITH REALTIME HINT */}
          <div>
            <div className="flex justify-between items-center mb-1">
              <label htmlFor="password" className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                Password <span className="text-red-500">*</span>
              </label>
              {password.length > 0 && (
                <span className={`text-[11px] font-bold ${isPasswordValid ? 'text-green-600' : 'text-amber-600'}`}>
                  {isPasswordValid ? 'âœ“ Password OK' : 'âš ï¸ Min 4 chars required'}
                </span>
              )}
            </div>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onBlur={() => setTouched(prev => ({ ...prev, password: true }))}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError('');
                }}
                className={`w-full px-3 py-2 pr-16 border rounded-lg text-gray-900 bg-white text-sm font-medium transition-colors ${
                  password.length > 0
                    ? isPasswordValid
                      ? 'border-green-500 focus:ring-2 focus:ring-green-600'
                      : 'border-amber-400 focus:ring-2 focus:ring-amber-500'
                    : 'border-gray-300 focus:ring-2 focus:ring-green-600'
                }`}
                placeholder="â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-1/2 -translate-y-1/2 px-2.5 py-1 text-xs font-bold text-gray-600 hover:text-gray-900 bg-gray-100 hover:bg-gray-200 rounded transition-colors z-10 cursor-pointer"
              >
                {showPassword ? 'ðŸ™ˆ Hide' : 'ðŸ‘ï¸ Show'}
              </button>
            </div>
            {touched.password && password.length > 0 && !isPasswordValid && (
              <p className="text-[11px] text-amber-700 font-medium mt-1">
                {language === 'ta' ? 'ðŸ’¡ à®‰à®¤à®µà®¿: à®•à®Ÿà®µà¯à®šà¯à®šà¯Šà®²à¯ à®•à¯à®±à¯ˆà®¨à¯à®¤à®¤à¯ 4 à®Žà®´à¯à®¤à¯à®¤à¯à®•à®³à¯ à®‡à®°à¯à®•à¯à®• à®µà¯‡à®£à¯à®Ÿà¯à®®à¯' : 'ðŸ’¡ Hint: Password must be at least 4 characters long'}
              </p>
            )}
            {isLogin && (
              <div className="flex justify-end mt-1">
                <button
                  type="button"
                  onClick={() => {
                    onClose();
                    window.dispatchEvent(new Event('openForgotPassword'));
                  }}
                  className="text-xs text-green-700 hover:text-green-900 font-semibold"
                >
                  {language === 'ta' ? 'à®•à®Ÿà®µà¯à®šà¯à®šà¯Šà®²à¯à®²à¯ˆ à®®à®±à®¨à¯à®¤à¯à®µà®¿à®Ÿà¯à®Ÿà¯€à®°à¯à®•à®³à®¾?' : 'Forgot Password?'}
                </button>
              </div>
            )}
          </div>

          {/* FULL NAME FIELD FOR REGISTRATION */}
          {!isLogin && (
            <div>
              <div className="flex justify-between items-center mb-1">
                <label htmlFor="name" className="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                  Full Name <span className="text-red-500">*</span>
                </label>
                {name.length > 0 && (
                  <span className={`text-[11px] font-bold ${isNameValid ? 'text-green-600' : 'text-amber-600'}`}>
                    {isNameValid ? 'âœ“ Name OK' : 'âš ï¸ Enter full name'}
                  </span>
                )}
              </div>
              <input
                id="name"
                type="text"
                value={name}
                onBlur={() => setTouched(prev => ({ ...prev, name: true }))}
                onChange={(e) => {
                  setName(e.target.value);
                  if (error) setError('');
                }}
                className={`w-full px-3 py-2 border rounded-lg text-gray-900 bg-white text-sm font-medium transition-colors ${
                  name.length > 0
                    ? isNameValid
                      ? 'border-green-500 focus:ring-2 focus:ring-green-600'
                      : 'border-amber-400 focus:ring-2 focus:ring-amber-500'
                    : 'border-gray-300 focus:ring-2 focus:ring-green-600'
                }`}
                placeholder="e.g. Vasu Vadhyar"
                required
              />
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-green-700 to-green-800 text-white py-3 px-4 rounded-xl font-extrabold hover:from-green-800 hover:to-green-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 shadow-md transition-all cursor-pointer text-base"
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {language === 'ta' ? 'à®šà¯†à®¯à®²à®¾à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®•à®¿à®±à®¤à¯...' : 'Processing...'}
              </span>
            ) : isLogin ? (
              language === 'ta' ? 'ðŸ”‘ à®‰à®³à¯à®¨à¯à®´à¯ˆà®¯à®µà¯à®®à¯ (Log In)' : 'ðŸ”‘ Log In'
            ) : (
              language === 'ta' ? 'ðŸ“ à®‡à®²à®µà®šà®®à®¾à®• à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à®µà¯à®®à¯ (Register Free)' : 'ðŸ“ Register Free Account'
            )}
          </button>

          <div className="flex items-center justify-between my-4">
            <span className="border-b w-1/4"></span>
            <span className="text-xs text-center text-gray-500 uppercase font-semibold">Or login with</span>
            <span className="border-b w-1/4"></span>
          </div>

          <div className="flex flex-col items-center space-y-3 pt-2">
            <GoogleLogin
              useOneTap={true}
              theme="filled_blue"
              shape="pill"
              size="large"
              width="280"
              onSuccess={async (credentialResponse) => {
                setLoading(true);
                try {
                  await googleLogin(credentialResponse.credential);
                  onClose();
                } catch (err) {
                  setError('Google Login failed. Please try again.');
                } finally {
                  setLoading(false);
                }
              }}
              onError={() => {
                setError('Google Login Failed');
              }}
            />

            <FacebookLogin
              appId={process.env.REACT_APP_FACEBOOK_APP_ID || "3249611805320267"}
              version="v26.0"
              onSuccess={async (response) => {
                setLoading(true);
                try {
                  await facebookLogin(response.accessToken);
                  onClose();
                } catch (err) {
                  console.error('FB Login error:', err);
                  setError('Facebook Login failed. Please try again.');
                } finally {
                  setLoading(false);
                }
              }}
              onFail={(error) => {
                console.error('Facebook Login Failed:', error);
                setError('Facebook Login Failed');
              }}
              render={({ onClick }) => (
                <button
                  type="button"
                  onClick={onClick}
                  className="w-full flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#166FE5] text-white py-2.5 px-4 rounded-lg font-bold shadow-md transition-all cursor-pointer text-sm"
                  data-testid="facebook-login-btn"
                >
                  <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Continue with Facebook (Facebook-à®‡à®²à¯ à®¨à¯à®´à¯ˆà®•)
                </button>
              )}
            />
          </div>

          <div className="mt-4 pt-3 border-t border-gray-100 text-center">
            {isLogin ? (
              <p className="text-xs text-gray-600 font-medium">
                {language === 'ta' ? 'à®•à®£à®•à¯à®•à¯ à®‡à®²à¯à®²à¯ˆà®¯à®¾?' : "Don't have an account?"}{' '}
                <button
                  type="button"
                  onClick={() => {
                    setError('');
                    setIsAlreadyRegistered(false);
                    setIsLogin(false);
                  }}
                  className="text-green-700 hover:text-green-900 font-bold underline cursor-pointer"
                >
                  {language === 'ta' ? 'à®‡à®™à¯à®•à¯ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯ à®•à®¿à®³à®¿à®•à¯ à®šà¯†à®¯à¯à®¯à®µà¯à®®à¯' : 'Register Now'}
                </button>
              </p>
            ) : (
              <p className="text-xs text-gray-600 font-medium">
                {language === 'ta' ? 'à®à®±à¯à®•à®©à®µà¯‡ à®•à®£à®•à¯à®•à¯ à®‰à®³à¯à®³à®¤à®¾?' : 'Already have an account?'}{' '}
                <button
                  type="button"
                  onClick={() => {
                    setError('');
                    setIsAlreadyRegistered(false);
                    setIsLogin(true);
                  }}
                  className="text-green-700 hover:text-green-900 font-bold underline cursor-pointer"
                >
                  {language === 'ta' ? 'à®‡à®™à¯à®•à¯ à®‰à®³à¯à®¨à¯à®´à¯ˆà®¯à®µà¯à®®à¯' : 'Log In Here'}
                </button>
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

// Forgot Password Modal
const ForgotPasswordModal = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [resetLink, setResetLink] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 8000);
      
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
      const API_BASE = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;
      
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      
      const data = await res.json();
      setSuccess(true);
      if (data && data.reset_link) {
        setResetLink(data.reset_link);
      }
    } catch (err) {
      console.error(err);
      setSuccess(true);
      setResetLink(`/reset-password?token=instant_${Date.now()}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/65 backdrop-blur-sm flex items-center justify-center z-[100000] p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 border-2 border-green-600 relative">
        <div className="flex justify-between items-center mb-4 border-b border-gray-200 pb-3">
          <h2 className="text-2xl font-extrabold text-green-800">ðŸ”‘ Reset Password</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-xl font-bold p-1">
            âœ•
          </button>
        </div>

        {!success ? (
          <>
            <p className="text-gray-600 mb-4">
              Enter your email address and we'll send you a link to reset your password.
            </p>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-md transition-colors disabled:bg-gray-400"
              >
                {loading ? 'Please wait...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div>
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4 font-semibold text-center">
              âœ… Password reset link generated successfully!
            </div>
            {resetLink && (
              <div className="bg-orange-50 border-2 border-orange-300 p-4 rounded-xl mb-4 text-center">
                <p className="text-sm text-gray-800 mb-3 font-semibold">
                  Click the button below to set your new password:
                </p>
                <a
                  href={resetLink}
                  className="inline-block w-full bg-orange-600 hover:bg-orange-700 text-white font-extrabold py-3 px-4 rounded-lg shadow-md transition-all text-center text-base"
                  onClick={onClose}
                >
                  ðŸ”‘ Set New Password Now / à®ªà¯à®¤à®¿à®¯ à®•à®Ÿà®µà¯à®šà¯à®šà¯Šà®²à¯ à®®à®¾à®±à¯à®±à¯à®•
                </a>
              </div>
            )}
            <button
              onClick={onClose}
              className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md transition-colors mt-2"
            >
              Close / à®®à¯‚à®Ÿà¯à®•
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Reset Password Page
const ResetPasswordPage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Get token from URL
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
      const API_BASE = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;
      
      await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password })
      });
      setSuccess(true);
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (err) {
      console.error(err);
      setSuccess(true);
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
          <div className="text-red-600 mb-4">âŒ Invalid or missing reset token</div>
          <Link to="/" className="text-orange-600 hover:text-orange-700">
            Return to homepage
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h2 className="text-2xl font-bold text-green-800 mb-6">Reset Password</h2>

        {success ? (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
            âœ… Password reset successfully! Redirecting to login...
          </div>
        ) : (
          <>
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  required
                  minLength={6}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  required
                  minLength={6}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-md transition-colors disabled:bg-gray-400"
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

// Page Dropdowns Component - Displays dropdowns on pages
const PageDropdowns = ({ pageName, onSelectionChange }) => {
  const [dropdowns, setDropdowns] = useState([]);
  const [selections, setSelections] = useState({});
  const { language } = useAuth();

  useEffect(() => {
    fetchDropdowns();
  }, [pageName]);

  const fetchDropdowns = async () => {
    try {
      const response = await axios.get(`${API}/dropdowns/page/${pageName}`);
      setDropdowns(response.data);
    } catch (error) {
      console.error('Error fetching dropdowns:', error);
    }
  };

  const handleChange = (dropdownId, value) => {
    const newSelections = { ...selections, [dropdownId]: value };
    setSelections(newSelections);
    if (onSelectionChange) {
      onSelectionChange(newSelections);
    }
  };

  if (dropdowns.length === 0) return null;

  return (
    <div className="space-y-4 mb-6">
      {dropdowns.map((dropdown) => (
        <div key={dropdown.id} className="bg-white rounded-lg shadow-md p-4">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            {language === 'en' ? dropdown.title_en : (dropdown.title_ta || dropdown.title_en)}
            {dropdown.required && <span className="text-red-500 ml-1">*</span>}
          </label>
          <select
            value={selections[dropdown.id] || ''}
            onChange={(e) => handleChange(dropdown.id, e.target.value)}
            required={dropdown.required}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          >
            <option value="">
              {language === 'en' ? 'Please select...' : 'à®¤à®¯à®µà¯à®šà¯†à®¯à¯à®¤à¯ à®¤à¯‡à®°à¯à®¨à¯à®¤à¯†à®Ÿà¯à®•à¯à®•à®µà¯à®®à¯...'}
            </option>
            {dropdown.items
              ?.filter(item => item.enabled)
              ?.sort((a, b) => a.order - b.order)
              ?.map((item, idx) => (
                <option key={idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
      ))}
    </div>
  );
};

// Comment Section Component
export const CommentSection = ({ pageSlug }) => {
  const { user, language, token } = useAuth();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [verifiedVia, setVerifiedVia] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpMethod, setOtpMethod] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpMessage, setOtpMessage] = useState('');
  const [waLink, setWaLink] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [maskedPhone, setMaskedPhone] = useState('');

  useEffect(() => {
    fetchComments();
  }, [pageSlug]);

  useEffect(() => {
    if (user && token) {
      checkVerificationStatus();
    }
  }, [user, token]);

  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${token || localStorage.getItem('token')}` }
  });

  const checkVerificationStatus = async () => {
    try {
      const res = await axios.get(`${API}/verify/status`, authHeaders());
      setIsVerified(res.data.is_verified);
      setVerifiedVia(res.data.verified_via);
    } catch (err) {
      console.error('Error checking verification:', err);
    }
  };

  const fetchComments = async () => {
    try {
      const response = await axios.get(`${API}/comments/${pageSlug}`);
      setComments(response.data);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  const handleSendOtp = async (method) => {
    setOtpSending(true);
    setOtpMessage('');
    setOtpMethod(method);

    // Derive masked info directly from user so it shows immediately
    if (user) {
      if (user.email) {
        const parts = user.email.split('@');
        if (parts.length === 2) {
          setMaskedEmail(parts[0].substring(0, 3) + '***@' + parts[1]);
        } else {
          setMaskedEmail(user.email);
        }
      }
      if (user.phone) {
        if (user.phone.length > 4) {
          setMaskedPhone('******' + user.phone.substring(user.phone.length - 4));
        } else {
          setMaskedPhone(user.phone);
        }
      } else {
        setMaskedPhone(language === 'en' ? 'your registered phone number' : 'à®‰à®™à¯à®•à®³à¯ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à®ªà¯à®ªà®Ÿà¯à®Ÿ à®¤à¯Šà®²à¯ˆà®ªà¯‡à®šà®¿ à®Žà®£à¯');
      }
    }
    
    setShowOtpModal(true); // Show modal immediately so users see loading state or errors

    try {
      const res = await axios.post(`${API}/verify/send-code`, { method }, authHeaders());
      if (res.data.status === 'already_verified') {
        setIsVerified(true);
        setVerifiedVia(res.data.verified_via);
        setShowOtpModal(false);
        return;
      }
      if (method === 'email') {
        if (res.data.masked_email) setMaskedEmail(res.data.masked_email);
        setOtpMessage(language === 'en' 
          ? `âœ… Code sent! Check your inbox.`
          : `âœ… à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯ à®…à®©à¯à®ªà¯à®ªà®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯!`);
      } else if (method === 'whatsapp') {
        setWaLink(res.data.wa_link || '');
        setOtpCode(res.data.code || '');
        setOtpMessage(language === 'en'
          ? 'ðŸ“± Click the WhatsApp button below to send your code, then enter it here.'
          : 'ðŸ“± à®‰à®™à¯à®•à®³à¯ à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯à®Ÿà¯ˆ à®…à®©à¯à®ªà¯à®ª à®•à¯€à®´à¯‡ WhatsApp à®ªà¯Šà®¤à¯à®¤à®¾à®©à¯ˆà®•à¯ à®•à®¿à®³à®¿à®•à¯ à®šà¯†à®¯à¯à®¯à®µà¯à®®à¯.');
      }
    } catch (err) {
      setOtpMessage(language === 'en' ? 'âŒ Failed to send code. Try again.' : 'âŒ à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯ à®…à®©à¯à®ªà¯à®ª à®®à¯à®Ÿà®¿à®¯à®µà®¿à®²à¯à®²à¯ˆ.');
    } finally {
      setOtpSending(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otpCode || otpCode.length < 6) return;
    setOtpVerifying(true);
    try {
      const res = await axios.post(`${API}/verify/confirm`, { code: otpCode }, authHeaders());
      if (res.data.status === 'verified' || res.data.status === 'already_verified') {
        setIsVerified(true);
        setVerifiedVia(res.data.method || otpMethod);
        setShowOtpModal(false);
        setOtpCode('');
        alert(language === 'en' 
          ? 'ðŸŽ‰ Verified! Your comments will now be published instantly.' 
          : 'ðŸŽ‰ à®šà®°à®¿à®ªà®¾à®°à¯à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯! à®‰à®™à¯à®•à®³à¯ à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯ à®‰à®Ÿà®©à®Ÿà®¿à®¯à®¾à®• à®µà¯†à®³à®¿à®¯à®¿à®Ÿà®ªà¯à®ªà®Ÿà¯à®®à¯.');
      }
    } catch (err) {
      setOtpMessage(language === 'en' 
        ? 'âŒ Invalid or expired code. Please try again.' 
        : 'âŒ à®¤à®µà®±à®¾à®© à®…à®²à¯à®²à®¤à¯ à®•à®¾à®²à®¾à®µà®¤à®¿à®¯à®¾à®© à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯.');
    } finally {
      setOtpVerifying(false);
    }
  };

  const handleSubmitComment = async (e) => {
    e.preventDefault();
    if (!user) {
      setShowAuthModal(true);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/comments`, {
        page_slug: pageSlug,
        content: newComment,
      }, authHeaders());
      setNewComment('');
      
      if (response.data.approved) {
        alert(language === 'en'
          ? 'Comment published instantly! âœ…'
          : 'à®•à®°à¯à®¤à¯à®¤à¯ à®‰à®Ÿà®©à®Ÿà®¿à®¯à®¾à®• à®µà¯†à®³à®¿à®¯à®¿à®Ÿà®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯! âœ…');
      } else {
        alert(language === 'en'
          ? 'Comment submitted! It will appear after admin approval. Verify your identity to post instantly next time!'
          : 'à®•à®°à¯à®¤à¯à®¤à¯ à®šà®®à®°à¯à®ªà¯à®ªà®¿à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯! à®¨à®¿à®°à¯à®µà®¾à®•à®¿ à®’à®ªà¯à®ªà¯à®¤à®²à¯à®•à¯à®•à¯à®ªà¯ à®ªà®¿à®±à®•à¯ à®¤à¯‹à®©à¯à®±à¯à®®à¯. à®…à®Ÿà¯à®¤à¯à®¤ à®®à¯à®±à¯ˆ à®‰à®Ÿà®©à®Ÿà®¿à®¯à®¾à®• à®‡à®Ÿà¯à®•à¯ˆà®¯à®¿à®Ÿ à®‰à®™à¯à®•à®³à¯ à®…à®Ÿà¯ˆà®¯à®¾à®³à®¤à¯à®¤à¯ˆà®šà¯ à®šà®°à®¿à®ªà®¾à®°à¯à®•à¯à®•à®µà¯à®®à¯!');
      }
      
      fetchComments();
    } catch (error) {
      console.error('Error posting comment:', error);
      alert(language === 'en' ? 'Failed to post comment' : 'à®•à®°à¯à®¤à¯à®¤à¯ˆ à®‡à®Ÿà¯à®•à¯ˆà®¯à®¿à®Ÿ à®®à¯à®Ÿà®¿à®¯à®µà®¿à®²à¯à®²à¯ˆ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-8" data-testid="comment-section">
      <h3 className="text-2xl font-bold text-green-800 mb-4">
        {language === 'en' ? 'Comments' : 'à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯'} ({comments.length})
      </h3>

      {/* Verification Banner */}
      {user && (
        <div className={`mb-4 p-4 rounded-lg border ${isVerified 
          ? 'bg-green-50 border-green-200' 
          : 'bg-amber-50 border-amber-200'}`}
        >
          {isVerified ? (
            <div className="flex items-center space-x-2">
              <span className="text-green-600 text-xl">âœ…</span>
              <span className="text-green-800 font-medium">
                {language === 'en' 
                  ? `Verified ${verifiedVia === 'whatsapp' ? 'via WhatsApp' : 'via Email'} â€” Your comments are published instantly!` 
                  : `à®šà®°à®¿à®ªà®¾à®°à¯à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯ ${verifiedVia === 'whatsapp' ? 'WhatsApp à®®à¯‚à®²à®®à¯' : 'Email à®®à¯‚à®²à®®à¯'} â€” à®‰à®™à¯à®•à®³à¯ à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯ à®‰à®Ÿà®©à®Ÿà®¿à®¯à®¾à®• à®µà¯†à®³à®¿à®¯à®¿à®Ÿà®ªà¯à®ªà®Ÿà¯à®®à¯!`}
              </span>
            </div>
          ) : (
            <div>
              <div className="flex items-center space-x-2 mb-3">
                <span className="text-amber-500 text-xl">âš ï¸</span>
                <span className="text-amber-800 font-medium">
                  {language === 'en' 
                    ? 'Verify your identity to post comments instantly (without admin approval)' 
                    : 'à®¨à®¿à®°à¯à®µà®¾à®•à®¿ à®’à®ªà¯à®ªà¯à®¤à®²à¯ à®‡à®²à¯à®²à®¾à®®à®²à¯ à®‰à®Ÿà®©à®Ÿà®¿à®¯à®¾à®• à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯ˆ à®µà¯†à®³à®¿à®¯à®¿à®Ÿ à®‰à®™à¯à®•à®³à¯ à®…à®Ÿà¯ˆà®¯à®¾à®³à®¤à¯à®¤à¯ˆà®šà¯ à®šà®°à®¿à®ªà®¾à®°à¯à®•à¯à®•à®µà¯à®®à¯'}
                </span>
              </div>
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={() => handleSendOtp('email')}
                  disabled={otpSending}
                  className="flex items-center space-x-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors disabled:bg-gray-400 shadow-sm"
                >
                  <span>ðŸ“§</span>
                  <span>{otpSending && otpMethod === 'email' 
                    ? (language === 'en' ? 'Sending...' : 'à®…à®©à¯à®ªà¯à®ªà¯à®•à®¿à®±à®¤à¯...') 
                    : (language === 'en' ? 'Verify via Email' : 'Email à®®à¯‚à®²à®®à¯ à®šà®°à®¿à®ªà®¾à®°à¯')}</span>
                </button>
                <button
                  onClick={() => handleSendOtp('whatsapp')}
                  disabled={otpSending}
                  className="flex items-center space-x-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors disabled:bg-gray-400 shadow-sm"
                >
                  <span>ðŸ“±</span>
                  <span>{otpSending && otpMethod === 'whatsapp' 
                    ? (language === 'en' ? 'Preparing...' : 'à®¤à®¯à®¾à®°à®¾à®•à®¿à®±à®¤à¯...') 
                    : (language === 'en' ? 'Verify via WhatsApp' : 'WhatsApp à®®à¯‚à®²à®®à¯ à®šà®°à®¿à®ªà®¾à®°à¯')}</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* OTP Verification Modal */}
      {showOtpModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative">
            <button
              onClick={() => { setShowOtpModal(false); setOtpCode(''); setOtpMessage(''); }}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold"
            >Ã—</button>
            
            <div className="text-center mb-6">
              <div className="text-4xl mb-2">{otpMethod === 'email' ? 'ðŸ“§' : 'ðŸ“±'}</div>
              <h3 className="text-xl font-bold text-gray-900">
                {language === 'en' ? 'Enter Verification Code' : 'à®šà®°à®¿à®ªà®¾à®°à¯à®ªà¯à®ªà¯à®•à¯ à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯à®Ÿà¯ˆ à®‰à®³à¯à®³à®¿à®Ÿà®µà¯à®®à¯'}
              </h3>
              
              <p className="text-sm text-gray-500 mt-1">
                {otpMethod === 'email' 
                  ? (language === 'en' ? `Sent to: ${maskedEmail}` : `à®‡à®¤à®±à¯à®•à¯ à®…à®©à¯à®ªà¯à®ªà®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯: ${maskedEmail}`)
                  : (language === 'en' ? `Click the button below to send the code to Admin` : `à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯à®Ÿà¯ˆ à®¨à®¿à®°à¯à®µà®¾à®•à®¿à®•à¯à®•à¯ à®…à®©à¯à®ªà¯à®ª à®•à¯€à®´à¯‡ à®‰à®³à¯à®³ à®ªà¯Šà®¤à¯à®¤à®¾à®©à¯ˆà®•à¯ à®•à®¿à®³à®¿à®•à¯ à®šà¯†à®¯à¯à®¯à®µà¯à®®à¯`)
                }
              </p>
              {otpMessage && (
                <p className="text-sm text-gray-600 mt-2">{otpMessage}</p>
              )}
            </div>

            {/* WhatsApp link button */}
            {otpMethod === 'whatsapp' && waLink && (
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center mb-4 px-4 py-3 bg-green-500 hover:bg-green-600 text-white font-bold rounded-xl transition-colors shadow-md"
              >
                ðŸ“± {language === 'en' ? 'Open WhatsApp & Send Code' : 'WhatsApp à®¤à®¿à®±à®¨à¯à®¤à¯ à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯ à®…à®©à¯à®ªà¯à®ªà®µà¯à®®à¯'}
              </a>
            )}

            <div className="mb-4">
              <input
                type="text"
                maxLength={6}
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                placeholder="000000"
                className="w-full text-center text-3xl font-bold tracking-[12px] py-4 border-2 border-gray-300 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all"
                autoFocus
              />
            </div>

            <button
              onClick={handleVerifyOtp}
              disabled={otpVerifying || otpCode.length < 6}
              className="w-full py-3 bg-orange-600 hover:bg-orange-700 text-white font-bold rounded-xl transition-colors disabled:bg-gray-300 shadow-md text-lg"
            >
              {otpVerifying 
                ? (language === 'en' ? 'Verifying...' : 'à®šà®°à®¿à®ªà®¾à®°à¯à®•à¯à®•à®¿à®±à®¤à¯...') 
                : (language === 'en' ? 'ðŸ” Verify' : 'ðŸ” à®šà®°à®¿à®ªà®¾à®°à¯')}
            </button>

            <div className="mt-4 text-center">
              <button
                onClick={() => handleSendOtp(otpMethod)}
                disabled={otpSending}
                className="text-sm text-blue-600 hover:text-blue-800 underline"
              >
                {language === 'en' ? 'Resend Code' : 'à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯à®Ÿà¯ˆ à®®à¯€à®£à¯à®Ÿà¯à®®à¯ à®…à®©à¯à®ªà¯à®ªà¯'}
              </button>
              <p className="text-xs text-gray-400 mt-1">
                {language === 'en' ? 'Code expires in 10 minutes' : 'à®•à¯à®±à®¿à®¯à¯€à®Ÿà¯ 10 à®¨à®¿à®®à®¿à®Ÿà®™à¯à®•à®³à®¿à®²à¯ à®•à®¾à®²à®¾à®µà®¤à®¿à®¯à®¾à®•à¯à®®à¯'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Comment Form */}
      <form onSubmit={handleSubmitComment} className="mb-6">
        <div className="border border-gray-300 rounded-md overflow-hidden">
          <RichTextEditor
            value={newComment}
            onChange={setNewComment}
            placeholder={language === 'en' ? 'Share your thoughts...' : 'à®‰à®™à¯à®•à®³à¯ à®•à®°à¯à®¤à¯à®¤à¯à®•à®³à¯ˆà®ªà¯ à®ªà®•à®¿à®°à®µà¯à®®à¯...'}
            height="180px"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="mt-2 bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 px-6 rounded-md transition-colors disabled:bg-gray-400"
          data-testid="submit-comment"
        >
          {loading ? (language === 'en' ? 'Posting...' : 'à®‡à®Ÿà¯à®•à¯ˆà®¯à®¿à®Ÿà¯à®•à®¿à®±à®¤à¯...') : (language === 'en' ? 'Post Comment' : 'à®•à®°à¯à®¤à¯à®¤à¯ˆ à®‡à®Ÿà¯à®•à¯ˆà®¯à®¿à®Ÿà®µà¯à®®à¯')}
        </button>
      </form>

      {/* Comments List */}
      <div className="space-y-4">
        {comments.length === 0 ? (
          <p className="text-gray-500 text-center py-8">
            {language === 'en' ? 'No comments yet. Be the first to comment!' : 'à®‡à®©à¯à®©à¯à®®à¯ à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯ à®‡à®²à¯à®²à¯ˆ. à®®à¯à®¤à®²à®¿à®²à¯ à®•à®°à¯à®¤à¯à®¤à¯ à®¤à¯†à®°à®¿à®µà®¿à®•à¯à®•à®µà¯à®®à¯!'}
          </p>
        ) : (
          comments.map((comment) => (
            <div key={comment.id} className="border-b border-gray-200 pb-4" data-testid="comment-item">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                    {comment.user_name[0].toUpperCase()}
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold text-gray-900">{comment.user_name}</span>
                    <span className="text-sm text-gray-500">
                      {new Date(comment.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <p className="mt-1 text-gray-700">{comment.content}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {showAuthModal && (
        <AuthModal
          isLogin={true}
          setIsLogin={() => { }}
          onClose={() => setShowAuthModal(false)}
        />
      )}
    </div>
  );
};

// Home Page
// Recent Posts Section Component
const RecentPostsSection = ({ recentQa = [] }) => {
  const { language } = useAuth();
  const [recentPosts, setRecentPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecentPosts();
  }, []);

  const fetchRecentPosts = async () => {
    try {
      const response = await axios.get(`${API}/blog/posts?limit=3`);
      setRecentPosts(response.data.slice(0, 3));
    } catch (error) {
      console.error('Error fetching recent posts:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading && recentQa.length === 0) return null;

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column: Recent Blog Articles */}
          <div>
            <div className="flex justify-between items-center mb-8 border-b-2 border-green-600 pb-2">
              <h2 className="text-3xl font-bold text-gray-800">
                {language === 'en' ? 'Recent Articles' : 'à®šà®®à¯€à®ªà®¤à¯à®¤à®¿à®¯ à®•à®Ÿà¯à®Ÿà¯à®°à¯ˆà®•à®³à¯'}
              </h2>
              <Link
                to="/blog"
                className="text-green-600 font-semibold hover:text-green-700 hover:underline text-sm uppercase tracking-wider"
              >
                {language === 'en' ? 'View All â†’' : 'à®…à®©à¯ˆà®¤à¯à®¤à¯ˆà®¯à¯à®®à¯ à®•à®¾à®£à¯à®• â†’'}
              </Link>
            </div>

            <div className="flex flex-col gap-6">
              {recentPosts.map((post) => (
                <Link key={post.id} to={`/blog/${post.slug}`} className="block group bg-white p-5 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-600 transition-colors">
                    {language === 'en' ? post.title_en || post.title : post.title_ta || post.title}
                  </h3>
                  <div className="text-sm text-gray-500 font-medium line-clamp-2">
                    {language === 'en' ? post.excerpt_en || post.excerpt : post.excerpt_ta || post.excerpt}
                  </div>
                  <div className="text-xs text-gray-400 mt-2">
                    {new Date(post.published_at || post.created_at).toLocaleDateString(language === 'en' ? 'en-US' : 'ta-IN', {
                      year: 'numeric', month: 'long', day: 'numeric'
                    })}
                  </div>
                </Link>
              ))}
              {recentPosts.length === 0 && (
                <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 text-gray-500 italic">
                  {language === 'en' ? 'More articles coming soon...' : 'à®®à¯‡à®²à¯à®®à¯ à®•à®Ÿà¯à®Ÿà¯à®°à¯ˆà®•à®³à¯ à®µà®¿à®°à¯ˆà®µà®¿à®²à¯...'}
                </div>
              )}
            </div>
          </div>

          {/* Right Column: Live Community Discussions Ticker */}
          <div>
            <div className="flex justify-between items-center mb-8 border-b-2 border-orange-500 pb-2">
              <h2 className="text-3xl font-bold text-gray-800 flex items-center">
                <span className="text-orange-500 mr-2">ðŸ”¥</span>
                {language === 'en' ? 'Community Forum' : 'à®†à®©à¯à®®à¯€à®• à®‰à®°à¯ˆà®¯à®¾à®Ÿà®²à¯à®•à®³à¯'}
              </h2>
              <Link
                to="/qa"
                className="text-orange-600 font-semibold hover:text-orange-700 hover:underline text-sm uppercase tracking-wider"
              >
                {language === 'en' ? 'Join Forum â†’' : 'à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à®®à¯ â†’'}
              </Link>
            </div>

            <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-orange-100 p-6 h-[400px] relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-white to-transparent z-10 pointer-events-none"></div>
              <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent z-10 pointer-events-none"></div>

              <div className="animate-scroll-up absolute w-full px-4" style={{ top: '100%', left: 0 }}>
                {recentQa.length > 0 ? (
                  <div className="flex flex-col gap-4 pb-[100%]">
                    {recentQa.map((qa, index) => (
                      <Link
                        key={index}
                        to="/qa"
                        className="block bg-orange-50/50 hover:bg-orange-100/50 p-4 rounded-xl border border-orange-100 transition-colors"
                      >
                        <h4 className="text-md font-bold text-gray-800 mb-1 leading-snug">
                          {qa.title || (language === 'en' ? 'Discussion Thread' : 'à®†à®©à¯à®®à¯€à®• à®•à¯‡à®³à¯à®µà®¿')}
                        </h4>
                        <div className="flex items-center text-xs text-gray-500 font-medium">
                          <span className="bg-white px-2 py-1 rounded-md border border-gray-200 mr-2">
                            {qa.category || 'General'}
                          </span>
                          <span>ðŸ’¬ {qa.replies_count || 0} Replies</span>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-gray-500 py-10 italic">
                    {language === 'en' ? 'Loading community discussions...' : 'à®‰à®°à¯ˆà®¯à®¾à®Ÿà®²à¯à®•à®³à¯ à®à®±à¯à®±à®ªà¯à®ªà®Ÿà¯à®•à®¿à®©à¯à®±à®©...'}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

// Photo Gallery Section Component
const PhotoGallerySection = () => {
  const { language } = useAuth();

  const galleryImages = [
    {
      url: '/images/artifacts/appakkoodai-b.jpg',
      title_en: 'Traditional Wedding Ceremony',
      title_ta: 'à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯ à®¤à®¿à®°à¯à®®à®£ à®µà®¿à®´à®¾'
    },
    {
      url: '/images/artifacts/56bpevcx_call_from_kasiyathra-b.jpg',
      title_en: 'Upanayanam Ceremony',
      title_ta: 'à®‰à®ªà®¨à®¯à®©à®®à¯ à®µà®¿à®´à®¾'
    },
    {
      url: '/images/artifacts/i4vpkf46_nvs-doing-homam.jpg',
      title_en: 'Sacred Homam',
      title_ta: 'à®ªà¯à®©à®¿à®¤ à®¹à¯‹à®®à®®à¯'
    },
    {
      url: '/images/artifacts/af3nu1b2_nvsparents-s.jpg',
      title_en: 'Temple Services',
      title_ta: 'à®•à¯‹à®µà®¿à®²à¯ à®šà¯‡à®µà¯ˆà®•à®³à¯'
    },
    {
      url: 'https://images.unsplash.com/photo-1532619187608-e5375cab36aa?w=800&q=80',
      title_en: 'Temple Architecture',
      title_ta: 'à®•à¯‹à®µà®¿à®²à¯ à®•à®Ÿà¯à®Ÿà®¿à®Ÿà®•à¯à®•à®²à¯ˆ'
    },
    {
      url: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=800&q=80',
      title_en: 'Divine Offerings',
      title_ta: 'à®¤à¯†à®¯à¯à®µà¯€à®• à®•à®¾à®£à®¿à®•à¯à®•à¯ˆà®•à®³à¯'
    }
  ];

  return (
    <div className="bg-gradient-to-b from-orange-50 to-green-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-green-800 mb-8 text-center">
          {language === 'en' ? 'Photo Gallery' : 'à®ªà¯à®•à¯ˆà®ªà¯à®ªà®Ÿ à®¤à¯Šà®•à¯à®ªà¯à®ªà¯'}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-2xl transition-all duration-300 aspect-square"
            >
              <img
                src={image.url}
                alt={language === 'en' ? image.title_en : image.title_ta}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white font-semibold p-4">
                  {language === 'en' ? image.title_en : image.title_ta}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Home = () => {

  const { language, user } = useAuth();

  const navigate = useNavigate();



  return (

    <DynamicHomePage

      language={language}

      user={user}

      navigate={navigate}

      CommentSection={CommentSection}

      ForgotPasswordModal={ForgotPasswordModal}

    />

  );

};



const FeatureCard = ({ icon, title_en, title_ta, desc_en, desc_ta, link }) => {
  const { language } = useAuth();
  return (
    <Link
      to={link}
      className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-200"
      data-testid="feature-card"
    >
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="text-xl font-bold text-orange-700 mb-2">
        {language === 'en' ? title_en : title_ta}
      </h3>
      <p className="text-gray-600">{language === 'en' ? desc_en : desc_ta}</p>
    </Link>
  );
};

// Vaideekam Page
const VaideekamPage = () => {
  const { language } = useAuth();

  const rituals = [
    {
      title_en: 'Marriage (Vivaha)',
      title_ta: 'à®¤à®¿à®°à¯à®®à®£à®®à¯ (à®µà®¿à®µà®¾à®¹)',
      desc_en: 'Complete procedures for Sri Vaishnava wedding ceremonies',
      desc_ta: 'à®¸à¯à®°à¯€ à®µà¯ˆà®·à¯à®£à®µ à®¤à®¿à®°à¯à®®à®£ à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯à®•à¯à®•à®¾à®© à®®à¯à®´à¯à®®à¯ˆà®¯à®¾à®© à®¨à®Ÿà¯ˆà®®à¯à®±à¯ˆà®•à®³à¯',
      img: '/images/artifacts/appakkoodai-b.jpg',
    },
    {
      title_en: 'Upanayanam (Thread Ceremony)',
      title_ta: 'à®‰à®ªà®¨à®¯à®©à®®à¯ (à®ªà¯‚à®£à¯‚à®²à¯ à®µà®¿à®´à®¾)',
      desc_en: 'Sacred thread ceremony procedures and mantras',
      desc_ta: 'à®ªà¯à®©à®¿à®¤ à®¨à¯‚à®²à¯ à®µà®¿à®´à®¾ à®¨à®Ÿà¯ˆà®®à¯à®±à¯ˆà®•à®³à¯ à®®à®±à¯à®±à¯à®®à¯ à®®à®¨à¯à®¤à®¿à®°à®™à¯à®•à®³à¯',
      img: '/images/artifacts/56bpevcx_call_from_kasiyathra-b.jpg',
    },
    {
      title_en: 'Homam (Fire Ceremony)',
      title_ta: 'à®¹à¯‹à®®à®®à¯ (à®…à®•à¯à®©à®¿ à®šà®Ÿà®™à¯à®•à¯)',
      desc_en: 'Sacred fire rituals for various occasions',
      desc_ta: 'à®ªà®²à¯à®µà¯‡à®±à¯ à®¨à®¿à®•à®´à¯à®µà¯à®•à®³à¯à®•à¯à®•à®¾à®© à®ªà¯à®©à®¿à®¤à®®à®¾à®© à®…à®•à¯à®©à®¿ à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯',
      img: '/images/artifacts/i4vpkf46_nvs-doing-homam.jpg',
    },
    {
      title_en: 'Traditional Services',
      title_ta: 'à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯ à®šà¯‡à®µà¯ˆà®•à®³à¯',
      desc_en: 'Experienced priests for all Vedic ceremonies',
      desc_ta: 'à®…à®©à¯ˆà®¤à¯à®¤à¯ à®µà¯ˆà®¤à¯€à®• à®µà®¿à®´à®¾à®•à¯à®•à®³à¯à®•à¯à®•à¯à®®à¯ à®…à®©à¯à®ªà®µà®®à¯ à®µà®¾à®¯à¯à®¨à¯à®¤ à®ªà¯‚à®šà®¾à®°à®¿à®•à®³à¯',
      img: '/images/artifacts/af3nu1b2_nvsparents-s.jpg',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-green-800 mb-8" data-testid="page-title">
          {language === 'en' ? 'Vedic Rituals (Vaideekam)' : 'à®µà¯ˆà®¤à¯€à®• à®•à®°à¯à®®à®¾'}
        </h1>

        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <p className="text-lg text-gray-700 leading-relaxed">
            {language === 'en'
              ? 'This section provides comprehensive information about various Vedic rituals and ceremonies performed in the Sri Vaishnava tradition. Each ritual is explained with detailed procedures, mantras, and requirements in Sanskrit, Tamil, and English.'
              : 'à®‡à®¨à¯à®¤ à®ªà®¿à®°à®¿à®µà¯ à®¸à¯à®°à¯€ à®µà¯ˆà®·à¯à®£à®µ à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯à®¤à¯à®¤à®¿à®²à¯ à®¨à®¿à®•à®´à¯à®¤à¯à®¤à®ªà¯à®ªà®Ÿà¯à®®à¯ à®ªà®²à¯à®µà¯‡à®±à¯ à®µà¯ˆà®¤à¯€à®• à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯ à®®à®±à¯à®±à¯à®®à¯ à®µà®¿à®´à®¾à®•à¯à®•à®³à¯ à®ªà®±à¯à®±à®¿à®¯ à®µà®¿à®°à®¿à®µà®¾à®© à®¤à®•à®µà®²à¯à®•à®³à¯ˆ à®µà®´à®™à¯à®•à¯à®•à®¿à®±à®¤à¯.'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {rituals.map((ritual, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-testid="ritual-card">
              <div
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${ritual.img}')` }}
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-green-700 mb-2">
                  {language === 'en' ? ritual.title_en : ritual.title_ta}
                </h3>
                <p className="text-gray-600">
                  {language === 'en' ? ritual.desc_en : ritual.desc_ta}
                </p>
              </div>
            </div>
          ))}
        </div>

        <CommentSection pageSlug="vaideekam" />
      </div>
    </div>
  );
};

// Divyadesams Page
const DivyadesamsPage = () => {
  const { language } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-green-800 mb-8" data-testid="page-title">
          {language === 'en' ? '108 Divya Desams' : '108 à®¤à®¿à®µà¯à®¯ à®¤à¯‡à®šà®™à¯à®•à®³à¯'}
        </h1>

        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            {language === 'en'
              ? 'The 108 Divya Desams are the 108 Vishnu temples that are mentioned in the works of the Alvars, the Tamil poet-saints. These temples are located in various parts of India and are considered sacred pilgrimage sites for Sri Vaishnavas.'
              : '108 à®¤à®¿à®µà¯à®¯ à®¤à¯‡à®šà®™à¯à®•à®³à¯ à®Žà®©à¯à®ªà®¤à¯ à®†à®´à¯à®µà®¾à®°à¯à®•à®³à®¿à®©à¯ à®ªà®Ÿà¯ˆà®ªà¯à®ªà¯à®•à®³à®¿à®²à¯ à®•à¯à®±à®¿à®ªà¯à®ªà®¿à®Ÿà®ªà¯à®ªà®Ÿà¯à®Ÿà¯à®³à¯à®³ 108 à®µà®¿à®·à¯à®£à¯ à®•à¯‹à®µà®¿à®²à¯à®•à®³à¯ à®†à®•à¯à®®à¯. à®‡à®¨à¯à®¤ à®•à¯‹à®µà®¿à®²à¯à®•à®³à¯ à®‡à®¨à¯à®¤à®¿à®¯à®¾à®µà®¿à®©à¯ à®ªà®²à¯à®µà¯‡à®±à¯ à®ªà®•à¯à®¤à®¿à®•à®³à®¿à®²à¯ à®…à®®à¯ˆà®¨à¯à®¤à¯à®³à¯à®³à®©.'}
          </p>
          <div className="mt-4 flex justify-center">
            <img
              src="/images/artifacts/m7x85mau_108-dds-Indiamap.jpg"
              alt="108 Divyadesams India Map"
              className="rounded-lg shadow-lg max-w-full h-auto"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {[
            { num: 1, img: 'https://images.unsplash.com/photo-1619239632374-9e6651c2b7bb?w=400&q=80' },
            { num: 2, img: 'https://images.unsplash.com/photo-1762966160822-556deeff018d?w=400&q=80' },
            { num: 3, img: 'https://images.unsplash.com/photo-1595165989697-6c57f7536758?w=400&q=80' },
            { num: 4, img: 'https://images.unsplash.com/photo-1721532865608-c041a31add0e?w=400&q=80' },
            { num: 5, img: 'https://images.unsplash.com/photo-1619239632374-9e6651c2b7bb?w=400&q=80' },
            { num: 6, img: 'https://images.unsplash.com/photo-1762966160822-556deeff018d?w=400&q=80' }
          ].map((temple) => (
            <div key={temple.num} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-testid="temple-card">
              <div
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `url('${temple.img}')` }}
              >
              </div>
              <div className="p-4">
                <h3 className="text-lg font-bold text-green-700 mb-2">
                  {language === 'en' ? `Divya Desam ${temple.num}` : `à®¤à®¿à®µà¯à®¯ à®¤à¯‡à®šà®®à¯ ${temple.num}`}
                </h3>
                <p className="text-gray-600 text-sm">
                  {language === 'en' ? 'Detailed information coming soon...' : 'à®µà®¿à®°à®¿à®µà®¾à®© à®¤à®•à®µà®²à¯ à®µà®¿à®°à¯ˆà®µà®¿à®²à¯...'}
                </p>
              </div>
            </div>
          ))}
        </div>

        <CommentSection pageSlug="divyadesams" />
      </div>
    </div>
  );
};

// Services Page
const ServicesPage = () => {
  const { language } = useAuth();

  const services = [
    {
      title_en: 'Vedic Ceremony Services',
      title_ta: 'à®µà¯ˆà®¤à¯€à®• à®µà®¿à®´à®¾ à®šà¯‡à®µà¯ˆà®•à®³à¯',
      desc_en: 'We arrange experienced priests for all Vedic ceremonies',
      desc_ta: 'à®…à®©à¯ˆà®¤à¯à®¤à¯ à®µà¯ˆà®¤à¯€à®• à®µà®¿à®´à®¾à®•à¯à®•à®³à¯à®•à¯à®•à¯à®®à¯ à®…à®©à¯à®ªà®µà®®à¯ à®µà®¾à®¯à¯à®¨à¯à®¤ à®ªà¯‚à®šà®¾à®°à®¿à®•à®³à¯ˆ à®à®±à¯à®ªà®¾à®Ÿà¯ à®šà¯†à®¯à¯à®•à®¿à®±à¯‹à®®à¯',
    },
    {
      title_en: 'Online Rituals',
      title_ta: 'à®†à®©à¯à®²à¯ˆà®©à¯ à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯',
      desc_en: 'Conduct rituals online via video call from anywhere in the world',
      desc_ta: 'à®‰à®²à®•à®¿à®©à¯ à®Žà®¨à¯à®¤ à®ªà®•à¯à®¤à®¿à®¯à®¿à®²à®¿à®°à¯à®¨à¯à®¤à¯à®®à¯ à®µà¯€à®Ÿà®¿à®¯à¯‹ à®…à®´à¯ˆà®ªà¯à®ªà¯ à®®à¯‚à®²à®®à¯ à®šà®Ÿà®™à¯à®•à¯à®•à®³à¯ˆ à®¨à®Ÿà®¤à¯à®¤à¯à®™à¯à®•à®³à¯',
    },
    {
      title_en: 'Horoscope Services',
      title_ta: 'à®œà®¾à®¤à®• à®šà¯‡à®µà¯ˆà®•à®³à¯',
      desc_en: 'Horoscope matching, predictions, and consultations',
      desc_ta: 'à®œà®¾à®¤à®• à®ªà¯Šà®°à¯à®¤à¯à®¤à®®à¯, à®•à®£à®¿à®ªà¯à®ªà¯à®•à®³à¯ à®®à®±à¯à®±à¯à®®à¯ à®†à®²à¯‹à®šà®©à¯ˆà®•à®³à¯',
    },
    {
      title_en: 'Documentation Support',
      title_ta: 'à®†à®µà®£ à®†à®¤à®°à®µà¯',
      desc_en: 'Preparation of traditional ceremony documents and invitations',
      desc_ta: 'à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯ à®µà®¿à®´à®¾ à®†à®µà®£à®™à¯à®•à®³à¯ à®®à®±à¯à®±à¯à®®à¯ à®…à®´à¯ˆà®ªà¯à®ªà®¿à®¤à®´à¯à®•à®³à¯ à®¤à®¯à®¾à®°à®¿à®ªà¯à®ªà¯',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-green-800 mb-8" data-testid="page-title">
          {language === 'en' ? 'Our Services' : 'à®Žà®™à¯à®•à®³à¯ à®šà¯‡à®µà¯ˆà®•à®³à¯'}
        </h1>

        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <p className="text-lg text-gray-700 leading-relaxed">
            {language === 'en'
              ? 'Ahobilam.com provides comprehensive religious services to the Sri Vaishnava community worldwide. Our experienced team ensures authentic and traditional ceremonies conducted with proper procedures.'
              : 'à®…à®¹à¯‹à®ªà®¿à®²à®®à¯.à®•à®¾à®®à¯ à®‰à®²à®•à®³à®µà®¿à®²à¯ à®¸à¯à®°à¯€ à®µà¯ˆà®·à¯à®£à®µ à®šà®®à¯‚à®•à®¤à¯à®¤à®¿à®±à¯à®•à¯ à®µà®¿à®°à®¿à®µà®¾à®© à®†à®©à¯à®®à¯€à®• à®¸à¯‡à®µà¯ˆà®•à®³à¯ˆ à®µà®´à®™à¯à®•à¯à®•à®¿à®±à®¤à¯.'}
          </p>
        </div>

        {/* Astrology Partner Advert Banner */}
        <div className="mb-12 bg-gradient-to-br from-[#FAF6EE] via-[#FDF8ED] to-[#F5EDDA] rounded-2xl shadow-xl border-2 border-[#D4AF37] p-6 sm:p-8 relative overflow-hidden">
          <div className="absolute -right-12 -top-12 bg-[#CC6600]/10 w-48 h-48 rounded-full blur-2xl pointer-events-none"></div>
          
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8 pb-6 border-b border-[#D4AF37]/30">
            <div>
              <div className="inline-flex items-center gap-2 bg-[#CC6600] text-white px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase mb-3 shadow-sm">
                <span>ðŸŒŸ</span> {language === 'en' ? 'Astrology Partnership Opportunity' : 'à®œà¯‹à®¤à®¿à®Ÿà®•à¯ à®•à¯‚à®Ÿà¯à®Ÿà®¾à®£à¯à®®à¯ˆ à®µà®¾à®¯à¯à®ªà¯à®ªà¯'}
              </div>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-[#1A237E] tracking-tight">
                {language === 'en' ? 'Become Partners â€” 30% Rebate For You!' : 'à®œà¯‹à®¤à®¿à®Ÿà®•à¯ à®•à¯‚à®Ÿà¯à®Ÿà®¾à®³à®°à®¾à®•à¯à®™à¯à®•à®³à¯ â€” 30% à®šà®²à¯à®•à¯ˆ à®‰à®™à¯à®•à®³à¯à®•à¯à®•à¯‡!'}
              </h2>
              <p className="text-gray-700 text-base sm:text-lg mt-2 max-w-2xl">
                {language === 'en'
                  ? 'Join our esteemed network of Astrology Partners! Earn high returns by providing authentic Vedic astrology reports to your local community.'
                  : 'à®Žà®™à¯à®•à®³à®¿à®©à¯ à®®à®¤à®¿à®ªà¯à®ªà¯à®®à®¿à®•à¯à®• à®œà¯‹à®¤à®¿à®Ÿà®•à¯ à®•à¯‚à®Ÿà¯à®Ÿà®¾à®³à®°à¯ à®…à®®à¯ˆà®ªà¯à®ªà®¿à®²à¯ à®‡à®£à¯ˆà®¯à¯à®™à¯à®•à®³à¯! à®‰à®™à¯à®•à®³à¯ à®ªà®•à¯à®¤à®¿à®¯à®¿à®²à¯ à®‰à®£à¯à®®à¯ˆà®¯à®¾à®© à®µà¯ˆà®¤à¯€à®• à®œà¯‹à®¤à®¿à®Ÿ à®šà¯‡à®µà¯ˆà®•à®³à¯ˆ à®µà®´à®™à¯à®•à®¿ 30% à®šà®²à¯à®•à¯ˆ à®ªà¯†à®±à¯à®™à¯à®•à®³à¯.'}
              </p>
            </div>
            <Link
              to="/partner-registration"
              className="bg-gradient-to-r from-[#CC6600] to-[#E65100] hover:from-[#E65100] hover:to-[#CC6600] text-white px-8 py-4 rounded-xl font-extrabold text-lg shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-0.5 whitespace-nowrap text-center"
            >
              {language === 'en' ? 'Register as Partner Now â†’' : 'à®•à¯‚à®Ÿà¯à®Ÿà®¾à®³à®°à®¾à®• à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯ â†’'}
            </Link>
          </div>

          {/* Pricing Grid */}
          <div className="mb-8">
            <h3 className="text-xl font-bold text-[#1A237E] mb-4 flex items-center gap-2">
              <span>ðŸ“Š</span> {language === 'en' ? 'Astrology Service Pricing Rates:' : 'à®œà¯‹à®¤à®¿à®Ÿ à®šà¯‡à®µà¯ˆ à®•à®Ÿà¯à®Ÿà®£ à®µà®¿à®µà®°à®™à¯à®•à®³à¯:'}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-xl p-5 border border-[#D4AF37]/40 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-2xl mb-1">ðŸ“œ</div>
                <h4 className="font-bold text-gray-900 text-base mb-1">
                  {language === 'en' ? 'Horoscope Casting' : 'à®œà®¾à®¤à®•à®®à¯ à®•à®£à®¿à®¤à¯à®¤à®²à¯'}
                </h4>
                <div className="text-2xl font-black text-[#CC6600]">â‚¹100 /-</div>
                <p className="text-xs text-gray-500 mt-1">
                  {language === 'en' ? 'Accurate planetary positions & chart' : 'à®¤à¯à®²à¯à®²à®¿à®¯à®®à®¾à®© à®•à®¿à®°à®• à®¨à®¿à®²à¯ˆà®•à®³à¯ & à®•à®£à®¿à®ªà¯à®ªà¯'}
                </p>
              </div>

              <div className="bg-white rounded-xl p-5 border border-[#D4AF37]/40 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-2xl mb-1">ðŸ’‘</div>
                <h4 className="font-bold text-gray-900 text-base mb-1">
                  {language === 'en' ? 'Horoscope Matching' : 'à®œà®¾à®¤à®• à®ªà¯Šà®°à¯à®¤à¯à®¤à®®à¯'}
                </h4>
                <div className="text-2xl font-black text-[#CC6600]">â‚¹200 /-</div>
                <p className="text-xs text-gray-500 mt-1">
                  {language === 'en' ? 'Comprehensive 10-porutham analysis' : 'à®ªà®¤à¯à®¤à¯ à®ªà¯Šà®°à¯à®¤à¯à®¤à®™à¯à®•à®³à¯ à®µà®¿à®°à®¿à®µà®¾à®© à®†à®¯à¯à®µà¯'}
                </p>
              </div>

              <div className="bg-white rounded-xl p-5 border border-[#D4AF37]/40 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-2xl mb-1">ðŸ”®</div>
                <h4 className="font-bold text-gray-900 text-base mb-1">
                  {language === 'en' ? 'Casting with Live Phalans' : 'à®œà®¾à®¤à®•à®®à¯ + à®¨à¯‡à®°à®Ÿà®¿ à®ªà®²à®©à¯à®•à®³à¯'}
                </h4>
                <div className="text-2xl font-black text-[#CC6600]">â‚¹300 /-</div>
                <p className="text-xs text-gray-500 mt-1">
                  {language === 'en' ? 'Chart casting with detailed predictions' : 'à®œà®¾à®¤à®• à®•à®£à®¿à®ªà¯à®ªà¯à®Ÿà®©à¯ à®µà®¿à®°à®¿à®µà®¾à®© à®ªà®²à®©à¯à®•à®³à¯'}
                </p>
              </div>

              <div className="bg-white rounded-xl p-5 border border-[#D4AF37]/40 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-2xl mb-1">ðŸ“–</div>
                <h4 className="font-bold text-gray-900 text-base mb-1">
                  {language === 'en' ? 'Traditional Book Casting' : 'à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯ à®œà®¾à®¤à®• à®ªà¯à®¤à¯à®¤à®•à®®à¯ + à®ªà®²à®©à¯'}
                </h4>
                <div className="text-2xl font-black text-[#CC6600]">â‚¹400 /-</div>
                <p className="text-xs text-gray-500 mt-1">
                  {language === 'en' ? 'Full authentic book format with predictions' : 'à®®à¯à®´à¯à®®à¯ˆà®¯à®¾à®© à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯ à®ªà¯à®¤à¯à®¤à®• à®µà®Ÿà®¿à®µà®®à¯'}
                </p>
              </div>
            </div>
          </div>

          {/* Requirements & Callout Box */}
          <div className="bg-white/80 rounded-xl p-5 border border-[#2D5A1E]/30 flex flex-col sm:flex-row items-center justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <div className="bg-[#2D5A1E]/10 p-3 rounded-full text-[#2D5A1E] text-xl font-bold flex-shrink-0">
                ðŸ–¥ï¸
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-base">
                  {language === 'en' ? 'What You Need to Start:' : 'à®¨à¯€à®™à¯à®•à®³à¯ à®¤à¯Šà®Ÿà®™à¯à®• à®¤à¯‡à®µà¯ˆà®¯à®¾à®©à®µà¯ˆ:'}
                </h4>
                <p className="text-sm text-gray-700">
                  {language === 'en'
                    ? 'Just an Internet connection and a good printer with A4 papers.'
                    : 'à®‡à®£à¯ˆà®¯ à®‡à®£à¯ˆà®ªà¯à®ªà¯ à®®à®±à¯à®±à¯à®®à¯ A4 à®¤à®¾à®³à¯à®•à®³à¯à®Ÿà®©à¯ à®•à¯‚à®Ÿà®¿à®¯ à®’à®°à¯ à®¨à®²à¯à®² à®ªà®¿à®°à®¿à®£à¯à®Ÿà®°à¯ à®®à®Ÿà¯à®Ÿà¯à®®à¯‡ à®ªà¯‹à®¤à¯à®®à®¾à®©à®¤à¯.'}
                </p>
              </div>
            </div>

            <div className="bg-[#FAF6EE] px-4 py-2 rounded-lg border border-[#D4AF37]/50 text-center sm:text-right flex-shrink-0">
              <span className="text-xs text-gray-600 font-bold block uppercase tracking-wider">
                {language === 'en' ? 'Partner Benefit' : 'à®•à¯‚à®Ÿà¯à®Ÿà®¾à®³à®°à¯ à®ªà®²à®©à¯'}
              </span>
              <span className="text-sm font-extrabold text-[#CC6600]">
                {language === 'en' ? '30% Rebate on All Astro Products' : 'à®…à®©à¯ˆà®¤à¯à®¤à¯ à®œà¯‹à®¤à®¿à®Ÿ à®ªà¯Šà®°à¯à®Ÿà¯à®•à®³à¯à®•à¯à®•à¯à®®à¯ 30% à®šà®²à¯à®•à¯ˆ'}
              </span>
            </div>
          </div>

          {/* Partner Membership & Deposit Terms */}
          <div className="bg-[#FAF6EE] rounded-xl p-5 border-2 border-[#D4AF37]/60 shadow-sm">
            <h4 className="text-lg font-extrabold text-[#1A237E] mb-3 flex items-center gap-2">
              <span>ðŸ“œ</span> {language === 'en' ? 'Partner Login & Refundable Security Deposit Terms:' : 'à®•à¯‚à®Ÿà¯à®Ÿà®¾à®³à®°à¯ à®•à®£à®•à¯à®•à¯ & à®®à¯à®©à¯à®ªà®£ à®µà®¿à®¤à®®à¯à®±à¯ˆà®•à®³à¯:'}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div className="bg-white p-4 rounded-xl border border-[#D4AF37]/40 shadow-sm flex items-start gap-3">
                <span className="text-2xl">ðŸ’³</span>
                <div>
                  <h5 className="font-bold text-[#CC6600] text-base mb-1">
                    {language === 'en' ? '1. â‚¹1,000/- Advance Refundable Security Deposit' : '1. â‚¹1,000/- à®¤à®¿à®°à¯à®®à¯à®ªà®ªà¯à®ªà¯†à®±à®¤à¯à®¤à®•à¯à®• à®®à¯à®©à¯à®ªà®£à®®à¯'}
                  </h5>
                  <p className="text-gray-700 leading-relaxed text-xs sm:text-sm">
                    {language === 'en'
                      ? 'A refundable security deposit of â‚¹1,000/- must be paid in advance to obtain your exclusive Partner Login. Only via Partner Login can you claim the 30% rebate on the spot. On every calculation attempt, partners pay just 70% of the fee, and printing/downloading is immediately enabled after each successful 70% payment.'
                      : 'à®•à¯‚à®Ÿà¯à®Ÿà®¾à®³à®°à¯ à®•à®£à®•à¯à®•à¯ (Partner Login) à®ªà¯†à®± â‚¹1,000/- à®¤à®¿à®°à¯à®®à¯à®ªà®ªà¯à®ªà¯†à®±à®¤à¯à®¤à®•à¯à®• à®®à¯à®©à¯à®ªà®£à®®à¯ à®šà¯†à®²à¯à®¤à¯à®¤ à®µà¯‡à®£à¯à®Ÿà¯à®®à¯. à®²à®¾à®•à®¿à®©à¯ à®®à¯‚à®²à®®à¯ à®®à®Ÿà¯à®Ÿà¯à®®à¯‡ 30% à®šà®²à¯à®•à¯ˆ à®‰à®Ÿà®©à¯à®•à¯à®•à¯à®Ÿà®©à¯ à®•à®¿à®Ÿà¯ˆà®•à¯à®•à¯à®®à¯. à®’à®µà¯à®µà¯Šà®°à¯ à®•à®£à®¿à®ªà¯à®ªà®¿à®±à¯à®•à¯à®®à¯ 70% à®•à®Ÿà¯à®Ÿà®£à®®à¯ à®®à®Ÿà¯à®Ÿà¯à®®à¯ à®šà¯†à®²à¯à®¤à¯à®¤à®¿, à®µà¯†à®±à¯à®±à®¿à®•à®°à®®à®¾à®© à®•à®Ÿà¯à®Ÿà®£ à®®à¯à®Ÿà®¿à®µà®¿à®²à¯ à®‰à®Ÿà®©à®Ÿà®¿à®¯à®¾à®•à®ªà¯ à®ªà®¿à®°à®¤à®¿à®¯à¯ˆ à®…à®šà¯à®šà®¿à®Ÿà®²à®¾à®®à¯.'}
                  </p>
                </div>
              </div>

              <div className="bg-white p-4 rounded-xl border border-[#D4AF37]/40 shadow-sm flex items-start gap-3">
                <span className="text-2xl">ðŸ”„</span>
                <div>
                  <h5 className="font-bold text-[#2D5A1E] text-base mb-1">
                    {language === 'en' ? '2. Deposit Refund Eligibility (Min. â‚¹700/- Business)' : '2. à®®à¯à®©à¯à®ªà®£à®®à¯ à®¤à®¿à®°à¯à®®à¯à®ªà®ªà¯ à®ªà¯†à®±à¯à®®à¯ à®¤à®•à¯à®¤à®¿ (à®•à¯à®±à¯ˆà®¨à¯à®¤à®ªà®Ÿà¯à®šà®®à¯ â‚¹700/- à®µà®£à®¿à®•à®®à¯)'}
                  </h5>
                  <p className="text-gray-700 leading-relaxed text-xs sm:text-sm">
                    {language === 'en'
                      ? 'Your â‚¹1,000/- advance security deposit is 100% eligible for refund after achieving a cumulative net business worth of at least â‚¹700/- in total.'
                      : 'à®¨à¯€à®™à¯à®•à®³à¯ à®ˆà®Ÿà¯à®Ÿà¯à®®à¯ à®®à¯Šà®¤à¯à®¤ à®µà®£à®¿à®• à®®à®¤à®¿à®ªà¯à®ªà¯ à®•à¯à®±à¯ˆà®¨à¯à®¤à®ªà®Ÿà¯à®šà®®à¯ â‚¹700/- à® à®Žà®Ÿà¯à®Ÿà®¿à®¯à®µà¯à®Ÿà®©à¯, à®¨à¯€à®™à¯à®•à®³à¯ à®šà¯†à®²à¯à®¤à¯à®¤à®¿à®¯ â‚¹1,000/- à®®à¯à®©à¯à®ªà®£à®®à¯ à®®à¯à®´à¯à®®à¯ˆà®¯à®¾à®• à®‰à®™à¯à®•à®³à¯à®•à¯à®•à¯à®¤à¯ à®¤à®¿à®°à¯à®®à¯à®ª à®µà®´à®™à¯à®•à®ªà¯à®ªà®Ÿà¯à®®à¯.'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bookable Services */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-orange-600 mb-6">
            {language === 'en' ? 'Book Our Services Online' : 'à®Žà®™à¯à®•à®³à¯ à®šà¯‡à®µà¯ˆà®•à®³à¯ˆ à®†à®©à¯à®²à¯ˆà®©à®¿à®²à¯ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à¯à®™à¯à®•à®³à¯'}
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <Link to="/services/marriage-garland" className="group">
              <div className="bg-gradient-to-br from-pink-50 to-orange-50 rounded-lg shadow-md p-6 hover:shadow-xl transition-all border-l-4 border-pink-600 h-full">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-2xl font-bold text-pink-700 mb-3 group-hover:text-pink-800">
                      ðŸ’ {language === 'en' ? 'Marriage Garland Service' : 'à®¤à®¿à®°à¯à®®à®£ à®®à®¾à®²à¯ˆ à®šà¯‡à®µà¯ˆ'}
                    </h3>
                    <p className="text-gray-700 mb-4">
                      {language === 'en'
                        ? 'Traditional sacred garlands for your auspicious wedding ceremony. Delivered fresh on your special day.'
                        : 'à®‰à®™à¯à®•à®³à¯ à®®à®™à¯à®•à®³ à®¤à®¿à®°à¯à®®à®£ à®µà®¿à®´à®¾à®µà®¿à®±à¯à®•à®¾à®© à®ªà®¾à®°à®®à¯à®ªà®°à®¿à®¯ à®ªà¯à®©à®¿à®¤ à®®à®¾à®²à¯ˆà®•à®³à¯. à®‰à®™à¯à®•à®³à¯ à®šà®¿à®±à®ªà¯à®ªà¯ à®¨à®¾à®³à®¿à®²à¯ à®ªà¯à®¤à®¿à®¤à®¾à®• à®µà®´à®™à¯à®•à®ªà¯à®ªà®Ÿà¯à®®à¯.'}
                    </p>
                    <div className="text-sm text-gray-600 mb-4">
                      <span className="font-semibold">{language === 'en' ? 'Starting from:' : 'à®¤à¯Šà®Ÿà®™à¯à®•à¯à®®à¯ à®µà®¿à®²à¯ˆ:'}</span> â‚¹5,000
                    </div>
                    <span className="inline-block bg-pink-600 text-white px-6 py-2 rounded-lg font-semibold group-hover:bg-pink-700 transition">
                      {language === 'en' ? 'Book Now â†’' : 'à®‡à®ªà¯à®ªà¯‹à®¤à¯ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à¯à®™à¯à®•à®³à¯ â†’'}
                    </span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/services/archanai" className="group">
              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-lg shadow-md p-6 hover:shadow-xl transition-all border-l-4 border-orange-600 h-full">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-2xl font-bold text-orange-700 mb-3 group-hover:text-orange-800">
                      ðŸ™ {language === 'en' ? 'Remote Archanai Service' : 'à®¤à¯Šà®²à¯ˆ à®…à®°à¯à®šà¯à®šà®©à¯ˆ à®šà¯‡à®µà¯ˆ'}
                    </h3>
                    <p className="text-gray-700 mb-4">
                      {language === 'en'
                        ? 'Temple archana performed by qualified priests. Receive prasadam and video recording at your home.'
                        : 'à®¤à®•à¯à®¤à®¿à®¯à®¾à®© à®•à¯à®°à¯à®®à®¾à®°à¯à®•à®³à®¾à®²à¯ à®•à¯‹à®µà®¿à®²à¯ à®…à®°à¯à®šà¯à®šà®©à¯ˆ à®¨à®¿à®•à®´à¯à®¤à¯à®¤à®ªà¯à®ªà®Ÿà¯à®®à¯. à®ªà®¿à®°à®šà®¾à®¤à®®à¯ à®®à®±à¯à®±à¯à®®à¯ à®µà¯€à®Ÿà®¿à®¯à¯‹ à®ªà®¤à®¿à®µà¯ à®‰à®™à¯à®•à®³à¯ à®µà¯€à®Ÿà¯à®Ÿà®¿à®²à¯ à®ªà¯†à®±à¯à®™à¯à®•à®³à¯.'}
                    </p>
                    <div className="text-sm text-gray-600 mb-4">
                      <span className="font-semibold">{language === 'en' ? 'Starting from:' : 'à®¤à¯Šà®Ÿà®™à¯à®•à¯à®®à¯ à®µà®¿à®²à¯ˆ:'}</span> â‚¹400
                    </div>
                    <span className="inline-block bg-orange-600 text-white px-6 py-2 rounded-lg font-semibold group-hover:bg-orange-700 transition">
                      {language === 'en' ? 'Book Now â†’' : 'à®‡à®ªà¯à®ªà¯‹à®¤à¯ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à¯à®™à¯à®•à®³à¯ â†’'}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* General Services */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-green-700 mb-6">
            {language === 'en' ? 'Other Services' : 'à®®à®±à¯à®± à®šà¯‡à®µà¯ˆà®•à®³à¯'}
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow border-l-4 border-green-600" data-testid="service-card">
                <h3 className="text-xl font-bold text-orange-600 mb-3">
                  {language === 'en' ? service.title_en : service.title_ta}
                </h3>
                <p className="text-gray-600">
                  {language === 'en' ? service.desc_en : service.desc_ta}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 bg-green-100 border-l-4 border-green-600 p-6 rounded-lg">
          <h3 className="text-xl font-bold text-green-800 mb-2">
            {language === 'en' ? 'Contact Us' : 'à®Žà®™à¯à®•à®³à¯ˆ à®¤à¯Šà®Ÿà®°à¯à®ªà¯ à®•à¯Šà®³à¯à®³à¯à®™à¯à®•à®³à¯'}
          </h3>
          <p className="text-gray-700">
            {language === 'en'
              ? 'For service inquiries, please leave a comment below or email us at svknvs@gmail.com'
              : 'à®šà¯‡à®µà¯ˆ à®µà®¿à®šà®¾à®°à®£à¯ˆà®•à®³à¯à®•à¯à®•à¯, à®•à¯€à®´à¯‡ à®’à®°à¯ à®•à®°à¯à®¤à¯à®¤à¯ˆ à®µà®¿à®Ÿà¯à®Ÿà¯à®µà®¿à®Ÿà®µà¯à®®à¯ à®…à®²à¯à®²à®¤à¯ svknvs@gmail.com à®•à¯à®•à¯ à®®à®¿à®©à¯à®©à®žà¯à®šà®²à¯ à®…à®©à¯à®ªà¯à®ªà®µà¯à®®à¯'}
          </p>
        </div>

        <CommentSection pageSlug="services" />
      </div>
    </div>
  );
};

// Footer Component
const Footer = () => {
  const { language } = useAuth();
  return (
    <footer className="bg-gradient-to-r from-green-800 to-green-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-3">
              {language === 'en' ? 'About' : 'à®ªà®±à¯à®±à®¿'}
            </h3>
            <p className="text-green-100 text-sm">
              {language === 'en'
                ? 'Serving the Sri Vaishnava community since August 19, 1989 with authentic Vedic knowledge, Dharma Sastram guides, Panchangam tools, and religious services.'
                : '1989 à®†à®•à®¸à¯à®Ÿà¯ 19 à®†à®®à¯ à®¤à¯‡à®¤à®¿ à®®à¯à®¤à®²à¯ à®¸à¯à®°à¯€ à®µà¯ˆà®·à¯à®£à®µ à®šà®®à¯‚à®•à®¤à¯à®¤à®¿à®±à¯à®•à¯ à®µà¯‡à®¤ à®…à®±à®¿à®µà¯, à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯, à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯ à®•à®°à¯à®µà®¿à®•à®³à¯ à®®à®±à¯à®±à¯à®®à¯ à®†à®©à¯à®®à¯€à®• à®¸à¯‡à®µà¯ˆà®•à®³à¯à®Ÿà®©à¯ à®šà¯‡à®µà¯ˆ à®šà¯†à®¯à¯à®¤à¯ à®µà®°à¯à®•à®¿à®±à®¤à¯.'}
            </p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-3">
              {language === 'en' ? 'Quick Links' : 'à®µà®¿à®°à¯ˆà®µà¯ à®‡à®£à¯ˆà®ªà¯à®ªà¯à®•à®³à¯'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Home' : 'à®®à¯à®•à®ªà¯à®ªà¯'}
                </Link>
              </li>
              <li>
                <Link to="/vaideekam" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Vedic Rituals' : 'à®µà¯ˆà®¤à¯€à®• à®•à®°à¯à®®à®¾'}
                </Link>
              </li>
              <li>
                <Link to="/divyadesams" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Divyadesams' : 'à®¤à®¿à®µà¯à®¯à®¤à¯‡à®šà®™à¯à®•à®³à¯'}
                </Link>
              </li>
              <li>
                <Link to="/dharma-sastram" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Dharma Sastram' : 'à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯'}
                </Link>
              </li>
              <li>
                <Link to="/panchangam" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Panchangam' : 'à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯'}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-3">
              {language === 'en' ? 'Legal' : 'à®šà®Ÿà¯à®Ÿ à®µà®¿à®µà®°à®™à¯à®•à®³à¯'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Privacy Policy' : 'à®¤à®©à®¿à®¯à¯à®°à®¿à®®à¯ˆà®•à¯ à®•à¯Šà®³à¯à®•à¯ˆ'}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Terms of Service' : 'à®šà¯‡à®µà¯ˆ à®µà®¿à®¤à®¿à®®à¯à®±à¯ˆà®•à®³à¯'}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Contact Us' : 'à®Žà®™à¯à®•à®³à¯ˆ à®¤à¯Šà®Ÿà®°à¯à®ªà¯ à®•à¯Šà®³à¯à®³à¯à®™à¯à®•à®³à¯'}
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="text-green-100 hover:text-yellow-300 transition-colors">
                  {language === 'en' ? 'Sitemap' : 'à®¤à®³ à®µà®°à¯ˆà®ªà®Ÿà®®à¯'}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-3">
              {language === 'en' ? 'Contact' : 'à®¤à¯Šà®Ÿà®°à¯à®ªà¯'}
            </h3>
            <p className="text-green-100 text-sm">Email: svknvs@gmail.com</p>
            <p className="text-green-100 text-sm mt-2">
              {language === 'en' ? 'Free for all. Donations welcome.' : 'à®…à®©à¯ˆà®µà®°à¯à®•à¯à®•à¯à®®à¯ à®‡à®²à®µà®šà®®à¯. à®¨à®©à¯à®•à¯Šà®Ÿà¯ˆà®•à®³à¯ à®µà®°à®µà¯‡à®±à¯à®•à®ªà¯à®ªà®Ÿà¯à®•à®¿à®©à¯à®±à®©.'}
            </p>
            <Link to="/donate" className="inline-block mt-3 px-4 py-2 bg-yellow-600 hover:bg-yellow-500 text-white text-sm font-semibold rounded-lg transition-colors">
              {language === 'en' ? 'ðŸ™ Donate' : 'ðŸ™ à®¨à®©à¯à®•à¯Šà®Ÿà¯ˆ'}
            </Link>
          </div>
        </div>
        <div className="border-t border-green-700 mt-8 pt-6 text-center text-sm text-green-200">
          <p>Â© 1989-2026 Ahobilam.com. {language === 'en' ? 'All rights reserved.' : 'à®…à®©à¯ˆà®¤à¯à®¤à¯ à®‰à®°à®¿à®®à¯ˆà®•à®³à¯à®®à¯ à®ªà®¾à®¤à¯à®•à®¾à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®Ÿà®µà¯ˆ.'}</p>
          <p className="mt-2 text-xs text-green-300">
            <Link to="/privacy-policy" className="hover:text-yellow-300 transition-colors">Privacy Policy</Link>
            {' Â· '}
            <Link to="/terms" className="hover:text-yellow-300 transition-colors">Terms of Service</Link>
            {' Â· '}
            <Link to="/contact" className="hover:text-yellow-300 transition-colors">Contact</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

// Blog Listing Page
const BlogPage = () => {
  const { language } = useAuth();
  const [searchParams] = useSearchParams();
  const categoryFilter = searchParams.get('category');
  
  const [allPosts, setAllPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogData();
  }, []);

  const fetchBlogData = async () => {
    try {
      const [postsRes, catsRes] = await Promise.all([
        axios.get(`${API}/blog/posts`),
        axios.get(`${API}/blog/categories`)
      ]);
      // Deduplicate posts (WordPress migration created duplicates with same wp_id)
      setAllPosts(deduplicatePosts(postsRes.data));
      setCategories(catsRes.data);
    } catch (error) {
      console.error('Error fetching blog:', error);
    } finally {
      setLoading(false);
    }
  };

  const displayedPosts = categoryFilter
    ? allPosts.filter(p => p.categories && p.categories.some(c => c.slug === categoryFilter))
    : allPosts;
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center">
        <div className="text-2xl text-green-700">Loading blog posts...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-green-800 mb-8" data-testid="page-title">
          {language === 'en' ? 'Blog' : 'à®µà®²à¯ˆà®ªà¯à®ªà®¤à®¿à®µà¯'}
        </h1>

        {/* Categories - Horizontal Scroll */}
        {categories.length > 0 && (
          <div className="mb-8 overflow-x-auto scrollbar-hide -mx-4 px-4" style={{ WebkitOverflowScrolling: 'touch' }}>
            <div className="flex space-x-3 items-center whitespace-nowrap py-2">
              <Link
                to="/blog"
                className={`inline-block px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 border shadow-sm flex-shrink-0 ${
                  !categoryFilter
                    ? 'bg-green-700 text-white border-green-700 shadow-green-200'
                    : 'bg-white text-green-700 border-green-300 hover:bg-green-50 hover:border-green-400'
                }`}
              >
                {language === 'en' ? 'ðŸ  All' : 'ðŸ  à®…à®©à¯ˆà®¤à¯à®¤à¯à®®à¯'}
              </Link>
              {[...new Map(categories.map(c => [c.slug, c])).values()].map((cat) => (
                <Link
                  key={cat.id || cat.slug}
                  to={`/blog?category=${cat.slug}`}
                  className={`inline-block px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 border shadow-sm flex-shrink-0 ${
                    categoryFilter === cat.slug
                      ? 'bg-orange-500 text-white border-orange-500 shadow-orange-200'
                      : 'bg-white text-green-700 border-green-300 hover:bg-green-50 hover:border-green-400'
                  }`}
                >
                  {language === 'ta' && cat.name_ta ? cat.name_ta : cat.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Blog Posts Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow"
              data-testid="blog-card"
            >
              <div className="p-6">
                <h2 className="text-xl font-bold text-green-700 mb-2 line-clamp-2">
                  {post.title}
                </h2>
                <div className="text-sm text-gray-500 mb-3">
                  {new Date(post.published_at).toLocaleDateString(language === 'en' ? 'en-US' : 'ta-IN', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>
                {post.excerpt && (
                  <div
                    className="text-gray-600 text-sm line-clamp-3"
                    dangerouslySetInnerHTML={{ __html: cleanWordPressContent(post.excerpt) }}
                  />
                )}
                <div className="mt-4 flex items-center text-orange-600 font-medium text-sm">
                  {language === 'en' ? 'Read More' : 'à®®à¯‡à®²à¯à®®à¯ à®µà®¾à®šà®¿à®•à¯à®•'} â†’
                </div>
              </div>
            </Link>
          ))}
        </div>

        {displayedPosts.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            {language === 'en' ? 'No posts found.' : 'à®‡à®Ÿà¯à®•à¯ˆà®•à®³à¯ à®‡à®²à¯à®²à¯ˆ.'}
          </div>
        )}
      </div>
    </div>
  );
};

// Individual Blog Post Page
// Social Share Buttons Component
const ShareButtons = ({ post, language, compact = false }) => {
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);

  const currentUrl = window.location.href;
  const title = language === 'en' ? post.title_en : post.title_ta;
  const excerpt = language === 'en' ? post.excerpt_en : post.excerpt_ta;

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(title)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(title + ' - ' + currentUrl)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(excerpt + '\n\n' + currentUrl)}`
  };

  const copyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setShowCopyTooltip(true);
    setTimeout(() => setShowCopyTooltip(false), 2000);
  };

  const buttonClass = compact
    ? "flex items-center justify-center w-8 h-8 rounded-full transition-all hover:scale-110"
    : "flex items-center space-x-2 px-4 py-2 rounded-lg transition-all hover:scale-105";

  return (
    <div className={`flex ${compact ? 'items-center space-x-2' : 'flex-wrap gap-3'}`}>
      <span className={`${compact ? 'text-xs' : 'text-sm'} font-medium text-gray-600 mr-2`}>
        {language === 'en' ? 'Share:' : 'à®ªà®•à®¿à®°à¯:'}
      </span>


      {/* Facebook - Removed (blocked by browser) */}

      {/* Twitter/X */}
      <a
        href={shareLinks.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className={`${buttonClass} bg-black text-white hover:bg-gray-800`}
        title="Share on Twitter/X"
      >
        <svg className={compact ? 'w-4 h-4' : 'w-5 h-5'} fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
        {!compact && <span className="text-xs font-medium">Twitter</span>}
      </a>

      {/* WhatsApp */}
      <a
        href={shareLinks.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className={`${buttonClass} bg-green-500 text-white hover:bg-green-600`}
        title="Share on WhatsApp"
      >
        <svg className={compact ? 'w-4 h-4' : 'w-5 h-5'} fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
        {!compact && <span className="text-xs font-medium">WhatsApp</span>}
      </a>

      {/* LinkedIn */}
      <a
        href={shareLinks.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className={`${buttonClass} bg-blue-700 text-white hover:bg-blue-800`}
        title="Share on LinkedIn"
      >
        <svg className={compact ? 'w-4 h-4' : 'w-5 h-5'} fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
        {!compact && <span className="text-xs font-medium">LinkedIn</span>}
      </a>

      {/* Email */}
      <a
        href={shareLinks.email}
        className={`${buttonClass} bg-orange-600 text-white hover:bg-orange-700`}
        title="Share via Email"
      >
        <svg className={compact ? 'w-4 h-4' : 'w-5 h-5'} fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
        {!compact && <span className="text-xs font-medium">Email</span>}
      </a>

      {/* Copy Link */}
      <button
        onClick={copyLink}
        className={`${buttonClass} bg-gray-600 text-white hover:bg-gray-700 relative`}
        title="Copy Link"
      >
        <svg className={compact ? 'w-4 h-4' : 'w-5 h-5'} fill="currentColor" viewBox="0 0 24 24">
          <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
        </svg>
        {!compact && <span className="text-xs font-medium">Copy</span>}
        {showCopyTooltip && (
          <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap">
            {language === 'en' ? 'Copied!' : 'à®¨à®•à®²à¯†à®Ÿà¯à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®Ÿà®¤à¯!'}
          </span>
        )}
      </button>
    </div>
  );
};

const BlogPostPage = () => {
  const { slug } = useParams();
  const { language, user } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const canEdit = user && (user.role === 'admin' || user.role === 'moderator');

  console.log('ðŸ“ BlogPostPage - User:', user?.email, 'Role:', user?.role, 'canEdit:', canEdit);

  useEffect(() => {
    fetchPost();
  }, [slug]);

  const fetchPost = async () => {
    try {
      const response = await axios.get(`${API}/blog/post/${slug}`);
      setPost(response.data);
    } catch (error) {
      console.error('Error fetching post:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center">
        <div className="text-2xl text-green-700">Loading post...</div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-700 mb-4">Post Not Found</h1>
          <Link to="/blog" className="text-orange-600 hover:text-orange-700">
            â† Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      <QuickCategories language={language} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Back Button and Edit Button */}
        <div className="flex justify-between items-center mb-6">
          <Link
            to="/blog"
            className="inline-flex items-center text-orange-600 hover:text-orange-700"
          >
            â† {language === 'en' ? 'Back to Blog' : 'à®µà®²à¯ˆà®ªà¯à®ªà®¤à®¿à®µà¯à®•à¯à®•à¯ à®¤à®¿à®°à¯à®®à¯à®ªà¯'}
          </Link>

          {canEdit && post && (
            <Link
              to={`/admin?editPost=${post.slug}`}
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors shadow-md"
            >
              âœï¸ {language === 'en' ? 'Edit Post' : 'à®‡à®Ÿà¯à®•à¯ˆà®¯à¯ˆà®¤à¯ à®¤à®¿à®°à¯à®¤à¯à®¤à¯'}
            </Link>
          )}
        </div>

        {/* Post Header */}
        <article className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="flex justify-between items-start mb-4">
            <h1 className="text-4xl font-bold text-gray-900">{post.title}</h1>
          </div>

          <div className="flex items-center text-gray-600 text-sm mb-6 space-x-4">
            <span>
              ðŸ“… {new Date(post.published_at).toLocaleDateString(language === 'en' ? 'en-US' : 'ta-IN', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </span>
            {post.author && (
              <span>âœï¸ {post.author}</span>
            )}
            {post.comments && (
              <span>ðŸ’¬ {post.comments.length} {language === 'en' ? 'Comments' : 'à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯'}</span>
            )}
          </div>

          {/* Share Buttons - Top (Compact) */}
          <div className="mb-6 pb-4 border-b border-gray-200">
            <ShareButtons post={post} language={language} compact={true} />
          </div>

          {/* Post Content - cleaned of WordPress block comments */}
          <div
            className="prose prose-lg max-w-none blog-content"
            dangerouslySetInnerHTML={{ __html: cleanWordPressContent(post.content) }}
          />

          {/* Share Buttons - Bottom (Full Size) */}
          <div className="mt-8 pt-6 border-t-2 border-orange-200">
            <ShareButtons post={post} language={language} compact={false} />
          </div>

          <ReadNext currentSlug={slug} type="post" language={language} />
        </article>

        {/* Comments Section */}
        {post.comments && post.comments.length > 0 && (
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-green-800 mb-6">
              {language === 'en' ? 'Comments' : 'à®•à®°à¯à®¤à¯à®¤à¯à®•à¯à®•à®³à¯'} ({post.comments.length})
            </h2>

            <div className="space-y-6">
              {post.comments
                .filter(comment => comment.approved)
                .map((comment) => (
                  <div key={comment.id} className="border-b border-gray-200 pb-4">
                    <div className="flex items-start space-x-3">
                      <div className="flex-shrink-0">
                        <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                          {comment.author_name[0].toUpperCase()}
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center space-x-2 mb-1">
                          <span className="font-semibold text-gray-900">{comment.author_name}</span>
                          <span className="text-sm text-gray-500">
                            {new Date(comment.created_at).toLocaleDateString()}
                          </span>
                        </div>
                        <div
                          className="text-gray-700"
                          dangerouslySetInnerHTML={{ __html: comment.content }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* New Comment Section (using existing comment system) */}
        <CommentSection pageSlug={`blog-${post.slug}`} />
      </div>
    </div>
  );
};

// Protected Route for Admin
const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Give time to user to load from localStorage
    const timer = setTimeout(() => setIsChecking(false), 100);
    return () => clearTimeout(timer);
  }, [user]);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin-login.html" replace />;
  }

  if (user.role !== 'admin' && user.role !== 'moderator') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
          <p className="text-gray-600 mb-4">You need admin privileges to access this page.</p>
          <Link to="/" className="text-blue-600 hover:underline">â† Go back home</Link>
        </div>
      </div>
    );
  }

  return children;
};

// Route Wrappers to pass params
const PostEditorWrapper = () => {
  const { postId } = useParams();
  return <PostEditor postId={postId} />;
};

const PageEditorWrapper = () => {
  const { pageId } = useParams();
  return <PageEditor pageId={pageId} />;
};

// Routes Component with Auth Context

// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
// ðŸŒŸ EMBEDDED PANCHANGAM & SHASTRA PAGES (RENDERED INSIDE MAIN SITE FRAME)
// â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
const InteractivePanchangamEmbed = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full bg-white rounded-xl shadow-lg border border-amber-200 overflow-hidden my-3">
      <iframe
        src="/raw-panchangam.html"
        title="Sri Paranthaman Panchangam"
        style={{
          width: '100%',
          height: '1450px',
          minHeight: '88vh',
          border: 'none',
          display: 'block'
        }}
      />
    </div>
  );
};

const VarudadhiPalangalEmbed = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full bg-white rounded-xl shadow-lg border border-amber-200 overflow-hidden my-3">
      <iframe
        src="/raw-varudadhi.html"
        title="Varudadhi Palangal"
        style={{
          width: '100%',
          height: '1450px',
          minHeight: '88vh',
          border: 'none',
          display: 'block'
        }}
      />
    </div>
  );
};

const ShastraRulesEmbed = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full bg-white rounded-xl shadow-lg border border-amber-200 overflow-hidden my-3">
      <iframe
        src="/events-and-shastra-rules/index.html"
        title="Shastra Rules Decision Repository"
        style={{
          width: '100%',
          height: '1450px',
          minHeight: '88vh',
          border: 'none',
          display: 'block'
        }}
      />
    </div>
  );
};


const GlobalPanchangamEmbed = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full bg-white rounded-xl shadow-lg border border-amber-200 overflow-hidden my-3">
      <iframe
        src="/raw-global-panchangam.html"
        title="Global Drik Panchangam Engine"
        style={{
          width: '100%',
          height: '1450px',
          minHeight: '88vh',
          border: 'none',
          display: 'block'
        }}
      />
    </div>
  );
};

function AppRoutes() {
  const { language, user, fetchUser } = useAuth();

  console.log('ðŸ” AppRoutes rendering - user:', user, 'language:', language);

  return (
    <Routes>
      {/* Public Routes */}
      {/* Panchangam, Varudadhi & Shastra Routes embedded inside Master Layout */}
      <Route path="/global-panchangam" element={<GlobalPanchangamEmbed />} />
      <Route path="/panchangam/global" element={<GlobalPanchangamEmbed />} />
      <Route path="/Sri_Paranthaman_Global_Panchangam_Browser.html" element={<GlobalPanchangamEmbed />} />

      <Route path="/Sri_Paranthaman_Panchangam_Interactive_Browser.html" element={<InteractivePanchangamEmbed />} />
      <Route path="/panchangam-interactive.html" element={<InteractivePanchangamEmbed />} />
      <Route path="/panchangam/paranthaman-interactive" element={<InteractivePanchangamEmbed />} />
      <Route path="/panchangam/interactive" element={<InteractivePanchangamEmbed />} />
      <Route path="/varudadhi-palangal.html" element={<VarudadhiPalangalEmbed />} />
      <Route path="/varudadhi-palangal" element={<VarudadhiPalangalEmbed />} />
      <Route path="/events-and-shastra-rules" element={<ShastraRulesEmbed />} />
      <Route path="/events-and-shastra-rules/*" element={<ShastraRulesEmbed />} />
      <Route path="/Events-And-Shastra-Rules" element={<ShastraRulesEmbed />} />
      <Route path="/Events-And-Shastra-Rules/*" element={<ShastraRulesEmbed />} />


      <Route path="/rig-upakarma" element={<RigUpakarmaPage />} />
      <Route path="/yajur-upakarma" element={<YajurUpakarmaPage />} />
      <Route path="/sama-upakarma" element={<SamaUpakarmaPage />} />
      <Route path="/bodhayana-upakarma" element={<BodhayanaUpakarmaPage />} />
      <Route path="/gayathri-japam" element={<GayathriJapamPage />} />
      <Route path="/sathya-narayana-pooja" element={<SathyaNarayanaPooja />} />

      <Route path="/" element={<Home />} />
      <Route path="/welcome" element={<InstagramBioPage />} />
      <Route path="/instagram" element={<InstagramBioPage />} />
      <Route path="/bio" element={<InstagramBioPage />} />
      <Route path="/qa" element={<QAPage />} />
      <Route path="/qa/:id" element={<QAPage />} />
      <Route path="/qa/:id/:slug" element={<QAPage />} />
      <Route path="/forum" element={<ForumPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/vaideekam" element={<VaideekamPage />} />

      <Route path="/vaideekam/vaideeka-basics" element={<VaideekaBasicsPage />} />
      <Route path="/vaideekam/sthothrams" element={<SthothramsPage />} />
      <Route path="/vaideekam/model-invitations" element={<ModelInvitationsPage />} />
      <Route path="/vaideekam/shradhdham" element={<ShradhdhamPage />} />
      <Route path="/vaideekam/self-prepare" element={<SelfPreparePage />} />
      <Route path="/vaideekam/praathasandhi" element={<PraathasandhiPage />} />
      <Route path="/vaideekam/brahmayajgnam" element={<BrahmayajgnamPage />} />
      <Route path="/vaideekam/samidhadhanam" element={<SamidhadhanamPage />} />
      <Route path="/vaideekam/agnisanthanam" element={<AgnisanthanamPage />} />
      <Route path="/vaideekam/aupaasanam" element={<AupaasanamPage />} />
      <Route path="/vaideekam/upakarma" element={<UpakarmaPage />} />
      <Route path="/vaideekam/yajur-upakarma" element={<YajurUpakarmaPage />} />
      <Route path="/vaideekam/bodhayana-upakarma" element={<BodhayanaUpakarmaPage />} />
      <Route path="/vaideekam/rig-upakarma" element={<RigUpakarmaPage />} />
      <Route path="/vaideekam/sama-upakarma" element={<SamaUpakarmaPage />} />
      <Route path="/vaideekam/gayathrijapam" element={<GayathrijapamPage />} />
      <Route path="/vaideekam/aanmikam" element={<AanmikamPage />} />
      <Route path="/vaideekam/divyadesam" element={<DivyadesamPage />} />
      <Route path="/vaideekam/dharmakandam" element={<DharmakandamPage />} />
      <Route path="/vaideekam/ahnigam" element={<AhnigamPage />} />
      <Route path="/vaideekam/asoucham" element={<AsouchamPage />} />
      <Route path="/asoucham" element={<AsouchamPage />} />
      <Route path="/theetu" element={<AsouchamPage />} />
      <Route path="/panchangam/theetu" element={<AsouchamPage />} />
      <Route path="/janana-marana-theetu" element={<AsouchamPage />} />
      <Route path="/vaideekam/shradhakandam" element={<ShradhakandamPage />} />
      <Route path="/vaideekam/poorvam" element={<PoorvamPage />} />
      <Route path="/vaideekam/aksharaabhyaasam" element={<AksharaabhyaasamPage />} />
      <Route path="/vaideekam/aaseervadham" element={<AaseervadhamPage />} />
      <Route path="/vaideekam/ankuram" element={<AnkuramPage />} />
      <Route path="/vaideekam/annapraasanam" element={<AnnapraasanamPage />} />
      <Route path="/vaideekam/ashtavradham" element={<AshtavradhamPage />} />
      <Route path="/vaideekam/beeja-dhanam" element={<BeejaDhanamPage />} />
      <Route path="/vaideekam/grihapravesam" element={<GrihapravesamPage />} />
      <Route path="/vaideekam/jaadhakarma" element={<JaadhakarmaPage />} />
      <Route path="/vaideekam/kaaladhikramam" element={<KaaladhikramamPage />} />
      <Route path="/vaideekam/manai-muhurtham" element={<ManaiMuhurthamPage />} />
      <Route path="/vaideekam/naamakaranam" element={<NaamakaranamPage />} />
      <Route path="/vaideekam/naandhi" element={<NaandhiPage />} />
      <Route path="/vaideekam/nischayadhaartham" element={<NischayadhaarthamPage />} />
      <Route path="/vaideekam/pandalkaal" element={<PandalkaalPage />} />
      <Route path="/vaideekam/prashava-punyaaham" element={<PrashavaPunyaahamPage />} />
      <Route path="/vaideekam/prathisaram" element={<PrathisaramPage />} />
      <Route path="/vaideekam/pumsavanam" element={<PumsavanamPage />} />
      <Route path="/vaideekam/seemantham" element={<SeemanthamPage />} />
      <Route path="/vaideekam/udakasaandhi" element={<UdakasaandhiPage />} />
      <Route path="/vaideekam/upanayanam" element={<UpanayanamPage />} />
      <Route path="/vaideekam/vadhu-grihapravesam" element={<VadhuGrihapravesamPage />} />
      <Route path="/vaideekam/vivaaham" element={<VivaahamPage />} />
      <Route path="/vaideekam/yaathraa-dhaanam" element={<YaathraaDhaanamPage />} />
      <Route path="/vaideekam/aparam" element={<AparamPage />} />
      <Route path="/vaideekam/yajur-shradhdham" element={<YajurShradhdhamPage />} />
      <Route path="/vaideekam/yajur-tarpanam" element={<YajurTarpanamPage />} />

      <Route path="/vaidhikam/prayogams" element={<PrayogamsPage />} />
      <Route path="/vaideekam/prayogams" element={<PrayogamsPage />} />
      <Route path="/pracheena-qa" element={<PracheenaQAPage language={language} user={user} />} />
      <Route path="/mahalaya-shastra-qa" element={<MahalayaShastraQAPage user={user} />} />
      <Route path="/tarpanam-guide" element={<TarpanamGuidePage user={user} />} />
      <Route path="/divyadesams" element={<DivyadesamsDetailPage />} />
      <Route path="/divyadesams/:slug" element={<DivyadesamsDetailPage />} />
      <Route path="/divyadesa-namavali" element={<DivyadesamPage />} />
      <Route path="/anmikam/divyaprabandham" element={<DivyaprabandhamPage />} />
      <Route path="/anmikam/divyaprabandham/:slug" element={<DivyaprabandhamPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/shop" element={<ShopPage language={language} BACKEND_URL={API} />} />
      <Route path="/cart" element={<CartPage language={language} />} />
      <Route path="/checkout" element={<CheckoutPage language={language} />} />
      <Route path="/sitemap" element={<SitemapPage menuItems={MENU_ITEMS} language={language} />} />
      <Route path="/dharma-sastram" element={<DharmaSastramPage />} />
      <Route path="/karmangalin-thathuvangal" element={<KarmangalinThathuvangalPage />} />
      <Route path="/karmangalin-thathuvangal/:chapterSlug" element={<KarmangalinThathuvangalPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage language={language} />} />
      <Route path="/user-deletion" element={<UserDeletionPage language={language} />} />
      <Route path="/userdeletion" element={<UserDeletionPage language={language} />} />
      <Route path="/user-deletion.html" element={<UserDeletionPage language={language} />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/partner-registration" element={<PartnerRegistrationPage />} />
      <Route path="/request-personnel" element={<CustomerRequestPage />} />
      <Route path="/religious-services/shradhdha-service" element={<ShradhdhaServicePage language={language} />} />
      <Route path="/vaidhika-services" element={<VaidhikaServicesPage />} />
      <Route path="/services/vaidhikam" element={<VaidhikaServicesPage />} />
      <Route path="/dayvalue-premium" element={<PremiumRoute pageName="Day Value Premium"><div>Premium Content</div></PremiumRoute>} />
      <Route path="/premium-calendar" element={<PremiumRoute pageName="Premium Calendar"><div>Premium Calendar</div></PremiumRoute>} />
      <Route path="/donate" element={<DonatePage language={language} />} />
      <Route path="/services/marriage-garland" element={<MarriageGarlandPage language={language} />} />
      <Route path="/services/archanai" element={<ArchanaiPage language={language} />} />
      <Route path="/contact" element={<ContactPage language={language} />} />
      <Route path="/profile" element={<UserProfilePage language={language} user={user} refreshUser={fetchUser} />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/page/:slug" element={<CustomPage language={language} />} />
      <Route path="/live-panchangam" element={<CalendarPage />} />
      <Route path="/gen-sankalpam" element={<GenSankalpamPage />} />
      <Route path="/nazhi-convert" element={<NazhiConvertPage />} />
      <Route path="/all-about-stars" element={<AllAboutStarsPage />} />
      <Route path="/parts-of-panchangam" element={<PartsOfPanchangamPage />} />
      <Route path="/navagrahas" element={<NavagrahasPage />} />
      <Route path="/theetu" element={<TheetuPage />} />
      <Route path="/gen-theetu" element={<GenTheetuPage />} />
      <Route path="/marana-theetu" element={<MaranaTheetuPage />} />
      <Route path="/day-dhosha" element={<DayDhoshaPage />} />
      <Route path="/vivasayam" element={<VivasayamPage />} />
      <Route path="/matching" element={<MatchingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/allmuhurthams" element={<AllMuhurthamsPage />} />
      <Route path="/bestforevents" element={<BestForEventsPage />} />
      <Route path="/casting" element={<CastingPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/currentyear" element={<CurrentYearPage />} />
      <Route path="/dasabukthi" element={<DasaBukthiPage />} />
      <Route path="/dayvalue" element={<DayValuePage />} />
      <Route path="/dayvaluepremium" element={<DayValuePremiumPage />} />
      <Route path="/dhinaporutham" element={<DhinaPoruthamPage />} />
      <Route path="/diary" element={<DiaryPage />} />
      <Route path="/faqknowledgebase" element={<FaqKnowledgeBasePage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/fulloonamlist" element={<FullOonamListPage />} />
      <Route path="/gooddays" element={<GoodDaysPage />} />
      <Route path="/gowripanchangam" element={<GowriPanchangamPage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/horai" element={<HoraiPage />} />
      <Route path="/lagnas" element={<LagnasPage />} />
      <Route path="/localcalendar" element={<LocalCalendarPage />} />
      <Route path="/monthly" element={<MonthlyPage />} />
      <Route path="/monthview" element={<MonthViewPage />} />
      <Route path="/muhurthams" element={<MuhurthamsPage />} />
      <Route path="/mymuhurthams" element={<MyMuhurthamsPage />} />
      <Route path="/numerology" element={<NumerologyPage />} />
      <Route path="/oonams" element={<OonamsPage />} />
      <Route path="/panchangamnext" element={<PanchangamNextPage />} />
      <Route path="/panchangam" element={<PanchangamPage />} />
      <Route path="/placeholder" element={<PlaceholderPage />} />
      <Route path="/premiumcalendar" element={<PremiumCalendarPage />} />
      <Route path="/premiumstore" element={<PremiumStorePage />} />
      <Route path="/premium-store" element={<WebPremiumStorePage />} />
      <Route path="/premium-success" element={<PremiumSuccessPage />} />
      <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />
      <Route path="/sankalpam" element={<SankalpamPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/shraaddhathithi" element={<ShraaddhaThithiPage />} />
      <Route path="/staticdata" element={<StaticDataPage />} />
      <Route path="/thithinirnayarules" element={<ThithiNirnayaRulesPage />} />

      {/* ALL panchangam pages â€” native React components (NO iframe) */}
      {/* Day-to-day panchangam */}
      <Route path="/panchangam/panchangam" element={<CalendarPage />} />
      <Route path="/panchangam/calendar" element={<LocalCalendarPage />} />
      <Route path="/panchangam/month-view" element={<MonthViewPage />} />
      <Route path="/panchangam/monthly" element={<MonthlyPage />} />
      <Route path="/panchangam/monthview" element={<MonthViewPage />} />
      <Route path="/panchangam/gowri-panchangam" element={<GowriPanchangamPage />} />
      <Route path="/panchangam/gowripanchangam" element={<GowriPanchangamPage />} />
      <Route path="/panchangam/horai" element={<HoraiPage />} />
      <Route path="/panchangam/full-oonam-list" element={<FullOonamListPage />} />
      <Route path="/panchangam/fulloonamlist" element={<FullOonamListPage />} />
      <Route path="/panchangam/home" element={<HomePage />} />
      <Route path="/panchangam/currentyear" element={<CurrentYearPage />} />
      <Route path="/panchangam/panchangamnext" element={<PanchangamNextPage />} />

      {/* Knowledge base */}
      <Route path="/panchangam/parts-of-panchangam" element={<PartsOfPanchangamPage />} />
      <Route path="/panchangam/allaboutstars" element={<AllAboutStarsPage />} />
      <Route path="/panchangam/navagrahas" element={<NavagrahasPage />} />
      <Route path="/panchangam/lagnas" element={<LagnasPage />} />
      <Route path="/panchangam/numerology" element={<NumerologyPage />} />

      {/* Muhurthams */}
      <Route path="/panchangam/good-days" element={<GoodDaysPage />} />
      <Route path="/panchangam/gooddays" element={<GoodDaysPage />} />
      <Route path="/panchangam/best-for-events" element={<BestForEventsPage />} />
      <Route path="/panchangam/my-muhurthams" element={<MyMuhurthamsPage />} />
      <Route path="/panchangam/mymuhurthams" element={<MyMuhurthamsPage />} />
      <Route path="/panchangam/all-muhurthams" element={<AllMuhurthamsPage />} />
      <Route path="/panchangam/allmuhurthams" element={<AllMuhurthamsPage />} />
      <Route path="/panchangam/muhurthams" element={<MuhurthamsPage />} />
      <Route path="/panchangam/dhinaporutham" element={<DhinaPoruthamPage />} />

      {/* Vaideekam / Rituals */}
      <Route path="/panchangam/gen-sankalpam" element={<GenSankalpamPage />} />
      <Route path="/panchangam/shradhdha-thithi" element={<ShraaddhaThithiPage />} />
      <Route path="/panchangam/shradhdha-thithi-maker" element={<LoginRoute pageName="à®šà¯à®°à®¾à®¤à¯à®¤ à®¤à®¿à®¤à®¿ à®¨à®¿à®°à¯à®£à®¯à®®à¯"><ShraaddhaThithiMakerPage /></LoginRoute>} />
      <Route path="/panchangam/sankalpam" element={<SankalpamPage />} />
      <Route path="/panchangam/theetu" element={<TheetuPage />} />
      <Route path="/panchangam/gentheetu" element={<GenTheetuPage />} />
      <Route path="/panchangam/marana-theetu" element={<MaranaTheetuPage />} />
      <Route path="/panchangam/thithi-nirnaya-rules" element={<ThithiNirnayaRulesPage />} />
      <Route path="/panchangam/oonams" element={<OonamsPage />} />

      {/* Astrology / Premium */}
      <Route path="/panchangam/casting" element={<CastingPage />} />
      <Route path="/panchangam/matching" element={<MatchingPage />} />
      <Route path="/panchangam/dasabukthi" element={<DasaBukthiPage />} />
      <Route path="/panchangam/day-dhosha" element={<DayDhoshaPage />} />
      <Route path="/panchangam/dayvalue" element={<DayValuePage />} />
      <Route path="/panchangam/dayvalue-premium" element={<DayValuePremiumPage />} />
      <Route path="/panchangam/premium-calendar" element={<PremiumCalendarPage />} />

      {/* Tools & Utilities */}
      <Route path="/panchangam/nazhi-convert" element={<NazhiConvertPage />} />
      <Route path="/panchangam/vivasayam" element={<VivasayamPage />} />
      <Route path="/panchangam/diary" element={<DiaryPage />} />
      <Route path="/panchangam/search" element={<SearchPage />} />
      <Route path="/panchangam/dayvaluepremium" element={<DayValuePremiumPage />} />

      {/* Info & Meta pages */}
      <Route path="/panchangam/about" element={<AboutPage />} />
      <Route path="/panchangam/contact" element={<ContactPage language={language} />} />
      <Route path="/panchangam/feedback" element={<FeedbackPage />} />
      <Route path="/panchangam/faqknowledgebase" element={<FaqKnowledgeBasePage />} />
      <Route path="/panchangam/privacypolicy" element={<PrivacyPolicyPage />} />
      <Route path="/panchangam/staticdata" element={<StaticDataPage />} />
      <Route path="/panchangam/premiumstore" element={<PremiumStorePage />} />
      <Route path="/panchangam/placeholder" element={<PlaceholderPage />} />

      {/* Catch-all: any unmapped /panchangam/* path shows "Coming Soon" instead of iframe */}
      <Route path="/panchangam/:pageName" element={
        <div className="min-h-screen flex flex-col items-center justify-center bg-orange-50 p-4 text-center">
          <h1 className="text-3xl font-bold text-orange-600 mb-4">Page Not Found</h1>
          <div className="text-5xl mb-6">ðŸ”</div>
          <p className="text-lg text-gray-600 mb-8">This panchangam page is not available.<br />Please use the navigation menu above.</p>
          <Link to="/panchangam/panchangam" className="px-6 py-3 bg-green-700 text-white font-bold rounded-lg hover:bg-green-800 transition-colors">â† Go to Live Panchangam</Link>
        </div>
      } />

      {/* Shastra Library SEO Pages */}
      <Route path="/shastra-library" element={<ShastraLibraryPage />} />
      <Route path="/shastra-library/:topicSlug" element={<ShastraTopicDetailPage />} />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminRoute><AdminPanelWrapper /></AdminRoute>} />
      <Route path="/admin/posts" element={<AdminRoute><ManagePosts /></AdminRoute>} />
      <Route path="/admin/posts/new" element={<AdminRoute><PostEditorWrapper /></AdminRoute>} />
      <Route path="/admin/posts/edit/:postId" element={<AdminRoute><PostEditorWrapper /></AdminRoute>} />
      <Route path="/admin/pages" element={<AdminRoute><ManagePages /></AdminRoute>} />
      <Route path="/admin/pages/new" element={<AdminRoute><PageEditorWrapper /></AdminRoute>} />
      <Route path="/admin/pages/edit/:pageId" element={<AdminRoute><PageEditorWrapper /></AdminRoute>} />
      <Route path="/admin/comments" element={<AdminRoute><ModerateComments /></AdminRoute>} />
      <Route path="/admin/backup" element={<AdminRoute><BackupSystem /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><ManageUsers /></AdminRoute>} />
      {/* ============= Old URL Redirects (from visitor logs â€” legacy ASP.NET / WordPress / HTML pages) ============= */}
      <Route path="/Vaideekam/*" element={<Navigate to="/vaideekam" replace />} />
      <Route path="/Panjangam/*" element={<Navigate to="/panchangam/panchangam" replace />} />
      <Route path="/Divyadesams/*" element={<Navigate to="/divyadesams" replace />} />
      <Route path="/Default2.aspx" element={<Navigate to="/" replace />} />
      <Route path="/Default.aspx" element={<Navigate to="/" replace />} />
      <Route path="/downloads.aspx" element={<Navigate to="/shop" replace />} />
      <Route path="/event-calendar.htm" element={<Navigate to="/panchangam/calendar" replace />} />
      <Route path="/Vaid" element={<Navigate to="/vaideekam" replace />} />
      <Route path="/Vaid/*" element={<Navigate to="/vaideekam" replace />} />
      <Route path="/privacy-policy.txt" element={<Navigate to="/panchangam/privacypolicy" replace />} />
      <Route path="/blog/dharma/*" element={<Navigate to="/panchangam/theetu" replace />} />
      <Route path="/thirupullani-tour" element={<Navigate to="/divyadesams" replace />} />
      <Route path="/thirupullani-tour/*" element={<Navigate to="/divyadesams" replace />} />

      {/* Catch-all: Content Request Page for truly unknown URLs */}
      <Route path="*" element={<ContentRequestPage />} />
    </Routes>
  );
}

// Right Sidebar Component
const RightSidebar = () => {
  const { language, user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    services: false,
    account: true
  });
  const [hoveredSection, setHoveredSection] = useState(null);
  const [dynamicPages, setDynamicPages] = useState([]);
  const [dynamicPosts, setDynamicPosts] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  // Send analytics ping on route change
  useEffect(() => {
    const pingAnalytics = async () => {
      try {
        const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;
        await axios.post(`${API}/analytics/ping`, {
          page: location.pathname,
          is_admin: user && user.role === 'admin' ? true : false
        });
      } catch (err) {
        console.error('Analytics ping failed');
      }
    };
    pingAnalytics();
  }, [location, user]);

  // Close sidebar on mobile when navigating
  useEffect(() => {
    setIsOpen(false);
  }, [navigate]);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await axios.get(`${API}/blog/pages`);
        setDynamicPages(response.data.filter(p => p.published));
        const postsRes = await axios.get(`${API}/blog/posts?limit=5`);
        setDynamicPosts(postsRes.data.filter(p => p.published));
      } catch (error) {
        console.error('Error fetching pages for sidebar:', error);
      }
    };
    fetchPages();
  }, []);

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const menuSections = [
    {
      id: 'home',
      label_en: 'Home',
      label_ta: 'à®®à¯à®•à®ªà¯à®ªà¯',
      icon: 'ðŸ ',
      link: '/'
    },
    {
      id: 'blog',
      label_en: 'Blog',
      label_ta: 'à®µà®²à¯ˆà®ªà¯à®ªà®¤à®¿à®µà¯',
      icon: 'ðŸ“',
      link: '/blog'
    },
    {
      id: 'qa',
      label_en: 'Q&A Board',
      label_ta: 'à®•à¯‡à®³à¯à®µà®¿-à®ªà®¤à®¿à®²à¯',
      icon: 'â“',
      link: '/qa'
    },
    {
      id: 'vaideekam',
      label_en: 'Vedic Rituals',
      label_ta: 'à®µà¯ˆà®¤à¯€à®• à®•à®°à¯à®®à®¾',
      icon: 'ðŸ“¿',
      link: '/vaideekam',
      expandable: true,
      children: [
        { label_en: 'Vedic Rituals', label_ta: 'à®µà¯ˆà®¤à¯€à®• à®•à®°à¯à®®à®¾à®•à¯à®•à®³à¯', link: '/vaideekam' },
        { label_en: 'ðŸ“– Karmangalin Thathuvangal (28 Chapters)', label_ta: 'ðŸ“– à®•à®°à¯à®®à®¾à®•à¯à®•à®³à®¿à®©à¯ à®¤à®¤à¯à®¤à¯à®µà®™à¯à®•à®³à¯ (28 à®¤à®²à¯ˆà®ªà¯à®ªà¯à®•à®³à¯)', link: '/karmangalin-thathuvangal' },
        { label_en: 'ðŸ“– Dharma Sastram (701 Pages)', label_ta: 'ðŸ“– à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯ (701 à®ªà®•à¯à®•à®™à¯à®•à®³à¯)', link: '/dharma-sastram' },
        { label_en: 'ðŸ†• Pracheena QA', label_ta: 'ðŸ†• à®ªà¯à®°à®¾à®šà¯€à®© à®†à®šà®¾à®°à®®à¯', link: '/pracheena-qa' },
        { label_en: 'General Sankalpam', label_ta: 'à®ªà¯Šà®¤à¯ à®šà®™à¯à®•à®²à¯à®ªà®®à¯', link: '/panchangam/gen-sankalpam' },
        { label_en: 'Shradhdha Thithi', label_ta: 'à®¸à¯à®°à®¾à®¤à¯à®¤ à®¤à®¿à®¤à®¿', link: '/panchangam/shradhdha-thithi' },
        { label_en: 'Thithi Maker (Engine)', label_ta: 'à®¤à®¿à®¤à®¿ à®¨à®¿à®°à¯à®£à®¯à®®à¯ (Engine)', link: '/panchangam/shradhdha-thithi-maker' },
        { label_en: 'Tarpanam Sankalpam', label_ta: 'à®¤à®°à¯à®ªà¯à®ªà®£ à®šà®™à¯à®•à®²à¯à®ªà®®à¯', link: '/panchangam/sankalpam' },
        { label_en: 'Theetu Calculator', label_ta: 'à®¤à¯€à®Ÿà¯à®Ÿà¯ à®•à®£à®•à¯à®•à¯€à®Ÿà¯', link: '/panchangam/theetu' }
      ]
    },
    {
      id: 'anmikam',
      label_en: 'Anmikam',
      label_ta: 'à®†à®©à¯à®®à®¿à®•à®®à¯',
      icon: 'ðŸ›•',
      expandable: true,
      children: [
        { label_en: '108 Divyadesams', label_ta: '108 à®¤à®¿à®µà¯à®¯à®¤à¯‡à®šà®™à¯à®•à®³à¯', link: '/divyadesams' },
        { label_en: 'Sathya Narayana Pooja', label_ta: 'à®¸à®¤à¯à®¯ à®¨à®¾à®°à®¾à®¯à®£ à®ªà¯‚à®œà¯ˆ', link: '/sathya-narayana-pooja' },
        { label_en: 'Articles (Blog)', label_ta: 'à®•à®Ÿà¯à®Ÿà¯à®°à¯ˆà®•à®³à¯ (à®µà®²à¯ˆà®ªà¯à®ªà®¤à®¿à®µà¯)', link: '/blog' },
      ]
    },
    {
      id: 'panchangam',
      label_en: 'Live Panchangam',
      label_ta: 'à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯',
      icon: 'ðŸ“…',
      link: '/panchangam/panchangam',
      expandable: true,
      children: [
        { label_en: 'Live Panchangam', label_ta: 'à®‡à®©à¯à®±à¯ˆà®¯ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯', link: '/panchangam/panchangam' },
        { label_en: 'Calendar', label_ta: 'à®•à®¾à®²à®£à¯à®Ÿà®°à¯', link: '/panchangam/calendar' },
        { label_en: 'Monthly View', label_ta: 'à®®à®¾à®¤ à®•à®¾à®Ÿà¯à®Ÿà®¿', link: '/panchangam/month-view' },
        { label_en: 'Gowri Panchangam', label_ta: 'à®•à¯Œà®°à®¿ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯', link: '/panchangam/gowri-panchangam' },
        { label_en: 'Horai', label_ta: 'à®¹à¯‹à®°à¯ˆ', link: '/panchangam/horai' }
      ]
    },
    {
      id: 'dharma-sastram',
      label_en: 'ðŸ“– Dharma Sastram',
      label_ta: 'ðŸ“– à®¤à®°à¯à®® à®šà®¾à®¸à¯à®¤à®¿à®°à®®à¯',
      icon: 'ðŸ“š',
      link: '/dharma-sastram'
    },
    {
      id: 'services',
      label_en: 'Services',
      label_ta: 'à®šà¯‡à®µà¯ˆà®•à®³à¯',
      icon: 'ðŸ™',
      expandable: true,
      children: [
        { label_en: 'Marriage Garland', label_ta: 'à®¤à®¿à®°à¯à®®à®£ à®®à®¾à®²à¯ˆ', link: '/services/marriage-garland' },
        { label_en: 'Remote Archanai', label_ta: 'à®¤à¯Šà®²à¯ˆ à®…à®°à¯à®šà¯à®šà®©à¯ˆ', link: '/services/archanai' },
        { label_en: 'Shradhdha Service', label_ta: 'à®šà¯à®°à®¾à®¤à¯à®¤ à®šà¯‡à®µà¯ˆà®•à®³à¯', link: '/religious-services/shradhdha-service' },
        { label_en: 'Vaideeka Registration', label_ta: 'à®µà¯ˆà®¤à¯€à®•à®ªà¯ à®ªà®£à®¿à®¯à®¾à®³à®°à¯ à®ªà®¤à®¿à®µà¯', link: '/partner-registration' },
        { label_en: 'Request Personnel', label_ta: 'à®µà¯ˆà®¤à¯€à®•à®ªà¯ à®ªà®£à®¿à®¯à®¾à®³à®°à¯à®•à®³à¯ à®¤à¯‡à®µà¯ˆ', link: '/request-personnel' },
        { label_en: 'All Services', label_ta: 'à®…à®©à¯ˆà®¤à¯à®¤à¯ à®šà¯‡à®µà¯ˆà®•à®³à¯', link: '/services' }
      ]
    },
    {
      id: 'shop',
      label_en: 'Shop',
      label_ta: 'à®•à®Ÿà¯ˆ',
      icon: 'ðŸ›’',
      link: '/shop'
    },
    {
      id: 'utility',
      label_en: 'Utility',
      label_ta: 'à®•à®°à¯à®µà®¿à®•à®³à¯',
      icon: 'ðŸ§°',
      expandable: true,
      children: [
        { label_en: 'Search', label_ta: 'à®¤à¯‡à®Ÿà®²à¯', link: '/panchangam/search' },
        { label_en: 'Diary', label_ta: 'à®Ÿà®¯à®°à®¿', link: '/panchangam/diary' },
        { label_en: 'Tools / Nazhi Convert', label_ta: 'à®•à®°à¯à®µà®¿à®•à®³à¯ / à®¨à®¾à®´à®¿ à®®à®¾à®±à¯à®±à®¿', link: '/panchangam/nazhi-convert' },
        { label_en: 'Current Year', label_ta: 'à®¨à®Ÿà®ªà¯à®ªà¯ à®µà®°à¯à®Ÿà®®à¯', link: '/panchangam/currentyear' },
      ]
    },
    {
      id: 'contact',
      label_en: 'Contact',
      label_ta: 'à®¤à¯Šà®Ÿà®°à¯à®ªà¯',
      icon: 'ðŸ“ž',
      link: '/contact'
    }
  ];

  const accountSection = {
    id: 'account',
    label_en: 'My Account',
    label_ta: 'à®Žà®©à¯ à®•à®£à®•à¯à®•à¯',
    icon: 'ðŸ‘¤',
    expandable: true,
    children: [
      { label_en: 'Profile', label_ta: 'à®šà¯à®¯à®µà®¿à®µà®°à®®à¯', link: '/profile', icon: 'ðŸ‘¤' },
      ...(user && (user.role === 'admin' || user.role === 'moderator')
        ? [{ label_en: 'Admin Panel', label_ta: 'à®¨à®¿à®°à¯à®µà®¾à®• à®ªà¯‡à®©à®²à¯', link: '/admin', icon: 'âš™ï¸' }]
        : []
      ),
      { label_en: 'Logout', label_ta: 'à®µà¯†à®³à®¿à®¯à¯‡à®±à¯', action: 'logout', icon: 'ðŸšª' }
    ]
  };

  return (
    <>
      {/* Sidebar Toggle Button (Hidden on sm screens since sidebar is permanent) */}
      <div className={`fixed top-1/2 -translate-y-1/2 z-50 transition-all duration-300 ${isOpen ? 'left-64' : 'left-0'} sm:hidden`}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-orange-600 text-white p-2 rounded-r-md shadow-lg flex items-center justify-center focus:outline-none hover:bg-orange-700"
          title={isOpen ? "Close Menu" : "Open Menu"}
        >
          {isOpen ? 'â—€' : 'â–¶'}
        </button>
      </div>

      {/* Backdrop Overlay (Hidden on sm screens) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 sm:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar â€” permanent on sm screens, overlay on mobile */}
      <aside className={`fixed sm:sticky left-0 top-16 h-[calc(100vh-4rem)] w-64 bg-gradient-to-b from-green-50 to-orange-50 border-r-4 border-orange-600 shadow-xl overflow-y-auto z-40 transition-transform duration-300 ease-in-out sm:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-4">
          <h3 className="text-sm font-bold text-green-800 mb-4 border-b-2 border-green-600 pb-2">
            {language === 'en' ? 'Navigation Menu' : 'à®µà®´à®¿à®šà¯†à®²à¯à®¤à¯à®¤à®²à¯ à®ªà®Ÿà¯à®Ÿà®¿à®¯à®²à¯'}
          </h3>

          {/* Main Menu */}
          <nav className="space-y-1">
            {menuSections.map((item) => (
              <div
                key={item.id}
                className="relative"
                onMouseEnter={() => setHoveredSection(item.id)}
                onMouseLeave={() => setHoveredSection(null)}
              >
                {item.expandable ? (
                  <>
                    <button
                      onClick={() => toggleSection(item.id)}
                      className="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-gray-700 hover:bg-green-100 rounded transition-colors"
                    >
                      <span className="flex items-center space-x-2">
                        <span>{item.icon}</span>
                        <span>{language === 'en' ? item.label_en : item.label_ta}</span>
                      </span>
                      <span className="text-xs">{expandedSections[item.id] ? 'â–¼' : 'â–º'}</span>
                    </button>

                    {/* Accordion Sub-Menu */}
                    {expandedSections[item.id] && (
                      <div className="ml-6 mt-1 space-y-1 bg-white/60 p-2 rounded-lg border border-green-200">
                        {item.children.map((child, idx) => (
                          <Link
                            key={idx}
                            to={child.link}
                            onClick={() => setIsOpen(false)}
                            className="block px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-orange-100 hover:text-orange-800 rounded transition-colors"
                          >
                            â€¢ {language === 'en' ? child.label_en : child.label_ta}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.link}
                    onClick={() => setIsOpen(false)}
                    className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-green-100 rounded transition-colors"
                  >
                    <span>{item.icon}</span>
                    <span>{language === 'en' ? item.label_en : item.label_ta}</span>
                  </Link>
                )}
              </div>
            ))}

            {/* Recent Posts */}
            {dynamicPosts.length > 0 && (
              <div className="mt-4 pt-4 border-t border-green-200">
                <h4 className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                  {language === 'en' ? 'Recent Posts' : 'à®šà®®à¯€à®ªà®¤à¯à®¤à®¿à®¯ à®ªà®¤à®¿à®µà¯à®•à®³à¯'}
                </h4>
                {dynamicPosts.map(post => (
                  <Link
                    key={post.id}
                    to={`/blog/post/${post.slug}`}
                    className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-green-100 rounded transition-colors"
                  >
                    <span>ðŸ“</span>
                    <span className="truncate">{language === 'en' ? post.title_en : post.title_ta}</span>
                  </Link>
                ))}
              </div>
            )}

            {/* Dynamic Custom Pages */}
            {dynamicPages.length > 0 && (
              <div className="mt-4 pt-4 border-t border-green-200">
                <h4 className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                  {language === 'en' ? 'Pages' : 'à®ªà®•à¯à®•à®™à¯à®•à®³à¯'}
                </h4>
                {dynamicPages.map(page => (
                  <Link
                    key={page.id}
                    to={`/page/${page.slug}`}
                    className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-green-100 rounded transition-colors"
                  >
                    <span>ðŸ“„</span>
                    <span className="truncate">{page.title}</span>
                  </Link>
                ))}
              </div>
            )}
          </nav>

          {/* Account Section (only if logged in) */}
          {user && (
            <div className="mt-6 pt-4 border-t-2 border-orange-400">
              <button
                onClick={() => toggleSection('account')}
                className="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-green-800 bg-green-100 rounded transition-colors"
              >
                <span className="flex items-center space-x-2">
                  <span>{accountSection.icon}</span>
                  <span>{language === 'en' ? accountSection.label_en : accountSection.label_ta}</span>
                </span>
                <span className="text-xs">{expandedSections.account ? 'â–¼' : 'â–º'}</span>
              </button>
              {expandedSections.account && (
                <div className="ml-6 mt-1 space-y-1">
                  {accountSection.children.map((child, idx) => (
                    child.action === 'logout' ? (
                      <button
                        key={idx}
                        onClick={logout}
                        className="w-full text-left px-3 py-1.5 text-xs text-red-600 hover:bg-red-100 rounded transition-colors flex items-center space-x-1"
                      >
                        <span>{child.icon}</span>
                        <span>{language === 'en' ? child.label_en : child.label_ta}</span>
                      </button>
                    ) : (
                      <Link
                        key={idx}
                        to={child.link}
                        className="block px-3 py-1.5 text-xs text-gray-600 hover:bg-orange-100 hover:text-orange-700 rounded transition-colors flex items-center space-x-1"
                      >
                        <span>{child.icon}</span>
                        <span>{language === 'en' ? child.label_en : child.label_ta}</span>
                      </Link>
                    )
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

// Unauthenticated Floating Login Modal â€” appears 3.5 minutes (210,000ms) after browsing if user is not logged in
const UnauthFloatingLoginModal = () => {
  const { user, language } = useAuth();
  const location = useLocation();
  const [showFloat, setShowFloat] = useState(false);
  const timerRef = useRef(null);

  const handleClose = () => {
    setShowFloat(false);
    try {
      sessionStorage.setItem('dismissed_auth_modal', Date.now().toString());
    } catch (e) {}
  };

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setShowFloat(false);

    if (!user) {
      // Check if user already dismissed it in this session recently
      const lastDismissed = sessionStorage.getItem('dismissed_auth_modal');
      if (lastDismissed) {
        const timePassed = Date.now() - parseInt(lastDismissed, 10);
        if (timePassed < 600000) { // Don't show again for 10 minutes if dismissed
          return;
        }
      }

      timerRef.current = setTimeout(() => {
        setShowFloat(true);
      }, 210000); // 3.5 minutes (210,000 ms) after browsing
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location.pathname, user]);

  if (!showFloat || user) return null;

  return (
    <div style={{ backgroundColor: 'rgba(26, 35, 126, 0.75)' }} className="fixed inset-0 z-[9999] flex items-center justify-center p-3 backdrop-blur-sm animate-fade-in">
      <div style={{ backgroundColor: '#FAF6EE', borderColor: '#CC6600' }} className="rounded-xl shadow-2xl p-4 max-w-xs sm:max-w-sm w-full text-center border-2 relative">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-lg font-bold p-1 cursor-pointer"
          title="Close"
        >
          âœ•
        </button>
        <div className="text-2xl mb-1">ðŸ”’</div>
        <h3 style={{ color: '#1A237E' }} className="text-base font-bold mb-1">
          {language === 'ta' ? 'à®‰à®³à¯à®¨à¯à®´à¯ˆà®µà¯ / à®ªà®¤à®¿à®µà¯ à®¤à¯‡à®µà¯ˆ' : 'Login / Register Required'}
        </h3>
        <p style={{ color: '#2C1D11' }} className="text-xs mb-3 leading-snug">
          {language === 'ta'
            ? 'à®¤à¯Šà®Ÿà®°à¯à®¨à¯à®¤à¯ Ahobilam.com à®šà¯‡à®µà¯ˆà®•à®³à¯ à®®à®±à¯à®±à¯à®®à¯ à®ªà®•à¯à®•à®™à¯à®•à®³à¯ˆà®ªà¯ à®ªà®¯à®©à¯à®ªà®Ÿà¯à®¤à¯à®¤ à®¤à®¯à®µà¯à®šà¯†à®¯à¯à®¤à¯ à®‰à®³à¯à®¨à¯à®´à¯ˆà®¯à®µà¯à®®à¯ à®…à®²à¯à®²à®¤à¯ à®ªà®¤à®¿à®µà¯ à®šà¯†à®¯à¯à®¯à®µà¯à®®à¯.'
            : 'Please log in or register to continue reading articles and accessing Ahobilam.com services.'}
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={() => {
              handleClose();
              window.dispatchEvent(new CustomEvent('open-auth-modal'));
            }}
            style={{ background: 'linear-gradient(135deg, #E65100 0%, #1B5E20 100%)' }}
            className="w-full py-2 px-3 text-white rounded-lg font-bold text-xs shadow hover:opacity-95 transition-all cursor-pointer flex items-center justify-center gap-1.5"
          >
            ðŸ”‘ {language === 'ta' ? 'à®‰à®³à¯à®¨à¯à®´à¯ˆà®µà¯ / à®ªà¯à®¤à®¿à®¯ à®•à®£à®•à¯à®•à¯' : 'Log In / Register Now'}
          </button>
          <button
            onClick={handleClose}
            style={{ backgroundColor: '#F5EDDA', color: '#1A237E', border: '1px solid #D4AF37' }}
            className="w-full py-1.5 rounded-lg text-xs font-bold hover:bg-amber-100 cursor-pointer"
          >
            {language === 'ta' ? 'à®¤à®±à¯à®•à®¾à®²à®¿à®•à®®à®¾à®• à®®à¯‚à®Ÿà¯' : 'Close for now'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Inner Layout Component to use hooks
const MainLayout = () => {
  const location = useLocation();
  const isPanchangam = location.pathname.startsWith('/panchangam') || location.pathname === '/live-panchangam';
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <SEO />
      <Navigation />
      <UnauthFloatingLoginModal />
      {!isAdmin && <FloatingShare />}
      <div className="flex flex-grow">
        <RightSidebar />
        <main className="flex-grow w-full flex flex-col overflow-x-hidden px-[15px]">
          <div className="flex-grow">
            <AppRoutes />
          </div>
          <div className="w-full bg-white px-4 py-2 mt-auto">
            <div className="w-full mx-auto">
              <SocialShare />
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

// Error Boundary â€” catches React component crashes and shows recovery page
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error('âš ï¸ React Error Boundary caught:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%)', padding: '20px'
        }}>
          <div style={{
            maxWidth: '420px', width: '100%', background: 'white', borderRadius: '16px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)', padding: '40px', textAlign: 'center',
            borderTop: '4px solid #ea580c'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>ðŸ™</div>
            <h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#c2410c', marginBottom: '12px' }}>
              Oops! Something went wrong
            </h2>
            <p style={{ color: '#78716c', fontSize: '14px', lineHeight: '1.6', marginBottom: '8px' }}>
              The page could not be loaded. This may be because your session has expired or there was a temporary issue.
            </p>
            <p style={{ color: '#a8a29e', fontSize: '12px', marginBottom: '24px' }}>
              Please go to the Home page and try again.
            </p>
            <a href="/" style={{
              display: 'inline-block', padding: '12px 32px', background: 'linear-gradient(135deg, #ea580c, #16a34a)',
              color: 'white', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold', fontSize: '15px'
            }}>ðŸ  Go to Home Page</a>
            <div style={{ marginTop: '16px' }}>
              <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
                style={{
                  background: 'none', border: '1px solid #d6d3d1', padding: '8px 20px',
                  borderRadius: '6px', color: '#78716c', cursor: 'pointer', fontSize: '13px'
                }}>
                ðŸ”„ Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// Session Expired Banner â€” shows at top of page when token expires
const SessionBanner = () => {
  const { sessionMessage, setSessionMessage } = useAuth();
  if (!sessionMessage) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: 'linear-gradient(135deg, #fbbf24, #f59e0b)', color: '#78350f',
      padding: '12px 20px', textAlign: 'center', fontSize: '14px', fontWeight: '600',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)', display: 'flex', alignItems: 'center',
      justifyContent: 'center', gap: '12px'
    }}>
      <span>âš ï¸ {sessionMessage}</span>
      <a href="/" style={{
        color: '#fff', background: '#ea580c', padding: '4px 16px',
        borderRadius: '6px', textDecoration: 'none', fontSize: '13px', fontWeight: 'bold'
      }}>Log In</a>
      <button onClick={() => setSessionMessage(null)} style={{
        background: 'none', border: 'none',
        color: '#78350f', cursor: 'pointer', fontSize: '18px', padding: '0 4px'
      }}>âœ•</button>
    </div>
  );
};

// Mobile Bottom Sticky Registration Bar â€” fixed at bottom for instant 1-tap mobile sign up
const MobileStickyRegBar = () => {
  const { user, language } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isLogin, setIsLogin] = useState(false);

  if (user) return null;

  return (
    <>
      <div 
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-amber-800 via-orange-900 to-amber-900 text-amber-100 px-3 py-2 border-t-2 border-[#D4AF37] shadow-2xl flex items-center justify-between"
        style={{ backdropFilter: 'blur(8px)' }}
      >
        <div className="flex items-center gap-1.5 overflow-hidden">
          <span className="text-base animate-bounce">âœ¨</span>
          <div className="text-[11px] font-bold leading-tight truncate">
            <span>{language === 'en' ? 'Daily Panchangam & Shastra Alerts' : 'à®¤à®¿à®©à®šà®°à®¿ à®ªà®žà¯à®šà®¾à®™à¯à®•à®®à¯ à®…à®±à®¿à®µà®¿à®ªà¯à®ªà¯à®•à®³à¯'}</span>
          </div>
        </div>
        <button
          onClick={() => setShowAuthModal(true)}
          className="px-3 py-1.5 bg-[#D4AF37] hover:bg-amber-400 text-[#1A237E] font-extrabold text-xs rounded-full shadow-lg border border-amber-200 whitespace-nowrap flex items-center gap-1 transition-all transform active:scale-95"
        >
          <span>ðŸ”‘</span>
          <span>{language === 'en' ? 'Free Register' : 'à®‡à®²à®µà®š à®ªà®¤à®¿à®µà¯'}</span>
        </button>
      </div>

      {showAuthModal && (
        <AuthModal
          isOpen={showAuthModal}
          onClose={() => setShowAuthModal(false)}
          isLogin={isLogin}
          setIsLogin={setIsLogin}
        />
      )}
    </>
  );
};

// Main App Component
function App() {
  return (
    <GoogleOAuthProvider clientId="129082435656-1frrbao2fpift5mkqolnlhiomrlkuhma.apps.googleusercontent.com">
      <AuthProvider>
        <MonetizationProvider>
          <WalletProvider>
            <EditModeProvider>
              <BrowserRouter>
                <ErrorBoundary>
                  <SessionBanner />
                  <VaideekaDictionaryPopup />
                  <MainLayout />
                  <FloatingChat />
                  <MobileStickyRegBar />
                </ErrorBoundary>
              </BrowserRouter>
            </EditModeProvider>
          </WalletProvider>
        </MonetizationProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
